export const QUESTIONS = [
    {
       "id":1375,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Any agent is prohibited from using material insider information in in which of the following scenarios?",
       "choice_a":"To execute any securities transactions based on this information",
       "choice_b":"To make any recommendations to either buy or sell based on this information",
       "choice_c":"To transmit the material insider information to anyone who might trade a security based on this information",
       "choice_d":"All of the ways listed",
       "correct_answer":"D",
       "explanation":"Any agent is prohibited from using material insider information to execute any securities transactions based on this information, to make any recommendations to either buy or sell based on this information, or to transmit the material insider information to anyone who might trade a security based on this information."
    },
    {
       "id":1376,
       "topic_id":1,
       "practice_test_id":"",
       "question":"As it relates to a member firm conducting business with the public, all of the following are violations except:",
       "choice_a":"Stating that a new issue has been approved for sale by the SEC",
       "choice_b":"Printing \u0022FINRA\u0022 in large type on business cards",
       "choice_c":"Charging a customer a larger than normal commission for executing a specific order",
       "choice_d":"Failing to execute a customer\u0027s order for a speculative security",
       "correct_answer":"C",
       "explanation":"A member firm may charge a customer a larger than ordinary commission for the execution of a specific order so long as it is disclosed to the customer. A member firm must always execute a customer's order."
    },
    {
       "id":1377,
       "topic_id":1,
       "practice_test_id":"",
       "question":"As it relates to the performance based compensation of an adviser, which is true?",
       "choice_a":"It may be accepted by an advisor of individual investors only",
       "choice_b":"It may be charged by a private investment company",
       "choice_c":"It is strictly prohibited in under all circumstances",
       "choice_d":"It is only allowed if the clients are limited to accredited investors",
       "correct_answer":"B",
       "explanation":"Performance based compensation is only allowed to be charged by a private investment company."
    },
    {
       "id":1378,
       "topic_id":1,
       "practice_test_id":"",
       "question":"As it relates to the Uniform Securities Act, which of the following are violations? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Selling dividends </li><li>Selling rights  </li><li>Offering rescission to a client based on a fall in market price </li><li>Selling preferred stock to the account of an investor seeking growth </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Selling a right is not a violation. All of the other choices listed are a violation of the USA."
    },
    {
       "id":1379,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Awards under arbitration must be paid:",
       "choice_a":"Immediately",
       "choice_b":"Within 90 days",
       "choice_c":"Within 60 days",
       "choice_d":"Within 30 days",
       "correct_answer":"D",
       "explanation":"Awards under arbitration must be paid in 30 days."
    },
    {
       "id":1380,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Creating false activity in a security to attract new purchaser is a fraudulent practice known as:",
       "choice_a":"Painting the tape",
       "choice_b":"Trading ahead",
       "choice_c":"Front running",
       "choice_d":"Active concealment",
       "correct_answer":"A",
       "explanation":"This is known as painting the tape, matched purchases, or matched sales."
    },
    {
       "id":1381,
       "topic_id":1,
       "practice_test_id":3,
       "question":"During a new issue registration, false information is included in the prospectus to buyers.  Which of the following may be held liable to investors? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Officers of the issuer </li><li> Accountants </li><li>Syndicate members </li><li>People who signed the registration statement </li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the parties listed may be held liable to the purchasers of the new issue."
    },
    {
       "id":1382,
       "topic_id":1,
       "practice_test_id":4,
       "question":"During the sale of a security, the agent may say which of the following to his client?",
       "choice_a":"This security is registered and fully approved by both the state and the SEC, and therefore it is a safe investment",
       "choice_b":"As a registered agent, I am fully approved by both the state and the SEC, and therefore I am a good choice of people for you to invest with",
       "choice_c":"There is always risk involved with a securities investment, but let\u0027s examine its past performance and earnings as well as its future earnings projection to discover how heavy the risk seems to be",
       "choice_d":"This security is fully regulated by securities industry authorities, and therefore it is a very safe investment",
       "correct_answer":"C",
       "explanation":"An agent may not state that a security is approved, that he is approved, or that an investment is safe because it is regulated by the securities industry; the correct statement above is an honest and ethical approach to a client."
    },
    {
       "id":1383,
       "topic_id":1,
       "practice_test_id":5,
       "question":"Encouraging an investor to purchase a mutual fund share just prior to its ex dividend date is known as:",
       "choice_a":"Break point sales",
       "choice_b":"An enticement",
       "choice_c":"Selling dividends",
       "choice_d":"An appropriate strategy known as dividend capture",
       "correct_answer":"C",
       "explanation":"Selling dividends is a violation.  The representative uses the pending dividend as an enticement to get the customer to make the purchase."
    },
    {
       "id":1384,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Every FINRA member must ensure against employee dishonesty.  In order to protect the investing public each firm must post:",
       "choice_a":"A surety bond",
       "choice_b":"A blanket bond",
       "choice_c":"Escrow",
       "choice_d":"A fidelity bond",
       "correct_answer":"D",
       "explanation":"A fidelity bond ensures against employee dishonesty."
    },
    {
       "id":1385,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Full disclosure of all known material information includes all of the following except:",
       "choice_a":"Giving positive as well as negative information about an investment",
       "choice_b":"Being careful not to offer opinions as material facts",
       "choice_c":"Being certain that a client receives all essential facts known so he can make an informed investment decision",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Full disclosure of all known material information includes giving positive as well as negative information about an investment, being careful not to offer opinions as material facts, and being certain that a client receives all essential facts known so he can make an informed investment decision."
    },
    {
       "id":1386,
       "topic_id":1,
       "practice_test_id":"",
       "question":"If FINRA finds that a member has violated the rules regarding fair advertising, FINRA may require the member to:",
       "choice_a":"File the proposed ads 45 days prior to its first use",
       "choice_b":"File the proposed ads 30 days prior to its first use",
       "choice_c":"File the proposed ad 10 days prior to its first use",
       "choice_d":"File the proposed ad 90 days prior to its first use",
       "correct_answer":"C",
       "explanation":"If FINRA has found the member's advertisements to be in violation of the rules of fair practice, they may require the member to file the ads 10 days before they are used."
    },
    {
       "id":1387,
       "topic_id":1,
       "practice_test_id":"",
       "question":"In order for a representative to join a new firm, the old member must fill out and submit a:",
       "choice_a":"U-4",
       "choice_b":"U-5",
       "choice_c":"U-6",
       "choice_d":"Uniform registration transfer",
       "correct_answer":"B",
       "explanation":"In order to terminate a representative's association with a member, that member must fill out and submit a U-5 to the FINRA."
    },
    {
       "id":1388,
       "topic_id":1,
       "practice_test_id":"",
       "question":"In order for a retired agent to continue to receive commission on the book of business they have built over their career, they must have:",
       "choice_a":"The approval of FINRA",
       "choice_b":"The approval of their SRO",
       "choice_c":"A contract",
       "choice_d":"A no compete clause",
       "correct_answer":"C",
       "explanation":"In order for a retired representative to continue to receive commissions on their book of business, they must have a contract."
    },
    {
       "id":1389,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Investment adviser representatives may not:",
       "choice_a":"Give advice for an hourly fee",
       "choice_b":"Call themselves a Registered Investment Adviser",
       "choice_c":"Receive compensation and commissions",
       "choice_d":"Perform technical analysis as the sole basis for recommending an investment",
       "correct_answer":"B",
       "explanation":"Investment adviser representatives  may not call themselves Registered Investment Advisers. The firm not the IAR is the RIA."
    },
    {
       "id":1390,
       "topic_id":1,
       "practice_test_id":"",
       "question":"It is deemed to be unethical for a broker dealer to: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Hypothecate a customer's securities without a lien </li><li>Charge a customer a larger commission for the execution of a limit order </li><li>Charge a fee for the collection of interest payments </li><li>Lend a customer's fully paid for securities with no loan agreement</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"A broker dealer may not pledge the customer's securities without a having a lien on the securities and they may not lend a customer's securities without having a loan consent agreement signed by the customer."
    },
    {
       "id":1391,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Joint accounts are allowed in all of the following except:",
       "choice_a":"A registered representative and a customer",
       "choice_b":"A registered representative and a spouse",
       "choice_c":"A registered representative and a friend",
       "choice_d":"A registered representative and their 16-year-old-child",
       "correct_answer":"D",
       "explanation":"An adult may never have a joint account with a minor."
    },
    {
       "id":1392,
       "topic_id":1,
       "practice_test_id":"",
       "question":"List the following sanctions in order from the most lenient to the most severe: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Expelled </li><li>Barred </li><li> Suspended </li><li>Censure </li></ol>",
       "choice_a":"IV, III, I, II",
       "choice_b":"III, IV, II, I",
       "choice_c":"III, IV, I, II",
       "choice_d":"IV, I, III, II",
       "correct_answer":"A",
       "explanation":"Censure is the most lenient while a bar is the most severe. An agent who has been barred will be barred for life. An agent may be expelled for up to 10 years. An agent who is suspended may be suspended for up to 1 year."
    },
    {
       "id":1393,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Mrs. Hill assures her agent and broker dealer that they may invest her money in a particular security even though it is not registered in her state and that she will sign a letter approving the transaction and stating that she will hold the agent and the firm harmless. This is:",
       "choice_a":"Valid only in an arbitration",
       "choice_b":"Valid only at that the state level",
       "choice_c":"Valid in arbitration and at the state level",
       "choice_d":"Valid in no circumstances",
       "correct_answer":"D",
       "explanation":"This type of authorization is not valid in any circumstances. The customer may not agree to waive their rights under the USA."
    },
    {
       "id":1394,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Prior to official arbitration proceedings, both parties may agree to try to resolve the dispute through:",
       "choice_a":"Mediation",
       "choice_b":"Intervention",
       "choice_c":"AWAC",
       "choice_d":"Subordination",
       "correct_answer":"A",
       "explanation":"Both parties may agree to try to resolve the dispute through mediation."
    },
    {
       "id":1395,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Regulation T is controlled by:",
       "choice_a":"Securities Exchange Commission",
       "choice_b":"NYSE",
       "choice_c":"FINRA",
       "choice_d":"FRB",
       "correct_answer":"D",
       "explanation":"The Federal Reserve board controls the extension of credit for securities purchases under Regulation T."
    },
    {
       "id":1396,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Sanctions imposed by FINRA are effective within how many days of a written decision?",
       "choice_a":"15 days",
       "choice_b":"45 days",
       "choice_c":"60 days",
       "choice_d":"30 days",
       "correct_answer":"D",
       "explanation":"The decisions are final after 30 days"
    },
    {
       "id":1397,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Simplified arbitration is available between two broker dealers for amounts up to:",
       "choice_a":"$25,000",
       "choice_b":"$30,000",
       "choice_c":"$10,000",
       "choice_d":"$50,000",
       "correct_answer":"D",
       "explanation":"Simplified arbitration between two broker dealers is available for disputes up to $50,000."
    },
    {
       "id":1398,
       "topic_id":1,
       "practice_test_id":"",
       "question":"SIPC covers customer's accounts in case of broker dealer failure and the accounts are covered up to:",
       "choice_a":"$500,000 total",
       "choice_b":"$500,000 per person",
       "choice_c":"$500,000 total per separate customer",
       "choice_d":"$500,000 per customer, of which up to $250,000 may be in cash",
       "correct_answer":"D",
       "explanation":"SIPC covers customer accounts for amounts up to $500,000, of which up to $250,000 may be in cash."
    },
    {
       "id":1399,
       "topic_id":1,
       "practice_test_id":1,
       "question":"The act that gave the NASD (now part of FINRA) the authority to regulate the over the counter market is:",
       "choice_a":"The NASD act of 1929",
       "choice_b":"The Securities Act of 1933",
       "choice_c":"The securities Act of 1934",
       "choice_d":"The Maloney Act of 1938",
       "correct_answer":"D",
       "explanation":"The Maloney Act of 1938 was an amendment to the Securities Exchange Act of 1934 and established the NASD as the Self Regulatory Organization for the over the counter market."
    },
    {
       "id":1400,
       "topic_id":1,
       "practice_test_id":2,
       "question":"The act that requires broker dealers to maintain a certain amount of net capital is:",
       "choice_a":"The Securities Act of 1933",
       "choice_b":"The Securities Act of 1934",
       "choice_c":"The Financial Responsibility Act of 1937",
       "choice_d":"The Maloney Act of 1938",
       "correct_answer":"B",
       "explanation":"The Securities Exchange Act of 1934 requires that brokerages maintain a minimum net capital."
    },
    {
       "id":1401,
       "topic_id":1,
       "practice_test_id":3,
       "question":"The best way to determine if an investment suits a particular investor is to:",
       "choice_a":"Ask the client questions about his investment objectives",
       "choice_b":"Ask the client questions about his tolerance for risk",
       "choice_c":"Ask the client questions about his investment experience",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The best way to handle a client is to ask questions and listen to the answers; try to put together a picture of the client as an investor in terms of his objectives, history of investing, and his tolerance for risk."
    },
    {
       "id":1402,
       "topic_id":1,
       "practice_test_id":4,
       "question":"The following are true about net worth standards for both broker dealers and registered investment advisors except:",
       "choice_a":"These standards are imposed because these professionals may take custody of client assets",
       "choice_b":"Minimum standards are usually higher for investment advisors who maintain custody of client accounts than for broker dealers",
       "choice_c":"A minimum net worth of $250,000 must be declared by all of these professionals",
       "choice_d":"Broker dealers and investment advisors may be required to post a surety bond to ensure their financial solvency.",
       "correct_answer":"C",
       "explanation":"The administrator may require minimum net worth standards and they may vary from state to state."
    },
    {
       "id":1403,
       "topic_id":1,
       "practice_test_id":5,
       "question":"The key element that constitutes a fraudulent act to be considered a criminal action would be best defined as which of the following?",
       "choice_a":"A loss greater than $1,000",
       "choice_b":"A loss greater than $10,000",
       "choice_c":"An intentional act for material gain",
       "choice_d":"A breech of ethics",
       "correct_answer":"C",
       "explanation":"A criminal prosecution of a fraudulent act will occur whenever there is intent on the part of the individual perpetuating the fraud.  The key difference between a criminal and civil prosecution for fraud will ultimately be based on proving that the action was intentionally done to defraud an investor."
    },
    {
       "id":1405,
       "topic_id":1,
       "practice_test_id":6,
       "question":"The maximum dollar value of a gift given to another person is:",
       "choice_a":"Limited to $100.00 per year per firm",
       "choice_b":"Limited to $1000.00 per year per employee",
       "choice_c":"Limited to $1000.00 per year per employee of another brokerage firm",
       "choice_d":"There is no limit as to the size of a gift",
       "correct_answer":"D",
       "explanation":"The limit on the gift is only on gifts to employees of other firms. There is no limit to the size of a gift that may be given outside the industry."
    },
    {
       "id":1406,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The maximum fine under the Code of Procedure is:",
       "choice_a":"$1,000,000",
       "choice_b":"$30,000",
       "choice_c":"300 % of the amount",
       "choice_d":"Unlimited",
       "correct_answer":"D",
       "explanation":"The maximum fine under the Code of Procedure is unlimited."
    },
    {
       "id":1412,
       "topic_id":1,
       "practice_test_id":"",
       "question":"FINRA's gift rule applies to all of the following except:",
       "choice_a":"Non-cash gifts",
       "choice_b":"Cash Gratuities",
       "choice_c":"Entertainment",
       "choice_d":"Employment contracts to provide temporary services to another member",
       "correct_answer":"D",
       "explanation":"The FINRA rule regarding gifts or payments to employees of another member covers all of those things listed except contract employees of another member firm who are exempt from the gift rule."
    },
    {
       "id":1413,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The only permitted intentional manipulation of a security price by an investment banker is allowed in which of the following cases?",
       "choice_a":"On a short sale of a security",
       "choice_b":"By a stabilizing bid when a security is trading in the secondary market",
       "choice_c":"By a stabilizing bid at the public offering price or above",
       "choice_d":"By a stabilizing bid at the public offering price or just below",
       "correct_answer":"D",
       "explanation":"Under the Securities Act of 1934, the only permitted intentional price manipulation of a security can occur in a new issue that has just begun trading in the secondary market and the lead underwriter makes a one time stabilizing bid at the public offering price or just below."
    },
    {
       "id":1414,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The primary purpose of the Uniform Securities Act is:",
       "choice_a":"To regulate federal and state registered securities",
       "choice_b":"To prevent fraudulent and misleading practices in the securities industry",
       "choice_c":"To establish a uniform code of behavior for broker dealers and agents",
       "choice_d":"To correct any violations and punish any violators of this act",
       "correct_answer":"B",
       "explanation":"The primary purpose of the Uniform Securities Act is to prevent any fraudulent or misleading practices, to keep them from occurring, and to protect the investor."
    },
    {
       "id":1415,
       "topic_id":1,
       "practice_test_id":6,
       "question":"The respondent to an arbitration has how long to respond to the claimant?",
       "choice_a":"30 days",
       "choice_b":"15 days",
       "choice_c":"45 days",
       "choice_d":"60 days",
       "correct_answer":"C",
       "explanation":"The respondent has 45 days to answer an arbitration claim."
    },
    {
       "id":1416,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The rule that requires a broker dealer to guard against the free flow of information between the investment banking department and the trading and retail department is known as:",
       "choice_a":"Insider Trading Act",
       "choice_b":"Policy and Procedures Act",
       "choice_c":"Fire Wall Requirement",
       "choice_d":"Investment Banking Act",
       "correct_answer":"C",
       "explanation":"All brokerage firms are required to maintain a fire wall between investment banking and the other departments of the firm."
    },
    {
       "id":1417,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The Securities Act of 1933 is concerned with which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Primary market transactions </li><li>Disclosure </li><li>Non exempt issuers </li><li>All issuers of securities</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"The Securities Act of 1933 is not concerned with exempt issuers of securities, although no one is exempt from the anti fraud provision of the act."
    },
    {
       "id":1418,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The Securities Act of 1934 regulates all of the following except:",
       "choice_a":"Exchanges",
       "choice_b":"Over the counter market",
       "choice_c":"Regional exchanges",
       "choice_d":"IPO\u0027S",
       "correct_answer":"D",
       "explanation":"The Securities Act of 1934 regulates the secondary market; it does not regulate the primary market."
    },
    {
       "id":1419,
       "topic_id":1,
       "practice_test_id":1,
       "question":"The Securities Exchange Act of 1934 regulates all of the following except:",
       "choice_a":"Client accounts",
       "choice_b":"Short sales",
       "choice_c":"Fraud in the primary market",
       "choice_d":"Net capital for broker dealers",
       "correct_answer":"C",
       "explanation":"The Securities Exchange Act of 1934 regulates all of the answers listed except fraud in the primary market. The Securities Exchange Act only regulates the secondary market."
    },
    {
       "id":1420,
       "topic_id":1,
       "practice_test_id":2,
       "question":"The Securities Exchange Act of 1934 regulates all of the following except:",
       "choice_a":"Fingerprinting of representatives",
       "choice_b":"Short sales",
       "choice_c":"Insider trading",
       "choice_d":"Underwriter transactions",
       "correct_answer":"D",
       "explanation":"Underwriter transactions are regulated by the Securities Act of 1933"
    },
    {
       "id":1421,
       "topic_id":1,
       "practice_test_id":3,
       "question":"The Securities Exchange Act regulates which market?",
       "choice_a":"Primary",
       "choice_b":"Secondary",
       "choice_c":"Third",
       "choice_d":"Fourth",
       "correct_answer":"B",
       "explanation":"The Securities Exchange Act of 1934 regulate the secondary market"
    },
    {
       "id":1422,
       "topic_id":1,
       "practice_test_id":4,
       "question":"The Uniform Securities Act covers fraud in which of the following areas?",
       "choice_a":"The sales of securities",
       "choice_b":"The purchase of securities",
       "choice_c":"Investment advisory practices",
       "choice_d":"All of the areas listed",
       "correct_answer":"D",
       "explanation":"The Uniform Securities Act covers fraud in the sales and purchase of securities as well as in the investment advisory practices in securities."
    },
    {
       "id":1423,
       "topic_id":1,
       "practice_test_id":5,
       "question":"Under the Insider Trading Fraud Enforcement Act, the maximum fine for violators is:",
       "choice_a":"Three times the amount of money made",
       "choice_b":"Three times the amount of money investor avoided losing",
       "choice_c":"Treble damages",
       "choice_d":"Unlimited",
       "correct_answer":"D",
       "explanation":"The maximum fine for someone found to have acted on inside information is unlimited."
    },
    {
       "id":1424,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Under the Uniform Securities Act, it is a violation for an investment adviser to:",
       "choice_a":"Hire an agent who is properly registered as a general securities representative",
       "choice_b":"Employ a representative who is not properly registered",
       "choice_c":"Hire an agent who has declared bankruptcy",
       "choice_d":"Hire a representative who has a criminal conviction 25 years ago",
       "correct_answer":"B",
       "explanation":"An investment adviser may not employ an agent who is not properly registered."
    },
    {
       "id":1425,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, it is unlawful for any person, in conjunction with the offer, sale, or purchase of a security, directly or indirectly, to do all of the following except:",
       "choice_a":"Employ any device, scheme, or artifice to defraud",
       "choice_b":"Make an untrue statement of fact or omit a statement of fact to misconstrue the information",
       "choice_c":"Offer an opinion about an investment based on an investment\u0027s past performance",
       "choice_d":"Engage in any act, practice, or course of business which would operate as deceit on any person",
       "correct_answer":"C",
       "explanation":"Offering an opinion about an investment based on its past performance is lawful as long as it is offered as an opinion, not absolute fact."
    },
    {
       "id":1426,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following actions by a broker would constitute a discretionary trade on a broker's part?",
       "choice_a":"Broker chooses the time and price of a security",
       "choice_b":"Broker chooses time of the trade",
       "choice_c":"Broker chooses security and number of shares",
       "choice_d":"Broker chooses price of trade",
       "correct_answer":"C",
       "explanation":"A discretionary order would be determined if a broker has chosen both the security and the number of shares in the trade.  Time and price alone would not constitute a discretionary trade in the account."
    },
    {
       "id":1427,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following actions by a broker would constitute an excessive markup or commission on the sale of a security?",
       "choice_a":"Marking up a security 5% for a 100 share trade",
       "choice_b":"Charging an 8% markup after having had to call five market makers to get the security for the client",
       "choice_c":"Charging 7% on a thinly traded non-NASDAQ security transaction",
       "choice_d":"Charging 8% on a highly traded NASDAQ security that is listed on the National Market System with over a dozen market makers",
       "correct_answer":"D",
       "explanation":"FINRA states as a guideline that a markup of 5% is permitted on a sale of a security unless they can justify a greater markup.  A NASDAQ security that is widely traded with numerous market makers would not be a typical security that would justify a higher than 5% standard markup for a broker dealer."
    },
    {
       "id":1428,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following acts concerns itself with the registration of broker dealers and their required net capital?",
       "choice_a":"SIPC Act of 1970",
       "choice_b":"Securities Act of 1933",
       "choice_c":"Broker Dealer Fiscal Responsibility act of 1937",
       "choice_d":"Securities Exchange Act of 1934",
       "correct_answer":"D",
       "explanation":"The Securities Exchange Act of 1934 regulates the activities of broker dealers and their required capital"
    },
    {
       "id":1429,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following are required for an offer of rescission? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It must be in writing  </li><li>It must offer interest at the current prime rate </li><li>It must be accepted within 35 days  </li><li>The client may recover punitive damages in addition to interest </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II and III",
       "choice_d":"I only",
       "correct_answer":"D",
       "explanation":"All of the choices listed are not required for an offer of rescission except that it be in writing."
    },
    {
       "id":1430,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following are true regarding  SIPC coverage? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Securities registered in a customer's name are distributed first to their owner's  </li><li>Securities held in street name are provided SIPC coverage </li><li>Commodities are not covered </li><li>Customers with excess claims become general creditors </li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are features of SIPC Coverage."
    },
    {
       "id":1431,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following are true regarding a brokerage firm giving a gift to the employee of another member? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The giving member must have the permission of the employing member. </li><li>It may not be based on sales. </li><li> It may not be based on the promise of sales. </li><li>It covers employment contracts. </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct except it does not cover employment contracts with another member firm."
    },
    {
       "id":1432,
       "topic_id":1,
       "practice_test_id":1,
       "question":"Which of the following are true regarding form letters? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They are considered retail communication </li><li>They must be approved in advance </li><li>They are considered correspondence </li><li>They are subject to file requirements </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"II and III",
       "correct_answer":"C",
       "explanation":"A form letter is considered retail communication; it must be approved in advance by a principal and it is subject to file requirements."
    },
    {
       "id":1433,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Which of the following does FINRA consider to be retail communication under Rule 2210? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Telemarketing scripts  </li><li>Text for seminars  </li><li>Market letters </li><li>Performance reports  </li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and III",
       "choice_c":"III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the items are considered to be retail communication under Rule 2210"
    },
    {
       "id":1434,
       "topic_id":1,
       "practice_test_id":3,
       "question":"Which of the following establish rules and membership requirements for FINRA?",
       "choice_a":"The Board of Governors",
       "choice_b":"The District Business Conduct Committee",
       "choice_c":"The National Business Conduct Committee",
       "choice_d":"The Office of the Bylaw Administrator",
       "correct_answer":"A",
       "explanation":"FINRA's Board of Governors establishes rules and membership standards."
    },
    {
       "id":1435,
       "topic_id":1,
       "practice_test_id":4,
       "question":"Which of the following gave the Federal Reserve Board the authority to regulate the extension of credit for securities purchases?",
       "choice_a":"The Securities Lending Act of 1935",
       "choice_b":"The Maloney Act of 1938",
       "choice_c":"The Securities Exchange Act of 1934",
       "choice_d":"The Securities Act of 1933",
       "correct_answer":"C",
       "explanation":"Regulation T of the Securities Exchange Act of 1934 gave the Federal Reserve board the authority to regulate the extension of credit for securities purchases."
    },
    {
       "id":1436,
       "topic_id":1,
       "practice_test_id":5,
       "question":"Which of the following handles trade practice complaints for FINRA?",
       "choice_a":"Rules of Conduct",
       "choice_b":"Department of Enforcement",
       "choice_c":"Uniform Practice Code",
       "choice_d":"The Board of Governors",
       "correct_answer":"B",
       "explanation":"The Department of Enforcement handles trade practice complaints for each district of FINRA."
    },
    {
       "id":1437,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Which of the following is not considered to be retail communication?",
       "choice_a":"Market letter",
       "choice_b":"Research report",
       "choice_c":"A group email to 15 clients who are interested in growth funds",
       "choice_d":"Telemarketing script",
       "correct_answer":"C",
       "explanation":"A group email to 15 clients who are interested in growth funds would be considered correspondence. If the email went to 25 or more clients it would be considered retail communication"
    },
    {
       "id":1438,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following is misleading? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Multiple hedge clauses  </li><li>Implied regulatory endorsement </li><li>Promises of free services </li><li>Using outside research </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"Multiple hedge clauses and implied regulatory endorsement are violations and misleading. Free services must be free to everyone, with no payment required."
    },
    {
       "id":1439,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following is not a violation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Failing to inform a firm principal about a customer verbally complaining </li><li>An agent without discretion determines the price to pay for a security </li><li>An agent borrows money from a friend who is also a customer  </li><li>The agent invests in a rental property without informing their firm </li></ol>",
       "choice_a":"I and III",
       "choice_b":"III and IV",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"An agent does not have to inform their firm about a verbal customer complaint and also does not need to inform them about owning a rental property. An agent can determine the best time and price to execute a customer's order."
    },
    {
       "id":1440,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Which of the following is / are associated persons of a member firm? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Registered representative  </li><li>Trader  </li><li>Director  </li><li>Manager </li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of those listed would be considered associated persons and would be required to register."
    },
    {
       "id":1441,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following is prohibited under the USA?",
       "choice_a":"Actively trading a customer\u0027s account",
       "choice_b":"Executing an order for the account of a customer for an unregistered non-exempt security at the customer\u0027s request",
       "choice_c":"Receiving a commission for selling a private placement to the account of a non-accredited investor",
       "choice_d":"Automatically canceling a customer\u0027s order at the end of the day because it was not executed",
       "correct_answer":"C",
       "explanation":"Only receiving a commission on  the sale of a private placement to a non-accredited investor's account is prohibited."
    },
    {
       "id":1442,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following is true regarding unsolicited orders? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An Administrator may require a signed acknowledgement from the customer that the order was executed at their request. </li><li>They may be executed in all securities. </li><li>They must be executed even if the agent feels it would not be a suitable investment for the customer. </li><li>The principal must approve all unsolicited orders prior to execution. </li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are true regarding unsolicited orders except there is no requirement that it be approved prior to execution. The order must be approved promptly by a principal."
    },
    {
       "id":1443,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following may be able to purchase shares of a hot issue?",
       "choice_a":"Registered representative",
       "choice_b":"Minor child of a firm employee",
       "choice_c":"Registered representative\u0027s spouse",
       "choice_d":"Registered representative\u0027s father-in-law",
       "correct_answer":"D",
       "explanation":"The registered representative's father-in-law may be able to purchase a hot issue."
    },
    {
       "id":1444,
       "topic_id":1,
       "practice_test_id":2,
       "question":"With regard to an agency cross transaction executed by an investment adviser all of the following are true except:",
       "choice_a":"The adviser must have the written authorization of both customers prior to affecting the cross.",
       "choice_b":"The adviser may solicit both sides of the cross",
       "choice_c":"The client\u0027s permission may be pulled verbally anytime prior to execution.",
       "choice_d":"The adviser may disclose the fact that they may engage in cross transactions in their brochure.",
       "correct_answer":"B",
       "explanation":"An adviser may not solicit both sides of the cross. They may only solicit one side of the transaction. All of the other choices listed are correct."
    },
    {
       "id":1445,
       "topic_id":1,
       "practice_test_id":3,
       "question":"You are looking to increase your book of business and are planning to step up your marketing effort. Which of the following would not be considered retail communication?",
       "choice_a":"A research report",
       "choice_b":"Prospecting script",
       "choice_c":"Invitation to a seminar",
       "choice_d":"A letter to a customer requesting a meeting to discuss her portfolio",
       "correct_answer":"D",
       "explanation":"The letter to a particular customer asking to meet with them would not be considered retail communication. The letter to the customer would be considered correspondence."
    },
    {
       "id":1446,
       "topic_id":1,
       "practice_test_id":4,
       "question":"You are the owner of a restaurant and you would like to have a guitarist play in the lounge on Saturday evenings.  You have known your representative for 15 years and know her to be a great jazz guitarist.  You think she would like to play and ask her if she was available to do so.  She would have to get permission from which of the following before accepting your offer?",
       "choice_a":"FINRA",
       "choice_b":"NYSE",
       "choice_c":"Her Firm",
       "choice_d":"No one, since it is not securities related and is on her own time",
       "correct_answer":"C",
       "explanation":"The representative would have to get permission from her employer before working outside the office in any capacity."
    },
    {
       "id":1447,
       "topic_id":1,
       "practice_test_id":5,
       "question":"You have an account with a brokerage firm that has filed for bankruptcy. There is $370,000 in market value in the account along with $75,000 in cash. Your spouse also has an account with $300,000 in market value and $90,000 in cash, what will SIPC cover?",
       "choice_a":"A total of $500,000 for both accounts",
       "choice_b":"Everything is covered in this situation",
       "choice_c":"The cash only",
       "choice_d":"The securities only",
       "correct_answer":"B",
       "explanation":"Everything is covered. SIPC covers $500,000 per separate customer, of which up to $250,000 may be cash, so both accounts are fully covered."
    },
    {
       "id":1448,
       "topic_id":1,
       "practice_test_id":6,
       "question":"You have just been handed a business card by a representative, and \u0022FINRA\u0022 is in bold letters in the center of the card with the firm's name and the representative's name in the lower corner of the card along with the firm's phone and fax number. Which of the following is true?",
       "choice_a":"The card is acceptable, as it has all of the required information on it",
       "choice_b":"The card is a violation of the rules of fair practice because it implies that FINRA has approved or endorsed the firm",
       "choice_c":"The card is a violation because it does not have SIPC on the card",
       "choice_d":"FINRA takes no position regarding business cards",
       "correct_answer":"B",
       "explanation":"The card is implying that FINRA has some how approved or endorsed the firm and is a violation."
    },
    {
       "id":1449,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Your brokerage firm has placed an ad in the local newspaper advertising its new line of services being offered to investors.  The firm must maintain the ad for how long?",
       "choice_a":"3 years",
       "choice_b":"2 years",
       "choice_c":"18 months",
       "choice_d":"12 months",
       "correct_answer":"A",
       "explanation":"Brokerage firms must maintain their advertising for at least 3 years."
    },
    {
       "id":1450,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Your firm has just started a sales contest for the office.  The representative who has the highest gross commission for the current quarter will win an all expense paid trip for two to Hawaii. Under FINRA rules this is:",
       "choice_a":"Not permitted, as it is valued over the $100 limit",
       "choice_b":"Not permitted, as it would be seen as an enticement for the representative and encourages churning.",
       "choice_c":"Not permitted, without approval of FINRA",
       "choice_d":"Permitted, as it is an internal sales contest",
       "correct_answer":"D",
       "explanation":"This would be permitted, as it is an internal sales contest.  You may influence your own employees, just not the employees of other firms."
    },
    {
       "id":1451,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Your firm has the following people working for it.  Which one is required to be registered in order to perform their job?",
       "choice_a":"Part time sales assistant who occasionally takes verbal orders from customers",
       "choice_b":"A corporate officer whose sole function is to act as liaison between the Board of Directors and management",
       "choice_c":"Your firm\u0027s receptionist who takes messages from customers inquiring about their accounts",
       "choice_d":"A back office margin clerk who assists the head of the margin department",
       "correct_answer":"A",
       "explanation":"The part time sales assistant who takes orders from customers must be registered because she is taking orders."
    },
    {
       "id":1452,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An investment company mails an offering to a neighboring state. Which of the following is true?",
       "choice_a":"An offer is considered to have been made only in the state in which it is received",
       "choice_b":"An offer is considered to have been made only in the state from which it was mailed",
       "choice_c":"An offer is considered to have been made in both states",
       "choice_d":"An offer is considered to have been made in the state from which it was mailed and in the state in which it was received if more than 70% of the offers were sent to the recipient state",
       "correct_answer":"C",
       "explanation":"An offer made through the mail is considered to have been made in the state from which it was mailed and in the state in which it was received."
    },
    {
       "id":1453,
       "topic_id":1,
       "practice_test_id":"",
       "question":"As it relates to advertising, which of the following can an investment adviser not do? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Not disclose market conditions </li><li>Show performance without fees </li><li>Refer to testimonials </li><li>Make offers of free services</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"An investment adviser may not show performance without taking into account the fees and expenses that will be incurred by clients. If the adviser details performance the adviser must disclose the market conditions for the same period of time. The SEC modernized the adviser advertising rules to allow the use of testimonials. An investment adviser may offer free services so long as they are actually free with no strings attached."
    },
    {
       "id":1454,
       "topic_id":1,
       "practice_test_id":2,
       "question":"An underwriter that is taking a new issue of securities to market can do which of the following prior to the filing date?",
       "choice_a":"Run a tombstone ad",
       "choice_b":"Accept indications of interest",
       "choice_c":"Prepare the registration statement",
       "choice_d":"Send out a final prospectus",
       "correct_answer":"C",
       "explanation":"Prior to the filing date, the underwriter may only prepare the registration statement."
    },
    {
       "id":1455,
       "topic_id":1,
       "practice_test_id":3,
       "question":"Which of the following are not considered wrap fee programs? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Managed account programs </li><li>3 (C) (7) programs </li><li>Mutual fund asset allocation programs </li><li>Fulcrum fee programs </li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"None of the choices listed are considered wrap fee programs."
    },
    {
       "id":1456,
       "topic_id":1,
       "practice_test_id":4,
       "question":"An investment adviser must disclose any regulatory actions for:",
       "choice_a":"1 year",
       "choice_b":"3 years",
       "choice_c":"5 years",
       "choice_d":"10 years",
       "correct_answer":"D",
       "explanation":"An investment adviser must disclose any regulatory actions for 10 years"
    },
    {
       "id":1457,
       "topic_id":1,
       "practice_test_id":5,
       "question":"An individual who is giving advice relating to securities but who is not required to register as an adviser:",
       "choice_a":"Is not exempt from the anti-fraud provisions of the Investment Advisers Act of 1940",
       "choice_b":"Must give only non personal advice",
       "choice_c":"Is exempt from the anti-fraud provisions of the Investment Advisers Act of 1940",
       "choice_d":"May not charge more than $199 for an annual subscription for a market letter if they base the letter on market conditions",
       "correct_answer":"A",
       "explanation":"An individual who is giving advice relating to securities but who is not required to register as an adviser is not exempt from the anti-fraud provisions of The Investment Advisers Act of 1940."
    },
    {
       "id":1458,
       "topic_id":1,
       "practice_test_id":6,
       "question":"According to the Investment Advisers Act of 1940 which of the following are considered advertising? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A formula used to determine the value of a security is sent to three people </li><li>A notice that offers analysis is mentioned after a radio broadcast </li><li>Graphs printed in an investment magazine with the adviser's name  </li><li>Information regarding the investment adviser is sent in written form to two potential clients </li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"The Investment Advisers Act of 1940 considers all of the choices listed to be advertising."
    },
    {
       "id":1459,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The Investment Advisers Act of 1940 considers written communication sent to more than how many people to be advertising?",
       "choice_a":1,
       "choice_b":10,
       "choice_c":5,
       "choice_d":15,
       "correct_answer":"A",
       "explanation":"The Investment Advisers Act of 1940 considers written communication sent to more than one person to be advertising."
    },
    {
       "id":1460,
       "topic_id":1,
       "practice_test_id":"",
       "question":"According to the SEC which of the following are considered to be advertising?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An email sent to three people </li><li>The adviser's website </li><li>Video presentations </li><li>Slide presentations </li></ol>",
       "choice_a":"II and III",
       "choice_b":"II and IV",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"The SEC considers all of the items listed to be advertising by investment advisers."
    },
    {
       "id":1461,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The SEC would prohibit performance based advertising for an investment adviser under which of the following circumstances? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The ad refers to client testimonials </li><li>The performance is calculated on gross returns before fees </li><li>Commissions are excluded </li><li>The ad bases the results on select group of identified clients</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I, II, III, and IV",
       "choice_d":"I, II, and III",
       "correct_answer":"B",
       "explanation":"An investment adviser may not show performance without taking into account the fees and expenses that will be incurred by clients. If the adviser details performance the adviser must disclose the market conditions for the same period of time. The SEC modernized the adviser advertising rules to allow the use of testimonials. If the adviser bases the return advertised on the clients who realized that return, those clients  must be identified."
    },
    {
       "id":1462,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Any person subject to an order of the SEC may appeal the order within:",
       "choice_a":"30 days",
       "choice_b":"45 days",
       "choice_c":"60 days",
       "choice_d":"90 days",
       "correct_answer":"C",
       "explanation":"An order of the SEC may be appealed in writing for 60 days."
    },
    {
       "id":1463,
       "topic_id":1,
       "practice_test_id":3,
       "question":"Which of the following are considered to have custody of client funds? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An investment adviser who holds customer securities in a separate location </li><li>An investment adviser with full power of attorney </li><li>An investment adviser who can buy and sell securities for client accounts without speaking to the client before hand </li><li>An investment adviser who can write client checks </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, III and IV",
       "correct_answer":"C",
       "explanation":"An investment adviser is considered to have custody of client funds if they have possession of the securities, full power of attorney, or can write checks from client accounts."
    },
    {
       "id":1464,
       "topic_id":1,
       "practice_test_id":4,
       "question":"Which of the following is not false?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Investment adviser representatives must have a brochure </li><li>Only ADV Part II needs to be presented to clients </li><li>If information in Form ADV Part II does not concern clients, that information need not be disclosed to clients </li><li>A performance based fee may be charged to a 3 (C) (7) fund investor who as an investment of $1,000,000 </li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I and II",
       "choice_d":"II, III, and IV",
       "correct_answer":"D",
       "explanation":"Only Form ADV II needs to be disclosed to clients. If information in Form ADV II does not relate to the clients that information does not need to be disclosed. Investors who have at least $1,000,000 invested in a 3(C) (7) fund may be charged a performance based fee. An investment adviser representative never needs their own brochure only the firm needs a brochure."
    },
    {
       "id":1465,
       "topic_id":1,
       "practice_test_id":5,
       "question":"An investment adviser with limited power of attorney converts client funds into another investment held in another separate account. Which of the following is most likely true?",
       "choice_a":"The investment adviser is within their authority to make the investment",
       "choice_b":"This is an acceptable practice if the new investment is in line with the client\u0027s investment objectives",
       "choice_c":"The investment adviser has committed a violation",
       "choice_d":"This is acceptable if the investment adviser is also registered as a broker dealer in the client\u0027s state of residency",
       "correct_answer":"C",
       "explanation":"By converting the client's funds, the investment adviser has committed a violation. The investment adviser has moved the client's funds from one account to another without full power of attorney."
    },
    {
       "id":1466,
       "topic_id":1,
       "practice_test_id":6,
       "question":"A lawyer is setting up a 401k plan for a client and suggests the client uses a specific adviser to manager the portfolio. Which of the following is / are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The lawyer must register </li><li>If the lawyer receives a fee they must give the client 2 brochures </li><li>If the lawyer receives a fee the fee arrangement must be in writing  </li><li>The lawyer is not required to register </li></ol>",
       "choice_a":"IV only",
       "choice_b":"III and IV",
       "choice_c":"I and II",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"If the lawyer is advising on a pension plan and recommends an investment adviser to manage the plan they are acting as a pension consultant and must register. If they are soliciting clients for the adviser they must provide clients with the solicitor's brochure and the adviser's brochure. All compensation arrangements must be in writing."
    },
    {
       "id":1467,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An individual who is not required to register as an investment adviser:",
       "choice_a":"Is exempt from the anti-fraud provisions of the Investment Advisers Act of 1940",
       "choice_b":"Is not exempt from the anti-fraud provision of the Investment Advisers Act of 1940",
       "choice_c":"Is allowed to give advice to up sixteen people nationally",
       "choice_d":"Is allowed to give advice to up to six people at the state level",
       "correct_answer":"B",
       "explanation":"An individual who is not requires to register as an investment adviser is not exempt from the anti-fraud provisions of The Investment Advisers Act of 1940."
    },
    {
       "id":1468,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An investment advisory client must be informed of which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If a partner leaves the firm </li><li>The amount of agency cross transactions executed in a given year </li><li>The amount of commission earned on agency cross transactions </li><li>A regulatory action against the adviser 11 years ago </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II, III, and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"An advisory client should be informed of all of the choices listed except a regulatory matter more than ten years old."
    },
    {
       "id":1469,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An investor in which of the following accounts should be the most concerned with reverse churning?",
       "choice_a":"Managed asset account",
       "choice_b":"Mutual fund allocation account",
       "choice_c":"Wrap account",
       "choice_d":"Tactical allocation account",
       "correct_answer":"C",
       "explanation":"An investor in a wrap account should be the most concerned about reverse churning. Reverse churning is the tendency to trade less than is appropriate. Since a Wrap account charges one fee for execution and advice  a firm may be less inclined to trade."
    },
    {
       "id":1470,
       "topic_id":1,
       "practice_test_id":2,
       "question":"An investment adviser needs to keep records for:",
       "choice_a":"2 years",
       "choice_b":"3 years",
       "choice_c":"5 years",
       "choice_d":"10 years",
       "correct_answer":"C",
       "explanation":"An investment adviser needs to keep records for five years."
    },
    {
       "id":1471,
       "topic_id":1,
       "practice_test_id":3,
       "question":"If an investment adviser uses a solicitor to obtain new clients, which of the following is not false?",
       "choice_a":"The adviser must get a signed statement from the client regarding the receipt of the brochure only",
       "choice_b":"The adviser must get a signed statement from the client regarding the receipt of the brochure and the solicitor\u0027s brochure",
       "choice_c":"An agreement with a solicitor is not required to be in writing",
       "choice_d":"Solicitors of impersonal advisory services must register",
       "correct_answer":"B",
       "explanation":"All of the choices listed are false except the adviser must get a signed statement from the client regarding the receipt of the brochure and the solicitor's brochure."
    },
    {
       "id":1472,
       "topic_id":1,
       "practice_test_id":4,
       "question":"An investor who is considering selling their stock in XYZ is told by someone that XYZ is going to be acquired and they should not sell. After hearing this, the investor holds their shares and several weeks later an announcement is made and XYZ is acquired at a significant premium. Which of the following is true?",
       "choice_a":"Both the tipper and the investor have committed a violation",
       "choice_b":"The investor has violated the Insider Trading and Securities Fraud Enforcement Act of 1988",
       "choice_c":"The investor has violated the Securities Exchange Act of 1934",
       "choice_d":"No violation has been committed by the investor",
       "correct_answer":"D",
       "explanation":"The investor in this case has not committed a violation by not selling the shares."
    },
    {
       "id":1473,
       "topic_id":1,
       "practice_test_id":5,
       "question":"An investor living in California is listening to a radio broadcast from New Mexico that details the benefits of investing in CMOs. The broadcast details how and where investors may purchase CMOs. Which of the following is true?",
       "choice_a":"An offer has been made in California",
       "choice_b":"An offer has not been made in California",
       "choice_c":"An offer has been made in both California and New Mexico",
       "choice_d":"An offer has not been made in either California or New Mexico",
       "correct_answer":"B",
       "explanation":"A radio broadcast originating outside a state does not constitute an offer inside a state where it can be heard."
    },
    {
       "id":1474,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Which of the following would be considered deceptive or unlawful? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An insurance company issuing securities related to a variable life insurance policy's separate account which are not redeemable </li><li>A long standing investment company offering an aggressive growth fund titled Superior Growth Fund </li><li>A broker dealer entering into a contract to repurchase securities from a customer at a slightly higher price in the near future </li><li>An insurance company deducting aggregate fees from a separate account with less than $5,000,000 </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"An insurance company may not issue securities related to a separate account which are not redeemable, and a mutual fund may not use a name that implies the fund or its performance is better than others. Answer III. describes a valid repurchase agreement and an insurance company must have a separate account with at least $1,000,000."
    },
    {
       "id":1475,
       "topic_id":1,
       "practice_test_id":"",
       "question":"All of the following are qualified purchasers except:",
       "choice_a":"An individual with at least $5,000,000 in investments",
       "choice_b":"A family trust with at least $5,000,000 in investments",
       "choice_c":"A married couple with at least $5,000,000 in investments",
       "choice_d":"A registered investment company with at least $5,000,000 in investments",
       "correct_answer":"D",
       "explanation":"All of the choices listed are qualified purchasers except the registered investment company. The investment company is an institutional investor."
    },
    {
       "id":1476,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following would be considered to be retail communications?",
       "choice_a":"The broker dealer\u0027s intranet",
       "choice_b":"Emails to less than 25 potential customers within 30 days",
       "choice_c":"Emails to several existing customers",
       "choice_d":"Instant messages to 25 or more potential customers",
       "correct_answer":"D",
       "explanation":"The company's intranet would only be available to its employees.  The emails to existing customers and to fewer than 25 potential customers is considered correspondence. IMs to 25 or more people is considered retail communications."
    },
    {
       "id":1477,
       "topic_id":1,
       "practice_test_id":"",
       "question":"All of the following are considered correspondence except:",
       "choice_a":"Emails to existing customers",
       "choice_b":"Emails to 20 potential customers",
       "choice_c":"Emails to 30 potential customers",
       "choice_d":"Customized written communication with an existing customer",
       "correct_answer":"C",
       "explanation":"Correspondence is customized communication with the client.  Once the same email is sent to 25 or more customers, it is no longer correspondence, it is classified as retail communication."
    },
    {
       "id":1478,
       "topic_id":1,
       "practice_test_id":1,
       "question":"Chat room discussions that discuss the member firm's business are considered:",
       "choice_a":"Public appearances",
       "choice_b":"Sales literature",
       "choice_c":"Correspondence",
       "choice_d":"Retail communication",
       "correct_answer":"D",
       "explanation":"Chat room discussions that discuss a member firm's business are considered to be part of retail communication."
    },
    {
       "id":1479,
       "topic_id":1,
       "practice_test_id":2,
       "question":"A member firm's securities principal must approve which of the following?",
       "choice_a":"Information to be posted on the firm\u0027s website",
       "choice_b":"Emails to 35 potential customers",
       "choice_c":"Instant messages to 40 potential customers",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The principal is responsible for the approval of all retail communication.  All of the choices are classified as retail communication."
    },
    {
       "id":1480,
       "topic_id":1,
       "practice_test_id":3,
       "question":"A registered rep sent an email to John Q. Smith, a potential client who was referred by his client Harry Jones. The email:",
       "choice_a":"Is considered advertising",
       "choice_b":"Is considered sales literature",
       "choice_c":"Os considered correspondence",
       "choice_d":"Requires FINRA approval",
       "correct_answer":"C",
       "explanation":"If an email is sent to fewer than 25 potential customers in a 30 day period, it is correspondence."
    },
    {
       "id":1481,
       "topic_id":1,
       "practice_test_id":4,
       "question":"Copies of instant messages sent to 50 potential customers must be kept for:",
       "choice_a":"Five years",
       "choice_b":"Three years",
       "choice_c":"Ten years",
       "choice_d":"The life of the firm",
       "correct_answer":"B",
       "explanation":"All electronic communication must be retained for three years."
    },
    {
       "id":1482,
       "topic_id":1,
       "practice_test_id":5,
       "question":"A general securities principal is responsible for approving all of the following except:",
       "choice_a":"An instant message sent by a rep to his client",
       "choice_b":"Information to be posted on the firm\u0027s website",
       "choice_c":"Reprint of a magazine article sent by a rep to his client",
       "choice_d":"Group email sent to 30 potential customers",
       "correct_answer":"A",
       "explanation":"A principal must approve all retail communication. Only the instant message to a single customer would not be classified as retail communication, it would be classified as correspondence."
    },
    {
       "id":1483,
       "topic_id":1,
       "practice_test_id":6,
       "question":"FINRA prohibits which of the following?",
       "choice_a":"The use of excessive hedge clauses in electronic communications",
       "choice_b":"Making misleading statements in electronic communications",
       "choice_c":"Implying that FINRA endorses the broker dealer",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"FINRA rules prohibit all of the choices."
    },
    {
       "id":1484,
       "topic_id":1,
       "practice_test_id":"",
       "question":"According to FINRA Conduct Rules, which of the following are considered advertisements?",
       "choice_a":"Bulletin boards",
       "choice_b":"Blogs",
       "choice_c":"Banner ads",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"FINRA Conduct Rules state that publicly available websites, as well as blogs, banner ads and bulletin boards are considered advertising."
    },
    {
       "id":1485,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Password protected websites are:",
       "choice_a":"Require passwords to be updated regularly",
       "choice_b":"Retail communication",
       "choice_c":"Correspondence",
       "choice_d":"Prohibited by FINRA Conduct Rules",
       "correct_answer":"B",
       "explanation":"According to FINRA, password protected websites are considered to be retail communication if even a single retail investor has access to the site."
    },
    {
       "id":1486,
       "topic_id":1,
       "practice_test_id":6,
       "question":"As per FINRA Rule 2210, electronic communications with the public:",
       "choice_a":"Must be based on the principles of fair dealing",
       "choice_b":"Must include price predictions",
       "choice_c":"Are prohibited unless the individual is an existing client",
       "choice_d":"Must be pre-filed with FINRA 15 days prior to use",
       "correct_answer":"A",
       "explanation":"All communications with the public must be based on the principles of fair dealing. It is a violation of the rule to omit material information, or to give misleading information via electronic communication."
    },
    {
       "id":1487,
       "topic_id":1,
       "practice_test_id":"",
       "question":"All of the following are true except:",
       "choice_a":"Emails to 25 or more potential clients must be approved by the principal prior to use",
       "choice_b":"A principal must approve a research report before it is posted on the firm\u0027s website",
       "choice_c":"All correspondence requires principal approval prior to use",
       "choice_d":"Electronic advertising requires prior principal approval",
       "correct_answer":"C",
       "explanation":"A principal must approve all retail communication prior to use, whether it is written or electronic.  Correspondence must be maintained at the firm, but does not require prior principal approval."
    },
    {
       "id":1488,
       "topic_id":1,
       "practice_test_id":"",
       "question":"FINRA Rule 3110, as it relates to books and records, states all of the following except:",
       "choice_a":"If a registered rep\u0027s email is sent from home, it is not part of the firm\u0027s records",
       "choice_b":"If a registered rep\u0027s email is sent from the office, it is part of the firm\u0027s records",
       "choice_c":"If a registered rep sends an instant message from home, it is part of the firm\u0027s records",
       "choice_d":"If a registered rep sends an instant message from the office, it is part of the firm\u0027s records",
       "correct_answer":"A",
       "explanation":"Rule 3110 states that when a rep sends an electronic communication regarding the firm's business (IM or email), from any location, it becomes part of the firm's records and must be maintained for 3 years."
    },
    {
       "id":1489,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A registered rep has created an online blog where she writes about her thoughts on the equity market.  This is an example of:",
       "choice_a":"Sales literature which is exempt from principal approval",
       "choice_b":"Sales literature which requires principal approval",
       "choice_c":"Advertising which is exempt from principal approval",
       "choice_d":"Advertising which requires principal approval",
       "correct_answer":"D",
       "explanation":"FINRA Conduct Rules state that publicly available websites, including blogs, are advertising.  All advertising requires prior principal approval."
    },
    {
       "id":1490,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A registered rep makes a recommendation to a customer via email.  Which of the following is / are true?",
       "choice_a":"The rep must make a reasonable effort to obtain the customer\u0027s investment objective and financial situation",
       "choice_b":"The rep must have reasonable grounds for believing the recommendation is suitable for the client",
       "choice_c":"The email would be considered correspondence",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Regardless of how a recommendation is made to a customer, the rep must obtain suitability information from the client and then have reasonable grounds for believing the recommendation is suitable.  Any email sent to an individual client is considered to be correspondence."
    },
    {
       "id":1491,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Member Conduct Rules state that registered reps must avoid conflicts of interest when dealing with customers.  With respect to equity research reports, which of the following is true?",
       "choice_a":"Written research reports are exempt from the conflict of interest rules",
       "choice_b":"Electronic research reports are exempt from the conflict of interest rules",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"D",
       "explanation":"Both written and electronic research reports require that conflicts of interest be disclosed to the public."
    },
    {
       "id":1492,
       "topic_id":1,
       "practice_test_id":3,
       "question":"A broker dealer's public website is:",
       "choice_a":"Retail communication",
       "choice_b":"Public appearance",
       "choice_c":"Not covered by FINRA rules",
       "choice_d":"Not covered by FINRA rules if it is password protected",
       "correct_answer":"A",
       "explanation":"A broker dealer's public website is considered retail communication. All websites require principal approval prior to changes being made to any information."
    },
    {
       "id":1493,
       "topic_id":1,
       "practice_test_id":4,
       "question":"Which of the following are important with respect to a broker dealer's website?",
       "choice_a":"The name of the firm should be prominently displayed",
       "choice_b":"Risk disclosure should clearly state the potential risks",
       "choice_c":"Information on the website must be updated to keep information current",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are important considerations when a broker dealer maintains a public website."
    },
    {
       "id":1494,
       "topic_id":1,
       "practice_test_id":5,
       "question":"All of the following are examples of advertising except:",
       "choice_a":"Blogs",
       "choice_b":"Chat rooms",
       "choice_c":"Websites",
       "choice_d":"Bulletin boards",
       "correct_answer":"B",
       "explanation":"Chat rooms are not advertising; they are considered public appearances."
    },
    {
       "id":1495,
       "topic_id":1,
       "practice_test_id":6,
       "question":"If a broker dealer refers to its membership in FINRA on its website:",
       "choice_a":"It is required by the Conduct Rules",
       "choice_b":"The firm must provide a hyperlink to the FINRA website",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"B",
       "explanation":"There is no requirement that a member refer to FINRA on its website.  However, if the firm chooses to mention its FINRA membership, it must provide a hyperlink to FINRA's homepage close to the FINRA reference on the site."
    },
    {
       "id":1496,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The FINRA logo:",
       "choice_a":"May be used on a firm\u0027s website",
       "choice_b":"May be used on a registered rep\u0027s website",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"D",
       "explanation":"The use of the FINRA logo is prohibited for use on both the firm's and registered rep's website."
    },
    {
       "id":1497,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A supervisor must review all:",
       "choice_a":"Employees incoming electronic communications",
       "choice_b":"Employees outgoing communications",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"All firm's must have procedures in place to have a supervisor review all employees incoming and outgoing electronic communications."
    },
    {
       "id":1498,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Regarding electronic communications between a firm's research department and non-research departments, all of the following are true except:",
       "choice_a":"Pre-approval of FINRA is required",
       "choice_b":"Pre-approval by the principal is required for certain public communications",
       "choice_c":"Copies of the electronic communications are sent to the firm\u0027s legal department",
       "choice_d":"Copies of the electronic communications are sent to the firm\u0027s compliance department",
       "correct_answer":"A",
       "explanation":"FINRA rules require that electronic communications between the research and non-research departments be copied to the firm's legal and compliance departments.  Additionally, the principal is required to pre-approve all retail communications  posted on the firm website."
    },
    {
       "id":1499,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Which of the following are true when a broker dealer receives a complaint from a customer?",
       "choice_a":"When a customer mails a complaint to the firm it must be reported to FINRA",
       "choice_b":"When a customer faxes a complaint to the firm it must be reported to FINRA",
       "choice_c":"When a customer emails a complaint to the firm it must be reported to FINRA",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All customer complaints are reported to FINRA."
    },
    {
       "id":1500,
       "topic_id":1,
       "practice_test_id":3,
       "question":"If a registered rep sends a business related email to his client via his Yahoo email account, all of the following are true except:",
       "choice_a":"The communication is not required to be supervised by the firm since it was sent from outside the office",
       "choice_b":"The communication is required to be supervised by the firm",
       "choice_c":"The communication must be retained by the firm for three years",
       "choice_d":"The firm may have policies that prohibit this communication",
       "correct_answer":"A",
       "explanation":"Not all firm's allow reps to send emails from their personal addresses.  If the firm does not prohibit this practice, the electronic communications are to be supervised and maintained at the firm."
    },
    {
       "id":1501,
       "topic_id":1,
       "practice_test_id":4,
       "question":"According to FINRA, e-faxes:",
       "choice_a":"Are not considered electronic communications",
       "choice_b":"Do not require supervision",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"D",
       "explanation":"According to FINRA rules, e-faxes are considered to be an electronic form of communication and as such require the appropriate supervision."
    },
    {
       "id":1502,
       "topic_id":1,
       "practice_test_id":5,
       "question":"With respect to reviewing a registered rep's emails at the firm, a supervisor:",
       "choice_a":"May not delegate this responsibility",
       "choice_b":"May delegate only to a Series 24 licensed principal",
       "choice_c":"Is ultimately responsible for the review",
       "choice_d":"Is required to perform this review every 30 days",
       "correct_answer":"C",
       "explanation":"Firms are required to have procedures in place for reviewing rep's emails, though not necessarily every 30 days.  The review may be done by a supervisor or it may be delegated to another person with the proper knowledge, experience and training.  It is not required for the reviewer to be a Series 24 principal."
    },
    {
       "id":1503,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Which of the following electronic communications require supervision by a principal?",
       "choice_a":"Blogs",
       "choice_b":"Group emails",
       "choice_c":"Bulletin boards",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The principal is required to supervise all electronic communications including blogs, group emails and bulletin boards."
    },
    {
       "id":1504,
       "topic_id":1,
       "practice_test_id":"",
       "question":"If a broker dealer's website requires a person to type in a password to gain access to the site, this is considered:",
       "choice_a":"Customized communications with the public",
       "choice_b":"Retail communication",
       "choice_c":"Advertising",
       "choice_d":"prohibited, as FINRA Conduct Rules require that all broker dealer websites be public websites, and therefore can not be password protected sites",
       "correct_answer":"B",
       "explanation":"When a website is password protected, it is considered to be retail communications if any retail investors can access the information."
    },
    {
       "id":1505,
       "topic_id":1,
       "practice_test_id":1,
       "question":"How long is a firm required to keep copies of a registered rep's blast emails?",
       "choice_a":"The firm is not required to keep copies of group emails",
       "choice_b":"5 years, readily accessible for 2 years",
       "choice_c":"3 years, readily accessible for 2 years",
       "choice_d":"10 years, readily accessible for 3 years",
       "correct_answer":"C",
       "explanation":"Group emails sent to more than 25 people in a 30 day period are considered retail communication. Copies of all retail communication needs to be kept for three years, with the most recent two years readily accessible."
    },
    {
       "id":1506,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Joe is a registered rep at XYZ broker dealer.  According to FINRA rules, if Joe sends an email to 15 prospective clients, which of the following is true?",
       "choice_a":"The emails are considered to be group emails",
       "choice_b":"The emails are classified as retail communication",
       "choice_c":"The emails are classified as correspondence",
       "choice_d":"The emails must be pre-approved by the compliance officer",
       "correct_answer":"C",
       "explanation":"If the same email is sent to fewer than 25 prospects the email is still considered correspondence.  Just like withetters, once the email is sent to 25 or more prospects it becomes a \u0022group email\u0022 and is considered retail communication.  There is no FINRA requirement that the compliance officer pre-approve correspondence."
    },
    {
       "id":1507,
       "topic_id":1,
       "practice_test_id":3,
       "question":"All electronic advertising must created by a member firm:",
       "choice_a":"Be approved by the principal prior to use",
       "choice_b":"Be filed with FINRA",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"All retail communication, whether written or electronic, must be approved by the principal prior to use and filed with FINRA (not approved by FINRA)."
    },
    {
       "id":1508,
       "topic_id":1,
       "practice_test_id":4,
       "question":"When a registered rep sends an instant message to a client, all of the following are true except:",
       "choice_a":"The instant message is considered correspondence",
       "choice_b":"The instant message must be maintained by the firm",
       "choice_c":"The instant message must be supervised by the firm",
       "choice_d":"The instant message may omit material facts",
       "correct_answer":"D",
       "explanation":"An instant message is an example of electronic correspondence.  As with written correspondence, it may not contain any false or misleading information, or omit any material facts."
    },
    {
       "id":1510,
       "topic_id":1,
       "practice_test_id":5,
       "question":"All of the following are retail communication except:",
       "choice_a":"A research report",
       "choice_b":"A marketing letter",
       "choice_c":"A group email",
       "choice_d":"A blog only accessible to institutional customers",
       "correct_answer":"D",
       "explanation":"A blog only accessible to institutional customers would not be considered retail communication it is institutional correspondence."
    },
    {
       "id":1511,
       "topic_id":1,
       "practice_test_id":6,
       "question":"If a registered rep enters an Internet chat room, which of the following is true?",
       "choice_a":"The rep may make exaggerated statements if he is not sending a research report to the customer",
       "choice_b":"The rep may make misleading statements to entice a prospective customer",
       "choice_c":"The rep may not reference past performance to indicate potential future results",
       "choice_d":"The rep may make unwarranted statements to entice a customer",
       "correct_answer":"C",
       "explanation":"A chat room where business is discussed is considered part of retail communication and must adhere to FINRA's rules regarding fair practice.  Therefore, no unwarranted or exaggerated claims, or misleading statements are allowed.  And as always, past performance is no indication of future performance."
    },
    {
       "id":1513,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following must be maintained by the broker dealer for three years?",
       "choice_a":"A business related email sent by the rep to his customer from his personal email address",
       "choice_b":"A business related email sent by the rep to his customer from his firm\u0027s email address",
       "choice_c":"A business related instant message sent by the rep to his customer from his personal email address",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Whether the customer is communicating from home or office, the firm is required to maintain copies of his business related electronic communications for three years."
    },
    {
       "id":1514,
       "topic_id":1,
       "practice_test_id":"",
       "question":"With regard to a broker dealer's website, all of the following are true except:",
       "choice_a":"Public websites are considered retail communication",
       "choice_b":"Research reports must be approved by the principal before being posted on the website",
       "choice_c":"Password protected websites are considered institutional communication",
       "choice_d":"FINRA logos may be used on a broker dealer\u0027s website",
       "correct_answer":"C",
       "explanation":"Password protected websites are classified as retail communication, not institutional communication.  All of the other choices are true of a broker dealer's website."
    },
    {
       "id":1515,
       "topic_id":1,
       "practice_test_id":6,
       "question":"All of the following require prior principal approval except:",
       "choice_a":"Research reports being posted on the company\u0027s website",
       "choice_b":"An instant message sent to 20 existing customers",
       "choice_c":"An email being sent to 25 prospects in a 30 day period",
       "choice_d":"An Internet blog posted by a registered rep providing information regarding the member firm",
       "correct_answer":"B",
       "explanation":"Prior principal approval is required for all retail communication.  Instant messages and emails sent to 25 or fewer people are considered correspondence."
    },
    {
       "id":1516,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Which of the following need to be taken into consideration when a broker dealer maintains a website?",
       "choice_a":"The information contained must be current",
       "choice_b":"The firm\u0027s name must be prominently displayed",
       "choice_c":"Risk disclosures must be displayed appropriately",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices are important when a broker dealer maintains a website."
    },
    {
       "id":1517,
       "topic_id":1,
       "practice_test_id":3,
       "question":"All of the following are true except:",
       "choice_a":"Electronic communications referring to the reliability of a firm\u0027s electronic trading systems may not be exaggerated",
       "choice_b":"A broker dealer must update the information on its website at least annually",
       "choice_c":"Risk disclosures must be displayed on the broker dealer\u0027s website",
       "choice_d":"The broker dealer is not required to mention its FINRA membership on its website",
       "correct_answer":"B",
       "explanation":"There is no exact requirement for how often a broker dealer must update its website.  However, the information contained must be \u0022current\u0022 so as not to mislead the public.  Reference to FINRA membership on a member's website is not obligatory.  If the firm chooses to mention its FINRA membership it must furnish a hyperlink to FINRA's homepage."
    },
    {
       "id":1518,
       "topic_id":1,
       "practice_test_id":4,
       "question":"With regard to correspondence, which of the following is true?",
       "choice_a":"An email to 50 potential customers is correspondence",
       "choice_b":"Each email to individual customers must be approved by the principal",
       "choice_c":"The principal may randomly select certain emails for review",
       "choice_d":"The principal need not review correspondence, only retail communication",
       "correct_answer":"C",
       "explanation":"A principal is required to review correspondence, and approve retail communication (a group email to 25 or more prospective clients is retail communication ).  However, due to the volume of correspondence, the firm's supervisory procedures may allow them to review correspondence randomly."
    },
    {
       "id":1519,
       "topic_id":1,
       "practice_test_id":5,
       "question":"Which of the following is/are true if a registered rep enters a chat room to discuss investment services?",
       "choice_a":"It is considered  retail communication",
       "choice_b":"It is subject to supervision by the firm",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"When a registered rep enters a chat room to discuss investment services, it is considered to be part of retail communication and is subject to appropriate firm supervision."
    },
    {
       "id":1520,
       "topic_id":1,
       "practice_test_id":6,
       "question":"According to SRO rules, under which of the following circumstances may an individual make a supervisory review of her own electronic communications?",
       "choice_a":"If the member is a sole proprietor with no other way of conducting a review",
       "choice_b":"If the member has fewer than 100 electronic communications per 60 day period",
       "choice_c":"If the member has fewer than 10 reps",
       "choice_d":"If a review is done on a monthly basis",
       "correct_answer":"A",
       "explanation":"Members may not make a supervisory review of their own individual electronic communications unless, because of their size or corporate structure, there is no other way to conduct the review.  A member who is a sole proprietor with no other employees fits this scenario."
    },
    {
       "id":1522,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Under FINRA rules, which of the following is/are considered retail communication?",
       "choice_a":"A public website",
       "choice_b":"A password protected website",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"FINRA rules state that all information posted on a Firm's website are deemed retail communication, including any information posted in password protected areas."
    },
    {
       "id":1523,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A registered rep sends an email to a prospect with the intent of gaining her as a client.  Which of the following is true?",
       "choice_a":"The email is correspondence and requires prior approval by the principal",
       "choice_b":"The email is correspondence and does not require prior approval by the principal",
       "choice_c":"The email is sales literature and requires prior approval by the principal",
       "choice_d":"The email is sales literature and does not require prior approval by the principal",
       "correct_answer":"B",
       "explanation":"An email that is sent to fewer than 25 prospective customers in a 30 day period is correspondence and does not require prior principal approval.  However, the firm is required to review a rep's correspondence."
    },
    {
       "id":1524,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following is/are true when  a rep sends electronic communications to the public?",
       "choice_a":"The rep has the same responsibilities as she would if she were speaking face to face with the client",
       "choice_b":"The rep must abide by firm policies regarding e-communications",
       "choice_c":"The same electronic communications sent to 100 existing customers is correspondence",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Member Conduct Rules are the same for all communications with the public.  In addition to SRO rules, the individual firms have policies in place regarding e-communications that the rep is required to adhere to."
    },
    {
       "id":1525,
       "topic_id":1,
       "practice_test_id":"",
       "question":"When a registered rep sends an instant message to a client, that instant message is:",
       "choice_a":"Advertising",
       "choice_b":"Sales literature",
       "choice_c":"Correspondence",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"An IM to an individual client is correspondence."
    },
    {
       "id":1526,
       "topic_id":1,
       "practice_test_id":1,
       "question":"An agent opens a new account for a client and enters a market order to buy 200 shares of WIDGET. At the end of the day, the agent turns in a new account form and a copy of the order ticket for approval by the supervisor. Which of the following is true?",
       "choice_a":"The agent\u0027s activities are not prohibited",
       "choice_b":"The agent needed approval for the new account prior to the execution of the first order",
       "choice_c":"The activity is prohibited; the agent must get prior approval for every order",
       "choice_d":"The activity is prohibited; new clients must pay for their first transaction in advance",
       "correct_answer":"B",
       "explanation":"Although prior approval from a supervisor is not required for every order, every new account must be approved by a supervisor prior to the execution of the first order."
    },
    {
       "id":1527,
       "topic_id":1,
       "practice_test_id":2,
       "question":"An agent is asked by a client to open an account and buy stock for the client's spouse. Which of the following is true?",
       "choice_a":"The agent is at risk if the stock declines",
       "choice_b":"This is a normal, acceptable practice",
       "choice_c":"The spouse must sign a trading authorization or else these actions are prohibited",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"In order to open a third party account (one party trading for another), a trading authorization must be signed by the owner of the account giving the third party the right to do so. Without a trading authorization, this would be a prohibited practice."
    },
    {
       "id":1528,
       "topic_id":1,
       "practice_test_id":3,
       "question":"In a sales presentation to a client regarding mutual funds, an agent states that if dividends and capital gains distributions are reinvested, the client should always be able to liquidate at a value higher than the original investment. Which of the following is correct?",
       "choice_a":"Due to dollar cost averaging, this is a legitimate statement",
       "choice_b":"The statement is fraudulent",
       "choice_c":"If the statement is contained in sales literature filed with and approved by the Administrator, it may be used",
       "choice_d":"The statement may be used if the broker-dealer is willing to make up any losses to the client",
       "correct_answer":"B",
       "explanation":"Guaranteeing a profit, regardless of the investment medium, is always considered fraudulent and is prohibited under the Act."
    },
    {
       "id":1529,
       "topic_id":1,
       "practice_test_id":4,
       "question":"An agent sells 2,000 shares of a $55 stock to a new client. Two weeks later, the stock is sold out of the client's account at a loss because the client could not pay for it. In this case the agent:",
       "choice_a":"Must rebate the clients losses",
       "choice_b":"Is not liable according to the USA",
       "choice_c":"May seek punitive damages from the client",
       "choice_d":"Did not make a reasonable inquiry as to the client\u0027s financial condition",
       "correct_answer":"D",
       "explanation":"Agents are required to determine the financial status of their customers."
    },
    {
       "id":1530,
       "topic_id":1,
       "practice_test_id":5,
       "question":"A new client approaches an agent regarding opening a new account but refuses to discuss his financial status. The agent should:",
       "choice_a":"Sell any type of securities",
       "choice_b":"Accept only unsolicited orders until more information is known",
       "choice_c":"Not open an account for this individual",
       "choice_d":"Sell only high-grade securities",
       "correct_answer":"B",
       "explanation":"An agent may not solicit orders from a client when no information about the client's financial status is known."
    },
    {
       "id":1531,
       "topic_id":1,
       "practice_test_id":6,
       "question":"An agent misrepresents the risks associated with U.S. Treasury bills, notes, and bonds. Under the Uniform Securities Act, which of the following would best describe the consequences?",
       "choice_a":"This is viewed as an unethical activity",
       "choice_b":"There are potential civil liabilities and a client can sue for damages",
       "choice_c":"There is no violation since the securities are issued by the U.S. government",
       "choice_d":"There are no civil liabilities because technically these are not considered securities",
       "correct_answer":"B",
       "explanation":"Misrepresenting the investment risks of a security could lead to civil liabilities as clients have the right to sue to recover their losses. U.S. Treasury bills, bonds, and notes are securities and the fact that they are exempt securities is irrelevant if misrepresentations are made."
    },
    {
       "id":1532,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An agent contacts a client and provides valid reasons why WIDGET Corporation shares represent an attractive purchase. He neglects to mention that the CFO has just resigned and that WIDGET is under investigation by a number of regulatory authorities. The client makes a purchase of WIDGET shares. Which of the following is false?",
       "choice_a":"The agent faces no civil liabilities since he gave valid reasons why the client should purchase WIDGET stock",
       "choice_b":"The client could recover the full purchase price paid for WIDGET stock",
       "choice_c":"The agent has committed a civil violation",
       "choice_d":"The client may file a lawsuit in state court",
       "correct_answer":"A",
       "explanation":"A purchaser has the right to bring a civil lawsuit if they believe the seller of the securities omits or makes an untrue statement concerning a material fact. This is a civil violation of the act. The client has the right to recover the full purchase price plus interest plus court cost and attorney fees."
    },
    {
       "id":1533,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Pete is an agent for SIA Brokerage. Pete spends a lot of his free time playing video games with his on line friend, Victor. They notice an ad in a magazine advertising franchises that provide an online gaming business. Pete has always wanted to start a business to supplement his income from selling securities, so he and Victor form a corporation to buy the online gaming franchise. Without telling his employer, Pete sells small amounts of stock in his company to friends and neighbors to help get the enterprise started. Which of the following is true?",
       "choice_a":"This is an unacceptable practice since the venture is likely to fail and the investors will lose their money",
       "choice_b":"This is an unacceptable practice since these securities transactions are not recorded on the books of Pete\u0027s broker-dealer",
       "choice_c":"This is an acceptable practice as long as Pete does not mention his broker-dealer\u0027s name in connection with the transactions",
       "choice_d":"This is an acceptable practice because it is a small amount of stock sold to friends and neighbors of Pete and Victor",
       "correct_answer":"B",
       "explanation":"It is considered an unacceptable practice for an agent to effect securities transactions that are not recorded on the books and records of the employer. Such transactions could involve violations of the Uniform Securities Act. Before engaging in such transactions, agents should notify their broker-dealers for permission."
    },
    {
       "id":1534,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Jane has never invested in securities before, preferring to keep her funds in FDlC-insured accounts and CDs. Stone Cold, an agent for Stickem B/D, is attempting to convince Jane to invest in mutual funds. Jane says to him, \u0022My main concern is the safety of my money. How do I know these mutual funds are safe?\u0022 Mr. Cold responds, \u0022These products are regulated by the Securities and Exchange Commission and state securities laws.\u0022 Which of the following is true?",
       "choice_a":"This is a misleading statement because it implies that being regulated assures the safety of the investment",
       "choice_b":"This is misleading because mutual funds are federal covered securities and are not registered at the state level",
       "choice_c":"This is not misleading as long as the investment is suitable for Jane",
       "choice_d":"This is not misleading because, taken literally, the statement is true",
       "correct_answer":"A",
       "explanation":"Even though Stone Cold's statement is true when examined in isolation, it is misleading in context, since it implies that the regulators assure the safety of the investments that they regulate. Regarding the antifraud sections of state securities laws apply to all securities, including exempt and federal covered securities."
    },
    {
       "id":1535,
       "topic_id":1,
       "practice_test_id":6,
       "question":"SIA Company is registered as both a broker-dealer and an investment adviser. As a broker-dealer, the firm makes a market in Widget stock. SIA believes that this stock would be a very good investment for one of its advisory clients and would like to sell the client some stock from its market-maker account. Which of the following is true?",
       "choice_a":"SIA may sell the stock to the client as long as the security is suitable for the account",
       "choice_b":"SIA may sell the stock to the client as long as it does not charge a commission for the transaction",
       "choice_c":"SIA may sell the stock to the client as long as it discloses, prior to the completion of the transaction, that it is acting as a principal and it obtains the client\u0027s written consent",
       "choice_d":"SIA is not permitted to effect this transaction under any circumstances due to the conflict of interest",
       "correct_answer":"C",
       "explanation":"An investment adviser that wishes to act as principal for its own account must 1) disclose the capacity in which it is acting prior to the completion of the transaction, and 2) obtain the client's written consent."
    },
    {
       "id":1536,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Amber is a client of Pete, an agent for Rocksolid Brokerage, Inc. Amber and Pete are also close personal friends. Amber placed an order for a new issue of stock that Rock-solid is underwriting. Due to a mix-up in her employer's accounting department, Amber does not have enough money to pay for the stock on the settlement date. Pete deposits enough of his own funds in Amber's account to cover the shortfall, which Amber pays back when her employer's payroll problem is resolved. Which of the following is true?",
       "choice_a":"This is an acceptable practice as long as the loan is repaid within a reasonable period",
       "choice_b":"This is an acceptable practice because Pete extended the loan as a friend and not as an agent of Rocksolid",
       "choice_c":"This is not an acceptable practice unless Amber pays Pete a reasonable rate of interest on the loan and has the permission of the broker-dealer",
       "choice_d":"This is not an acceptable practice since agents should not engage in the practice of lending money or securities to customers",
       "correct_answer":"D",
       "explanation":"It is considered an unethical practice for us to engage in the practice of lending or borrowing money or securities from a customer. This can lead to conflicts of interest and may be a violation of federal rules regarding the purchase of securities on credit."
    },
    {
       "id":1537,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Molly Hatchet, an agent for a broker-dealer, receives a call from a client who submits an order to sell 500 shares of stock at the market. After hanging up the phone, the agent notices the market turning around and decides to hold the order for a while. After half an hour, the market suddenly reverses again and Molly executes the customer's order at a loss. Which of the following is true?",
       "choice_a":"This is an unethical practice because the agent did not follow the client\u0027s instructions",
       "choice_b":"This is an unethical practice because the client lost money",
       "choice_c":"This is not an unethical practice since the agent was acting in good faith",
       "choice_d":"This is not an unethical practice as long as the agent reimburses the client for the loss",
       "correct_answer":"A",
       "explanation":"The agent failed to follow the client's instructions. This is an unethical practice under the USA even if the agent believes in good faith that she was acting in her client's best interests."
    },
    {
       "id":1538,
       "topic_id":1,
       "practice_test_id":"",
       "question":"If an agent receives a written complaint from a client, the agent:",
       "choice_a":"Must forward the complaint to a supervisor",
       "choice_b":"May use his or her own discretion in handling the complaint",
       "choice_c":"May disregard the complaint",
       "choice_d":"May no longer effect securities transactions",
       "correct_answer":"A",
       "explanation":"An agent must forward all written complaints to a supervisor."
    },
    {
       "id":1539,
       "topic_id":1,
       "practice_test_id":1,
       "question":"If an agent transfers a customer's securities into the firm's trading account, the agent would be guilty of:",
       "choice_a":"Parking",
       "choice_b":"Commingling",
       "choice_c":"Freeriding",
       "choice_d":"Backing away",
       "correct_answer":"B",
       "explanation":"Under the Uniform Securities Act, agents are prohibited from commingling client securities with the agent's or firm's securities."
    },
    {
       "id":1540,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Which of the following is correct regarding the bond that is required to be posted under the Uniform Securities Act as a condition for registration?",
       "choice_a":"It protects clients against losses",
       "choice_b":"It protects against brokerage firm fraud",
       "choice_c":"It is used to cover the costs of possible legal actions",
       "choice_d":"Property can be accepted in lieu of a bond",
       "correct_answer":"C",
       "explanation":"A bond may be required by an Administrator to cover possible legal costs arising from violations of the Uniform Securities Act. The Administrator may accept cash or securities in lieu of a bond but property may not be accepted. This type of bond is sometimes called a surety bond as opposed to a fidelity bond, which protects a brokerage firm from employee fraud, such as embezzlement."
    },
    {
       "id":1541,
       "topic_id":1,
       "practice_test_id":3,
       "question":"Which of the following would be a violation of the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Buying and selling the same stock on the same day on different exchanges </li><li> Offering shares of an unregistered nonexempt security to exactly 14 clients </li><li> Offering a Canadian Government bond to a resident of a state in which the agent is not registered",
       "choice_a":"II only",
       "choice_b":"I and II only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"C",
       "explanation":"It is a violation of the Act to offer unregistered nonexempt securities to one client, let alone fourteen. Also, the sale of exempt securities in a state does not exempt the agent from being registered in that state."
    },
    {
       "id":1542,
       "topic_id":1,
       "practice_test_id":4,
       "question":"Which of the following is not correct regarding the sharing of profits and losses in a client's account by an agent?",
       "choice_a":"The client\u0027s consent is required",
       "choice_b":"The consent of the agent\u0027s employer is required",
       "choice_c":"The sharing is strictly prohibited",
       "choice_d":"The agent\u0027s profits and losses must be in proportion to the percentage of his or her contribution",
       "correct_answer":"C",
       "explanation":"If an agent opens a joint account with a client, the agent may share in the profits, proportionate to his or her investment, provided employer and client approval was obtained."
    },
    {
       "id":1543,
       "topic_id":1,
       "practice_test_id":5,
       "question":"The Uniform Securities Act prohibits which of the following?",
       "choice_a":"Soliciting orders for unregistered nonexempt securities",
       "choice_b":"Maintaining discretionary accounts",
       "choice_c":"Charging extraordinary commissions on certain transactions",
       "choice_d":"All of the choices listed",
       "correct_answer":"A",
       "explanation":"Soliciting orders for unregistered nonexempt securities is prohibited by the Act. The Act allows discretionary accounts and charging for services provided by broker-dealers and their agents."
    },
    {
       "id":1544,
       "topic_id":1,
       "practice_test_id":6,
       "question":"An agent opens a new account for a client and enters a market order to buy 200 shares of WIDGET. At the end of the day, the agent turns in a new account form and a copy of the order ticket for approval by the supervisor. Which of the following is true?",
       "choice_a":"The agent\u0027s activities are not prohibited",
       "choice_b":"The agent needed approval for the new account prior to the execution of the first order",
       "choice_c":"The activity is prohibited; the agent must get prior approval for every order",
       "choice_d":"The activity is prohibited; new clients must pay for their first transaction in advance",
       "correct_answer":"B",
       "explanation":"Although prior approval from a supervisor is not required for every order, every new account must be approved by a supervisor prior to the execution of the first order."
    },
    {
       "id":1545,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An agent is asked by a client to open an account and buy stock for the client's spouse. Which of the following is true?",
       "choice_a":"The agent is at risk if the stock declines",
       "choice_b":"This is a normal, acceptable practice",
       "choice_c":"The spouse must sign a trading authorization or else these actions are prohibited",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"In order to open a third party account (one party trading for another), a trading authorization must be signed by the owner of the account giving the third party the right to do so. Without a trading authorization, this would be a prohibited practice."
    },
    {
       "id":1546,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An agent who knowingly gives a fictitious quote to a client:",
       "choice_a":"Must execute at that price",
       "choice_b":"Has committed a felony",
       "choice_c":"Has committed a fraudulent and misleading act",
       "choice_d":"All of the choices listed",
       "correct_answer":"C",
       "explanation":"Giving a fictitious quote or deliberately overstating the value of a client's account is a misleading and fraudulent practice."
    },
    {
       "id":1547,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The term churning is defined as:",
       "choice_a":"The sale of an unregistered non-exempt security",
       "choice_b":"Trading one security for another in a client\u0027s account",
       "choice_c":"Excessive activity in a client\u0027s account",
       "choice_d":"Trading done solely to make it appeal-that there is activity in the security",
       "correct_answer":"C",
       "explanation":"Churning is defined as generating excessive activity in a client's account, usually for the sole purpose of generating commissions."
    },
    {
       "id":1548,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An agent overhears that the chairman of a large manufacturing firm may be ousted because of erratic social behavior. The agent decides to call all clients who own shares of the manufacturing corporation and tell them to liquidate their position. Which of the following is true?",
       "choice_a":"The rumor may not have an effect on the market and the agent should wait to get a better feel for the situation",
       "choice_b":"This action was based on material inside information and the agent must inform all clients of this fact",
       "choice_c":"This action constitutes a prohibited use of a rumor to induce a purchase or sale",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"Liquidating client positions based on hearsay constitutes the prohibited use of a rumor to induce a transaction. If this were material inside information, the only step the agent could take would be to notify his or her supervisor."
    },
    {
       "id":1549,
       "topic_id":1,
       "practice_test_id":2,
       "question":"In a sales presentation to a client regarding mutual funds, an agent states that if dividends and capital gains distributions are reinvested, the client should always be able to liquidate at a value higher than the original investment. Which of the following is correct?",
       "choice_a":"Due to dollar cost averaging, this is a legitimate statement",
       "choice_b":"The statement is fraudulent",
       "choice_c":"If the statement is contained in sales literature filed with and approved by the Administrator, it may be used",
       "choice_d":"The statement may be used if the broker-dealer is willing to make up any losses to the client",
       "correct_answer":"B",
       "explanation":"Guaranteeing a profit, regardless of the investment medium, is always considered fraudulent and is prohibited under the Act."
    },
    {
       "id":1550,
       "topic_id":1,
       "practice_test_id":3,
       "question":"When attempting to make a sale, a client offers resistance. The agent may:",
       "choice_a":"Offer the prospect a guarantee against loss",
       "choice_b":"Attempt to overcome the objections",
       "choice_c":"Point out that the securities have been approved by the Administrator",
       "choice_d":"None of the choices listed",
       "correct_answer":"B",
       "explanation":"In attempting to make a sale, the agent may try to overcome the client's objections. However, guaranteeing the client against loss or stating that the securities have been approved by the Administrator would be considered fraudulent and prohibited practices."
    },
    {
       "id":1551,
       "topic_id":1,
       "practice_test_id":4,
       "question":"Which of the following would be dishonest and unethical practices if committed by an agent or investment adviser representative? <liI>Telling clients that exchange listing of a security is anticipated, without knowledge of the truth of such a statement </li><li> Providing inaccurate market quotations, such as a bond is yielding 10% when it really is yielding 1% </li><li>Failing to inform a client of larger than ordinary commissions on a transaction </li><li>Compensating an investment adviser based on a share of capital gains </li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I, II, and III only",
       "choice_c":"II, III, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the items listed would be considered dishonest and unethical."
    },
    {
       "id":1552,
       "topic_id":1,
       "practice_test_id":5,
       "question":"Which of the following are prohibited practices? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Entering a discretionary order on behalf of a client while you are waiting for the U.S. Postal Service to deliver a letter from the client containing written authorization </li><li>Accepting orders from a client's secretary without written third-party authorization </li><li>Recommending securities without regard to the client's financial sources  </li><li>Quoting a price that is unrelated to the current market </li></ol>",
       "choice_a":"IV only",
       "choice_b":"I and II only",
       "choice_c":"I, II, and III only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the items listed would be considered prohibited practices."
    },
    {
       "id":1553,
       "topic_id":1,
       "practice_test_id":6,
       "question":"One of your clients is an elderly retired woman living on a small pension plus Social Security. She has been given a tip on a stock with a thin market but with good possibilities of appreciation. She is considering purchasing this stock and wants your opinion. What should you do? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Tell her that the stock doesn't seem to be suitable according to her financial resources </li><li>Tell her that even if there is the possibility of price appreciation, the thin market is a high risk </li><li>Tell her it probably would be a good buy for her to help increase her retirement income</li></ol>",
       "choice_a":"II only",
       "choice_b":"III only",
       "choice_c":"I and II only",
       "choice_d":"II and III only",
       "correct_answer":"C",
       "explanation":"Thin markets exist when there are few buyers and sellers, creating a lack of liquidity in the security. This type of security is subject to wide price fluctuations over short periods of time and would not be suitable to elderly retired individuals on fixed incomes."
    },
    {
       "id":1554,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A new client approaches an agent regarding opening a new account but refuses to discuss his financial status. The agent should:",
       "choice_a":"Sell any type of securities",
       "choice_b":"Accept only unsolicited orders until more information is known",
       "choice_c":"Not open an account for this individual",
       "choice_d":"Sell only high-grade securities",
       "correct_answer":"B",
       "explanation":"An agent may not solicit orders from a client when no information about the client's financial status is known."
    },
    {
       "id":1555,
       "topic_id":1,
       "practice_test_id":"",
       "question":"SIA is an investment advisory firm. SIA is creating a new standard contract for its advisory clients. Which of the following clauses should not appear in the contract?",
       "choice_a":"The Adviser will provide the following services to the Client: management of the client\u0027s portfolio on a discretionary basis, quarterly written summaries of account activity, and quarterly personal review of the Client\u0027s assets under management of the Adviser",
       "choice_b":"The Client agrees to pay a quarterly fee to the Adviser consisting of i) .25% times the value of the portfolio at the end of each quarter, plus ii) 2% of any increase in the value of the portfolio compared to the end of the previous quarter. Part ii) of the fee will not be assessed if the portfolio declines in value",
       "choice_c":"The Adviser may not assign this contract to another party without the prior written consent of the Client",
       "choice_d":"If any partner leaves the business of the Adviser, or if the Adviser adds any partner, the Adviser will notify the Client within a reasonable period, but not more than ten business days after any such change",
       "correct_answer":"B",
       "explanation":"An investment adviser may not charge a fee which is based upon a share of the capital gains in the account or a share in the capital appreciation of the funds in the account. That part of Micro's fee that consists of 2% of any increase in the value of the portfolio each quarter would not be permitted."
    },
    {
       "id":1556,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Jane would like to purchase one share of stock for her newborn niece. Her broker-dealer charges a specified minimum ticket charge for small orders. Which of the following should be disclosed to Jane?",
       "choice_a":"Common stock is not a suitable gift for children since there is no guarantee it will pay a dividend",
       "choice_b":"It is not possible to purchase one share of stock; the minimum amount is 100 shares",
       "choice_c":"The commission charged for this transaction could be unusually large as a percentage of the offering price",
       "choice_d":"Jane will need to obtain permission from her niece\u0027s parents to purchase the stock for a minor",
       "correct_answer":"C",
       "explanation":"It is considered fraudulent for a broker-dealer to fail to notify a client of larger than ordinary commissions or costs. Purchases or sales of a small amount of securities can often lead to larger than ordinary costs because of minimum charges assessed for transactions. This can lead to commissions that are large as a percentage of the purchase price. It is not illegal to assess such charges, but it is illegal not to inform the client about them."
    },
    {
       "id":1557,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A person who sells securities in violation of state securities law is civilly liable for:",
       "choice_a":"Principal and interest",
       "choice_b":"Court costs",
       "choice_c":"Attorney\u0027s fees",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"A person who sells securities in violation of state securities law is civilly liable for all of the items listed."
    },
    {
       "id":1558,
       "topic_id":1,
       "practice_test_id":1,
       "question":"Which of the following is not a prohibited practice under the Uniform Securities Act?",
       "choice_a":"An agent making an untrue statement of a material fact",
       "choice_b":"An agent omitting a material fact because the agent did not have time to cover everything in a short presentation",
       "choice_c":"An agent deliberately failing to follow a client\u0027s instructions",
       "choice_d":"An agent actively soliciting orders in unregistered exempt securities",
       "correct_answer":"D",
       "explanation":"If a security is exempt, it does not have to be registered. All other choices would be considered prohibited practices under the Uniform Securities Act."
    },
    {
       "id":1559,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Which of the following is not true when a cease and desist order has been issued?",
       "choice_a":"It is enacted when or before a violation has occurred",
       "choice_b":"It must have been issued by the SEC",
       "choice_c":"It must have been authorized by the Administrator",
       "choice_d":"It may be issued against anyone who is engaging in activities prohibited by the Uniform Securities Act",
       "correct_answer":"B",
       "explanation":"Administrators will authorize a cease and desist order if they believe a violation of the Act is about to occur or if the Act has already been violated. The order does not have to come from the SEC."
    },
    {
       "id":1560,
       "topic_id":1,
       "practice_test_id":3,
       "question":"Which of the following transactions are exempt under the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A secondary market transaction in an over-the-counter stock of an issuer that is required to file annual 10-K reports with the SEC </li><li>A primary offering of an OTC stock sold in one state only  </li><li>A secondary market transaction executed by a broker-dealer to fill an unsolicited customer order </li><li>A secondary market sale to a mutual fund </li></ol>",
       "choice_a":"II only",
       "choice_b":"I and III only",
       "choice_c":"I, III, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Non-issuer (secondary market) transactions that are exempt include those involving:  securities of issuers subject to the registration and reporting requirements of the Securities Exchange Act of 1934, orders executed through a registered broker-dealer on an unsolicited basis, sales to institutional investors such as banks, insurance companies, and investment companies"
    },
    {
       "id":1561,
       "topic_id":1,
       "practice_test_id":4,
       "question":"A client desires a portfolio of income producing securities. An agent who has discretionary authority purchases shares of an aggressive growth fund for the client. The agent has:",
       "choice_a":"Committed a fraudulent act",
       "choice_b":"Committed an unauthorized act",
       "choice_c":"Acted inappropriately",
       "choice_d":"Acted properly",
       "correct_answer":"C",
       "explanation":"A client who desires income is looking for an investment that is high yielding (with reference to dividends and/or interest) and is relatively safe. A growth fund invests in companies that are expected to rise in market value relatively quickly. A majority of the earnings are retained by the corporation and not paid out in the form of dividends. Growth stocks can also be unstable and speculative. Therefore, the agent acted inappropriately with reference to the client's wishes and the investment was unsuitable. To be fraudulent, the action generally must involve some intent to deceive."
    },
    {
       "id":1562,
       "topic_id":1,
       "practice_test_id":5,
       "question":"Under the Uniform Securities Act, the term offer to sell would include:",
       "choice_a":"The delivery of a dividend of stock without the payment of any compensation",
       "choice_b":"The attempt to dispose of a security for value",
       "choice_c":"The exercise of warrants previously sold by the corporation to an individual",
       "choice_d":"The tender of convertible securities as a result of an offer made exclusively to existing stockholders by another corporation",
       "correct_answer":"B",
       "explanation":"The term offer to sell includes every attempt or offer to dispose of, or the solicitation of an offer to buy, a security or interest in a security for value."
    },
    {
       "id":1563,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Pete is an agent for a broker-dealer in North Carolina. Pete may not do which of the following?",
       "choice_a":"Solicit orders for municipal bonds issued by a North Carolina school district",
       "choice_b":"Accept unsolicited orders for common stock in the Widget Corporation if the stock is not registered in North Carolina",
       "choice_c":"Solicit orders for the Widget Corporation bonds, which are registered in North Carolina",
       "choice_d":"Solicit orders for the Widget Corporation preferred stock if the stock is not registered in North Carolina",
       "correct_answer":"D",
       "explanation":"Agents may not solicit orders for unregistered, nonexempt securities. Pete may solicit orders as described because municipal bonds are exempt from registration. The fact that the order was unsolicited provides an exemption for the transaction. Securities that are registered can always be sold. Only the securities that are neither registered nor exempt may not be solicited."
    },
    {
       "id":1564,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A New York Stock Exchange-listed corporation has 600,000 shares of stock outstanding and 1,000,000 shares authorized. The corporation declares a 50% stock dividend. The new securities would be registered by:",
       "choice_a":"Notification",
       "choice_b":"Qualification",
       "choice_c":"Coordination",
       "choice_d":"None of the choices listed",
       "correct_answer":"D",
       "explanation":"Securities listed on the New York Stock Exchange are federal covered securities and are not subject to state registration or review."
    },
    {
       "id":1565,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Pete is an agent for SIA Securities. One of his clients, Mr. Butts, works for the research department at Widget, Inc. Until now, Mr. Butts has invested in bond mutual funds and conservative stock funds. Today he called Pete and places an order to buy 1000 Call contracts. Which of the following is true?",
       "choice_a":"Pete must accept the order since he may not knowingly fail to follow client instructions",
       "choice_b":"Pete should bring this order to the attention of a supervisor immediately, since it may indicate insider trading",
       "choice_c":"Pete must refuse to accept the order, since investors may not purchase stock in companies for which they work",
       "choice_d":"Pete must accept this order since it is unsolicited",
       "correct_answer":"B",
       "explanation":"It is illegal for an agent to use inside information. It may also be a violation of the USA to assist an investor who is using inside information. A situation like this should be treated as a \u0022red flag\u0022 that should be brought to the attention of a supervisor."
    },
    {
       "id":1566,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Amber is a client of Pete, an agent for SIA Brokerage, Inc. Amber and Pete are also close personal friends. Amber placed an order for a new issue of stock that SIA is underwriting. Due to a mix-up in her employer's accounting department, Amber does not have enough money to pay for the stock on the settlement date. Pete deposits enough of his own funds in Amber's account to cover the shortfall, which Amber pays back when her employer's payroll problem is resolved. Which of the following is true?",
       "choice_a":"This is an acceptable practice as long as the loan is repaid within a reasonable period",
       "choice_b":"This is an acceptable practice because Pete extended the loan as a friend and not as an agent of SIA",
       "choice_c":"This is not an acceptable practice unless Amber pays Pete a reasonable rate of interest on the loan and has the permission of the broker-dealer",
       "choice_d":"This is not an acceptable practice since agents should not engage in the practice of lending money or securities to customers",
       "correct_answer":"D",
       "explanation":"It is considered an unethical practice for agents  to engage in the practice of lending or borrowing money or securities from a customer. This can lead to conflicts of interest and may be a violation of federal rules regarding the purchase of securities on credit."
    },
    {
       "id":1567,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A client lost money on an investment. His agent tells the client that he will assure him that he makes money on the next trade to make up for the losses he incurred. Which of the following statements is correct concerning the action taken by the agent?",
       "choice_a":"This is allowed if the agent\u0027s supervisor approves the transaction",
       "choice_b":"This is allowed if the client is permitted to buy oversubscribed issues",
       "choice_c":"This is allowed if the client has a discretionary account",
       "choice_d":"This is a considered an unethical business practice",
       "correct_answer":"D",
       "explanation":"If an agent or broker-dealer guarantees a customer against a loss it is considered an unethical business practice."
    },
    {
       "id":1568,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A client is so pleased that they tell their agent that they can keep 5% of any gains in his account from now on, in addition to the commissions that he usually pays. Which of the following is true?",
       "choice_a":"This is acceptable as long as the agreement in writing",
       "choice_b":"This is acceptable only if the Broker Dealer is registered as an investment adviser",
       "choice_c":"This is not acceptable unless Broker Dealer foregoes its usual commission charges",
       "choice_d":"This is not acceptable as it is considered to be sharing in the client\u0027s profits",
       "correct_answer":"D",
       "explanation":"Sharing in the profits and/or losses in a client's account is generally not permitted There is an exception if the client and the agent have a joint account, the client and the broker-dealer consent to the arrangement in writing, and profits and losses are shared in proportion to the capital that each contributed to the account."
    },
    {
       "id":1569,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following is a violation of the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Trades for the purpose of misrepresenting the actual trading volume of a stock </li><li>Failure to state all known facts </li><li> Inducing trades for the purpose of increasing commissions</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"B",
       "explanation":"Failure to state all known facts is not a violation of the Uniform Securities Act. Failure to state all material facts would be a violation. A material fact is information an investor would need in order to make a sound investment decision."
    },
    {
       "id":1570,
       "topic_id":1,
       "practice_test_id":2,
       "question":"A Client gives control of his brokerage account to his brother by giving him a handwritten note giving him trading authorization over the account. According to the Uniform Securities Act:",
       "choice_a":"This is too informal",
       "choice_b":"A person cannot grant a temporary authorization to another person if they are not related",
       "choice_c":"Because the authorization is in writing it is acceptable",
       "choice_d":"Only clients who prepay their fees can grant a third party trading authorization",
       "correct_answer":"C",
       "explanation":"This arrangement would be referred to as a third party trading authorization. The standard requirement is that it be in written form. The handwritten note from Mr. Daniels would be acceptable."
    },
    {
       "id":1571,
       "topic_id":1,
       "practice_test_id":3,
       "question":"A client has an objective of income only. Under the Uniform Securities Act, an agent who has discretionary authorization in the account could:",
       "choice_a":"Not buy a speculative stock without the client\u0027s approval",
       "choice_b":"Speculate with 5% of the client\u0027s assets",
       "choice_c":"Speculate with any amount that could be reasonably justified",
       "choice_d":"Not purchase equities in the account",
       "correct_answer":"A",
       "explanation":"Regardless of the account size, any amount of speculative investing would be inappropriate in an account with an objective of income only."
    },
    {
       "id":1572,
       "topic_id":1,
       "practice_test_id":4,
       "question":"Which of the following investment advisory practices is permissible?",
       "choice_a":"Assignment of the contract without consent",
       "choice_b":"Advisement of management changes",
       "choice_c":"Partaking in capital gains",
       "choice_d":"All of the choices listed",
       "correct_answer":"B",
       "explanation":"It is unlawful for an investment adviser to enter into or renew an investment advisory contract unless it provides, in writing, that there will be no partaking in capital gains or capital appreciation of the client's account, no assignment of the contract will be made without consent, and provides for notification of management changes within a reasonable time after the change."
    },
    {
       "id":1573,
       "topic_id":1,
       "practice_test_id":5,
       "question":"Bonds must be posted by all of the following except:",
       "choice_a":"Investment advisers who do not have discretionary authority or custody of client funds or securities",
       "choice_b":"Investment advisers who have discretionary authority but do not have custody of client funds or securities",
       "choice_c":"Broker-dealers who do not have discretionary authority",
       "choice_d":"Broker-dealers who have discretionary authority",
       "correct_answer":"A",
       "explanation":"Broker-dealers customarily have custody of client funds and securities and are required by the Act to post a bond. Investment advisers must post a bond only if they have discretionary authority over client accounts or have custody of client funds or securities. A bond guarantees that funds are available so that legal fees and fines can be met if assessed against a broker-dealer or investment adviser."
    },
    {
       "id":1574,
       "topic_id":1,
       "practice_test_id":6,
       "question":"An agent of a broker-dealer has a business relationship with an agent of another broker-dealer. They both own a large quantity of an on line gaming stock. Which of the following statements is correct if both agents buy and sell large amounts of the stock to increase its trading volume?",
       "choice_a":"This action is permissible if the agents receive prior written approval of their broker-dealers",
       "choice_b":"This action is not permissible since the agents are employed by two different broker-dealers",
       "choice_c":"This action may be considered market manipulation",
       "choice_d":"This action is considered a matched sale and is an allowable type of securities transaction",
       "correct_answer":"C",
       "explanation":"The action by the two agents may be considered manipulation. The agents may not effect transactions to create the false or misleading appearance of trading volume."
    },
    {
       "id":1575,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An agent contacts a client and provides seven valid reasons why SIA Corporation shares represent an attractive purchase. He neglects to mention that the Chief Financial Officer has just resigned and that SIA is under investigation by a number of regulatory authorities. The client makes a purchase of SIA shares. Which of the following is false?",
       "choice_a":"The agent faces no civil liabilities since he gave valid reasons why the client should purchase SIA stock",
       "choice_b":"The client could recover the full purchase price paid for SIA stock",
       "choice_c":"The agent has committed a civil violation",
       "choice_d":"The client may file a lawsuit in state court",
       "correct_answer":"A",
       "explanation":"A purchaser has the right to bring a civil lawsuit if they believe the seller of the securities omits or makes an untrue statement concerning a material fact. This is a civil violation of the act. The client has the right to recover the full purchase price + interest + court cost and attorney fees."
    },
    {
       "id":1576,
       "topic_id":1,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, an advertisement placed in a periodical that offers a security for sale is considered an offer in:",
       "choice_a":"The state in which the purchaser resides",
       "choice_b":"The state in which the periodical is published",
       "choice_c":"All states in which vendors are located",
       "choice_d":"All states in which the periodical is distributed",
       "correct_answer":"B",
       "explanation":"The Uniform Securities Act provides that an advertisement in a regular newspaper, magazine, or periodical is not an offer in any state other than the state of publication. An offer to sell made on radio, television, or other electronic communication is made in the state where the broadcast studio or originating source of the transmission is located."
    },
    {
       "id":1577,
       "topic_id":1,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, if an employee of an issuer is soliciting employees of that issuer for the purpose of selling securities, which of the following statements is true?",
       "choice_a":"The employee could receive commissions without being registered as an agent",
       "choice_b":"The employee would never be considered an agent of the issuer",
       "choice_c":"The employee would be considered an agent if she received commissions or other remuneration",
       "choice_d":"If the employee was an officer or director of the issuer she could receive commissions and would not be considered an agent",
       "correct_answer":"C",
       "explanation":"Any employee of an issuer soliciting employees of that issuer for the purpose of selling securities would be considered an agent of the issuer if the employee received commissions or other remuneration (such as a bonus based on securities sales)."
    },
    {
       "id":1578,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Jane has never invested in securities before, preferring to keep her funds in FDlC-insured accounts and CDs. Pete, an agent for SIA Brokerage, is attempting to convince Jane to invest in mutual funds. Jane says to him, \u0022My main concern is the safety of my money. How do I know these mutual funds are safe?\u0022 Pete responds, \u0022These products are regulated by the Securities and Exchange Commission and state securities laws.\u0022 Which of the following is true?",
       "choice_a":"This is a misleading statement because it implies that being regulated assures the safety of the investment",
       "choice_b":"This is misleading because mutual funds are federal covered securities and are not registered at the state level",
       "choice_c":"This is not misleading as long as the investment is suitable for Jane",
       "choice_d":"This is not misleading because, taken literally, the statement is true",
       "correct_answer":"A",
       "explanation":"Even though Pete's statement is true when examined in isolation, it is misleading in context, since it implies that the regulators assure the safety of the investments that they regulate. Note that the antifraud sections of state securities laws apply to all securities, including exempt and federal covered securities."
    },
    {
       "id":1579,
       "topic_id":1,
       "practice_test_id":"",
       "question":"SIA Company is registered as both a broker-dealer and an investment adviser. As a broker-dealer, the firm makes a market in WIDGET stock. SIA believes that this stock would be a very good investment for one of its advisory clients and would like to sell the client some stock from its market-maker account. Which of the following is true?",
       "choice_a":"SIA may sell the stock to the client as long as the security is suitable for the account",
       "choice_b":"SIA may sell the stock to the client as long as it does not charge a commission for the transaction",
       "choice_c":"SIA may sell the stock to the client as long as it discloses, prior to the completion of the transaction, that it is acting as a principal and it obtains the client\u0027s written consent",
       "choice_d":"SIA is not permitted to effect this transaction under any circumstances due to the conflict of interest",
       "correct_answer":"C",
       "explanation":"An investment adviser that wishes to act as principal for its own account must 1) disclose the capacity in which it is acting prior to the completion of the transaction, and 2) obtain the client's written consent."
    },
    {
       "id":1580,
       "topic_id":1,
       "practice_test_id":1,
       "question":"A client is traveling and would like their investment adviser representative to pay some personal bills while she is away. Under the Uniform Securities Act, such an activity <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Should be backed up in writing </li><li>Constitutes custody </li><li>Falls outside the scope of securities market regulations</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"B",
       "explanation":"When an investment adviser has access to customer funds and securities, custody exists. Investment advisers would not normally pay personal bills such as rent, credit card, or cable television on behalf of their clients. Written authorization is required for this type of activity and usually is referred to as full discretionary authority. Custody arrangements are covered by securities regulations."
    },
    {
       "id":1581,
       "topic_id":1,
       "practice_test_id":2,
       "question":"An offer to buy that is unsolicited would include:",
       "choice_a":"A person purchasing securities after receiving a prospectus in the mail",
       "choice_b":"A person purchasing securities after reading a tombstone advertisement",
       "choice_c":"Neither of the choices listed",
       "choice_d":"Both of the choices listed",
       "correct_answer":"B",
       "explanation":"A tombstone advertisement is usually placed by the underwriting syndicate. It is an announcement used to acquaint the public with a distribution of securities. It is not used to solicit orders for the purchase or sale of securities. There is a caveat (disclaimer) that is usually placed at the top of the tombstone which states that the announcement appears as a matter of record only and is not to be considered a solicitation. (2-2)"
    },
    {
       "id":1582,
       "topic_id":1,
       "practice_test_id":3,
       "question":"The definition of churning is:",
       "choice_a":"Delivery of an excessive amount of securities before settlement date",
       "choice_b":"Buying a security on one exchange and selling it on another",
       "choice_c":"Selling a security for a loss and buying it back within 30 days",
       "choice_d":"Excessive activity in a client\u0027s account",
       "correct_answer":"D",
       "explanation":"Churning is defined as excessive trading activity in an account, with particular attention paid to buy and sell transactions which are in conflict with the financial objectives of the client."
    },
    {
       "id":1583,
       "topic_id":1,
       "practice_test_id":4,
       "question":"A client purchases $15,000 worth of a thinly traded stock. Three weeks later the stock is worth $5,000 and the client sells the stock at a loss. The agent tells the client that he will be allowed to purchase shares of a new issue that is oversubscribed to make up for the $10,000 loss. Which of the following statements is correct concerning the action taken by the agent?",
       "choice_a":"This is allowed if the agent\u0027s supervisor approves the transaction",
       "choice_b":"This is allowed if the client is permitted to buy oversubscribed issues",
       "choice_c":"This is allowed if the client has a discretionary account",
       "choice_d":"This is a considered an unethical business practice",
       "correct_answer":"D",
       "explanation":"If an agent or broker-dealer guarantees a customer against a loss it is considered an unethical business practice. The fact that the client might have a discretionary account or a supervisor approved the transaction is irrelevant."
    },
    {
       "id":1584,
       "topic_id":1,
       "practice_test_id":5,
       "question":"Molly, an agent for a broker-dealer, receives a call from a client who submits an order to sell 1500 shares of stock at the market. After hanging up the phone, the agent notices the market turning around and decides to hold the order for a while. After an hour, the market suddenly reverses again and Molly executes the customer's order at a large loss. Which of the following is true?",
       "choice_a":"This is an unethical practice because the agent did not follow the client\u0027s instructions",
       "choice_b":"This is an unethical practice because the client lost money",
       "choice_c":"This is not an unethical practice since the agent was acting in good faith",
       "choice_d":"This is not an unethical practice as long as the agent reimburses the client for the loss",
       "correct_answer":"A",
       "explanation":"The agent failed to follow the client's instructions. This is an unethical practice under the USA even if the agent believes in good faith that she was acting in her client's best interests."
    },
    {
       "id":1585,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Fred is a client of Polly, who represents SIA Securities. Polly's recommendations have made Fred quite a lot of money over the last ten years. Fred is so pleased that he tells Polly that she can keep 20% of any gains in his account from now on, in addition to the commissions that he usually pays. Which of the following is true?",
       "choice_a":"This is acceptable as long as SIA and Fred agree in writing",
       "choice_b":"This is acceptable only if SIA is registered as an investment adviser",
       "choice_c":"This is not acceptable unless SIA foregoes its usual commission charges",
       "choice_d":"This is not acceptable as it is considered to be sharing in the client\u0027s profits",
       "correct_answer":"D",
       "explanation":"Sharing in the profits and/or losses in a client's account is generally not permitted There is an exception if the client and the agent have a joint account, the client and the broker-dealer consent to the arrangement in writing, and profits and losses are shared in proportion to the capital that each contributed to the account."
    },
    {
       "id":1586,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An agent may split commissions with which of the following?",
       "choice_a":"An agent of the same firm licensed in another state",
       "choice_b":"An insurance company officer giving the agent business",
       "choice_c":"An agent of another firm licensed in the same state",
       "choice_d":"Another licensed agent of the same firm licensed in the same state",
       "correct_answer":"D",
       "explanation":"The Uniform Securities Act allows for the splitting of commissions provided that the agents involved are employed by the same firm and are registered in the same state."
    },
    {
       "id":1587,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A client has a $1,000,000 account with an objective of income only. Under the Uniform Securities Act, an agent who has discretionary authorization in the account could:",
       "choice_a":"Not buy a speculative stock without the client\u0027s approval",
       "choice_b":"Speculate with 49% of the client\u0027s assets",
       "choice_c":"Speculate with 51% of the client\u0027s assets",
       "choice_d":"Not purchase equities in the account",
       "correct_answer":"A",
       "explanation":"Regardless of the account size, any amount of speculative investing would be inappropriate in an account with an objective of income only."
    },
    {
       "id":1588,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An agent of a SIA broker-dealer has a business relationship with an agent of another broker-dealer. They both own a large quantity of WIDGET stock. Which of the following statements is correct if both agents buy and sell large amounts of WIDGET stock to increase its trading volume?",
       "choice_a":"This action is permissible if the agents receive prior written approval of their broker-dealers",
       "choice_b":"This action is not permissible since the agents are employed by two different broker-dealers",
       "choice_c":"This action may be considered market manipulation",
       "choice_d":"This action is considered a matched sale and is an allowable type of securities transaction",
       "correct_answer":"C",
       "explanation":"The action by the two agents may be considered manipulation. The agents may not effect transactions to create the false or misleading appearance of trading volume in WIDGET stock. This type of market manipulation is sometimes referred to as a matched sale and is considered a violation of securities law. If the agents worked at the same broker-dealer and had received prior written permission from their firm the transactions would still be considered a prohibited business practice."
    },
    {
       "id":1589,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A client requests that her agent display a quote in a thinly traded security. The client is the majority shareholder in this security and the broker-dealer honors the request and displays the quote. Which of the following is correct?",
       "choice_a":"This would be permissible if the broker-dealer believed the quote was bona fide",
       "choice_b":"This would be considered an unethical business practice",
       "choice_c":"A broker-dealer may always enter a quote on behalf of a client",
       "choice_d":"A broker-dealer is not permitted to enter quotes on behalf of its clients",
       "correct_answer":"A",
       "explanation":"A broker-dealer is permitted to publish quotes (bid and ask prices) on behalf of its clients or for its own account. The broker-dealer must believe the quotes are bona fide and not intended to manipulate the market price of a security. If the quotes are not bona fide and the broker-dealer publishes them, they would have committed an unethical business practice."
    },
    {
       "id":1590,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An agent recommends that a client purchase a particular security. The agent believes the client has the resources to pay for the transaction. Three days after the trade is executed the client indicates that he cannot meet his financial obligation to the brokerage firm. If the agent lends personal funds to the client:",
       "choice_a":"The agent has committed fraud",
       "choice_b":"The agent has acted in an unethical manner",
       "choice_c":"The client forgoes a right to be offered a letter of rescission",
       "choice_d":"All of the choices listed",
       "correct_answer":"B",
       "explanation":"This is unethical behavior, not fraud. An agent should not borrow or lend funds to a client."
    },
    {
       "id":1591,
       "topic_id":1,
       "practice_test_id":"",
       "question":"All of the following could be considered churning except:",
       "choice_a":"A portfolio was completely changed on the first and fifteenth of every month",
       "choice_b":"There was aggressive switching among mutual fund families",
       "choice_c":"Turnover was motivated by the commissions an account would generate",
       "choice_d":"There was rampant day trading in a speculator\u0027s account",
       "correct_answer":"D",
       "explanation":"A speculator's goal is to produce short-term trading profits and one would expect a high degree of turnover in this account. Such activity would generally not be considered churning since it is consistent with this investor's objectives."
    },
    {
       "id":1592,
       "topic_id":1,
       "practice_test_id":1,
       "question":"When a firm exercises discretion in a client's account:",
       "choice_a":"A power of attorney should be obtained before the settlement date",
       "choice_b":"A power of attorney should be obtained before the first order is submitted",
       "choice_c":"The state requires that a client provide the firm with a cash deposit",
       "choice_d":"The state must be notified that an agent will exercise discretion",
       "correct_answer":"B",
       "explanation":"A power of attorney should be obtained before the first order is entered."
    },
    {
       "id":1593,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Pete is an agent for SIA Brokerage. His client, Bill, is the CEO of a publicly traded company. Bill tells Pete about an upcoming merger between his company and a competitor. This information is not yet public knowledge. Which of the following is true?",
       "choice_a":"Pete may pass this information along to his clients, but may not use it personally",
       "choice_b":"Pete may use this information to do trades for Bill\u0027s account, but may not disclose it to anyone else",
       "choice_c":"Pete should disclose this information to a supervisor, but take no other actions based on it",
       "choice_d":"Pete should not disclose this information to any other person, and should not effect any trades based on it",
       "correct_answer":"C",
       "explanation":"Inside information is material, nonpublic information about an issuer. Agents of a broker-dealer who come into possession of such information should inform their supervisor, but should take no other actions. They should not effect trades based on this information, nor pass the information along to anyone except a supervisor."
    },
    {
       "id":1594,
       "topic_id":1,
       "practice_test_id":3,
       "question":"The least suitable investment for an 80-year old investor, would be a:",
       "choice_a":"Treasury note",
       "choice_b":"Utility stock fund",
       "choice_c":"Fixed annuity",
       "choice_d":"Raw land limited partnership",
       "correct_answer":"D",
       "explanation":"Raw land limited partnerships are highly speculative and do not provide the current income return that the majority of elderly investors are seeking."
    },
    {
       "id":1595,
       "topic_id":1,
       "practice_test_id":4,
       "question":"A customer of a broker-dealer maintains a personal trading account. The spouse of the customer may:",
       "choice_a":"Purchase additional securities in the account",
       "choice_b":"Sell securities out of the account",
       "choice_c":"Transfer securities to another account",
       "choice_d":"None of the choices listed",
       "correct_answer":"D",
       "explanation":"In a personal trading account, trades may only be entered by the individual or a third party designated by a written power of attorney. A spouse without power of attorney would not be eligible to trade in the account."
    },
    {
       "id":1596,
       "topic_id":1,
       "practice_test_id":5,
       "question":"An agent has been executing transactions which are not reflected on the books of the broker-dealer. This type of activity requires:",
       "choice_a":"Suspension of the broker-dealer",
       "choice_b":"Registration as an investment adviser representative",
       "choice_c":"Registration by the agent as a broker-dealer",
       "choice_d":"Registration as an investment adviser by the agent",
       "correct_answer":"C",
       "explanation":"The agent is acting independently of the firm and would be viewed as a separate broker-dealer. The state would view the agent as acting as an unregistered broker-dealer."
    },
    {
       "id":1597,
       "topic_id":1,
       "practice_test_id":6,
       "question":"An agent has just received an unsolicited order from a customer. The customer wants to purchase a large amount of a speculative stock. Although the customer has the financial resources to bear the risks of this investment, the agent does not think it fits the client's investment objectives. The agent may do all of the following except:",
       "choice_a":"Accept the order",
       "choice_b":"Attempt to convince the customer to not buy the stock",
       "choice_c":"Attempt to convince the customer to purchase another stock",
       "choice_d":"Ignore the customer\u0027s order if it is not suitable",
       "correct_answer":"D",
       "explanation":"It is considered a dishonest and unethical practice for an agent to knowingly fail to follow client instructions. However, agents may certainly attempt to convince customers to alter those instructions if they feel another course of action is more suitable for that client."
    },
    {
       "id":1598,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An investment adviser should recommend investments to clients that:",
       "choice_a":"Are as safe as possible",
       "choice_b":"Have the highest return given the client\u0027s risk tolerance",
       "choice_c":"Have an investment-grade rating",
       "choice_d":"Are suitable for the client",
       "correct_answer":"D",
       "explanation":"One of an investment adviser's most important duties is to provide investment advice that is suitable for the client. This means providing advice that is appropriate given the client's investment objectives, financial resources, and risk tolerance."
    },
    {
       "id":1599,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An agent for a broker-dealer has inadvertently sold a non-exempt unregistered security to a client. Which of the following would rectify the sale? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Getting the security registered as soon as possible </li><li>Buying the security back from the client </li><li>Paying the client interest from the date of the sale, less dividend or interest income received </li><li>Asking the client to sign a waiver of noncompliance </li></ol>",
       "choice_a":"IV only",
       "choice_b":"I and IV only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and IV only",
       "correct_answer":"C",
       "explanation":"If an agent discovers that he or she has inadvertently sold an unregistered nonexempt security to a client, the agent may offer to repurchase the security from the client under an offer of rescission, and pay the client the legal rate of interest from the date of purchase, less dividend or interest income received."
    },
    {
       "id":1600,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An adviser highlights a prospectus on a mutual fund to point out the important parts to their client. This action is:",
       "choice_a":"Allowable because anything you do to inform investor is is in their best interest",
       "choice_b":"Allowable because they can still read the original wording.",
       "choice_c":"Impermissible because you cannot change a prospectus in any way",
       "choice_d":"Not allowed because the advisor does not know which information the client may want to focus on",
       "correct_answer":"C",
       "explanation":"A prospectus can not be marked or changed in any way. Highlighting content or even stapling a business card to a prospectus is not allowed."
    },
    {
       "id":1601,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An investment adviser needs to borrow money for gambling losses.  His brother is a client who offers to loan him money from his account with his brother.  This is:",
       "choice_a":"Allowed only if it is less than $1000",
       "choice_b":"Allowed only if there is a written contract",
       "choice_c":"Never allowed",
       "choice_d":"Allowed because it is family",
       "correct_answer":"D",
       "explanation":"An adviser could borrow money from an immediate family member so long as the firm does not have policy against it. Otherwise an adviser may only borrow money from a client if that client is in the business of making loans, such as if the client is a bank."
    },
    {
       "id":1602,
       "topic_id":1,
       "practice_test_id":"",
       "question":"What is an investment adviser allowed to do regarding a security?",
       "choice_a":"Push it to family and friends based on their knowledge of developments at the company",
       "choice_b":"Recommend that investors sell it short",
       "choice_c":"Act in a capacity opposite of the advise provided to clients for the purpose of building a position",
       "choice_d":"Tell clients that the covered securities they are recommending are safer than other securities and do not have to register with the state",
       "correct_answer":"B",
       "explanation":"An investment adviser may recommend that clients sell securities short so long as the clients are able to understand the risks and short selling is suitable for the client.  An adviser may not suggest that a covered security is safer than a non covered security, nor may the adviser push the security based on their knowledge of developments at the company."
    },
    {
       "id":1603,
       "topic_id":1,
       "practice_test_id":1,
       "question":"Which of the following if committed by an adviser would be considered an unethical practice? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Not disclosing fees </li><li>Not allowing someone to register for too risky securities </li><li>Soliciting new investors in other states </li><li>Charging a larger than normal commission to execute a customer's specific order </li></ol>",
       "choice_a":"I only",
       "choice_b":"IV only",
       "choice_c":"III and IV",
       "choice_d":"III only",
       "correct_answer":"A",
       "explanation":"An adviser must always disclose the costs and fees for services. It is perfectly ok to charge a larger than normal commission for executing a specific order so long as it is disclosed."
    },
    {
       "id":1604,
       "topic_id":1,
       "practice_test_id":2,
       "question":"An agent and firm are being sued for excessive trading in an account.  How could the president of the firm escape liability?",
       "choice_a":"He did not know what the adviser was doing",
       "choice_b":"He performed all oversight but the adviser was hiding his actions",
       "choice_c":"The president is never liable",
       "choice_d":"The client did not lose any money in the transaction",
       "correct_answer":"B",
       "explanation":"If the president or principal of the firm is performing all of the required oversight of the agent and the agent is going to extraordinary measures to hide their actions the president or principal of the firm may escape liability."
    },
    {
       "id":1605,
       "topic_id":1,
       "practice_test_id":3,
       "question":"A firm is employing a non-registered person who is acting as an agent when making sales to customers.  The state administrator can do which of the following: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Fine the agent </li><li>Fine the Broker Dealer </li><li>Bar the agent </li><li>Pursue criminal action against the agent </li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"The state securities administrator may take all of the actions listed except they can not bring criminal action against the agent. The administrator would have to refer the matter to the state attorney general for prosecution."
    },
    {
       "id":1606,
       "topic_id":1,
       "practice_test_id":4,
       "question":"An Investment adviser is not allowed to do any of the following except:",
       "choice_a":"Make recommendations based on public information",
       "choice_b":"Tell an investor that the company\u0027s rival is unlikely to win a new contract",
       "choice_c":"Say that an internal audit shows the company is better off than thought",
       "choice_d":"Exercise time and size discretion over an account without written authority",
       "correct_answer":"A",
       "explanation":"An investment adviser may only make recommendations based on public information. The adviser may not cite an internal audit (\u0022non public information\u0022), exercise discretion over the amount of a security to buy or sell without discretion nor state that a company is unlikely to win a contract without stating that it is their opinion and not a fact."
    },
    {
       "id":1607,
       "topic_id":1,
       "practice_test_id":5,
       "question":"Which of the following cannot appear on the firm's website?",
       "choice_a":"The State Administrator approves our practices",
       "choice_b":"Goals of the institution",
       "choice_c":"Amount of money the firm manages",
       "choice_d":"Quotes from customers",
       "correct_answer":"A",
       "explanation":"A firm may never state that any regulator approves or endorses the firm or its agents. All of the other choices may be placed on the firm's website."
    },
    {
       "id":1608,
       "topic_id":1,
       "practice_test_id":6,
       "question":"A client sends a written complaint about an agent being rude.  The company is required to:",
       "choice_a":"Contact the state administrator with the charges",
       "choice_b":"Do nothing as this is not a substantial claim",
       "choice_c":"Investigate the matter",
       "choice_d":"Suspend the agent immediately",
       "correct_answer":"C",
       "explanation":"A firm that receives a written customer complaint is required to investigate the matter no matter how small the claim."
    },
    {
       "id":1609,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An investment adviser says that they will compensate the customer for any losses that a security will have. This is:",
       "choice_a":"Not allowed because it is guaranteeing a return",
       "choice_b":"Not allowed as they may not have enough money to cover the loss",
       "choice_c":"An acceptable practice",
       "choice_d":"Allowed only if approved by the principal at the home office",
       "correct_answer":"A",
       "explanation":"No firm, adviser or agent may guarantee a result or promise no loss to a client for any reason."
    },
    {
       "id":1610,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An agent knows there will be an oversubscription to the offering of a security.  He then, acting on verbal authority, opens an account for his wife where he puts many of the securities. This is:",
       "choice_a":"A violation as you cannot act for another person",
       "choice_b":"Acceptable because it is his wife",
       "choice_c":"An example of withholding and a violation",
       "choice_d":"This is acceptable if the amount of the securities is less than $10,000",
       "correct_answer":"C",
       "explanation":"All securities that are the subject of an underwriting must be offered to the public and can not be withheld for the account of a broker dealer, an agent or anyone who is financially dependent upon the agent, such as spouse or a child."
    },
    {
       "id":1611,
       "topic_id":1,
       "practice_test_id":2,
       "question":"A client asks an agent to sell his shares in company C at the market.  The agent believes the stock will rise and waits until the end of the day when the stock has fallen. Which of the following is true?",
       "choice_a":"This is acceptable  because the agent was acting in what he thought were the best interests of the client",
       "choice_b":"This is not acceptable only because the client lost money",
       "choice_c":"This is a violation because the agent did not listen to the client",
       "choice_d":"This is acceptable because the agent can not be expected to execute every order for all clients immediately",
       "correct_answer":"C",
       "explanation":"This is a violation because the agent did not listen to the client  and sell their shares in company C at the market as soon as practical."
    },
    {
       "id":1612,
       "topic_id":1,
       "practice_test_id":3,
       "question":"A firm is found in violation of the USA for selling unregistered non exempt securities and for making false statements. The administrator can: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Take action against the firm's agents </li><li>Take action against the broker dealer </li><li>Bring criminal charges against the agents </li><li>Award the firm's clients money and interest </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"An administrator can do all of the choices listed but can not bring criminal charges against the agents. Only a district attorney can bring criminal charges against agents."
    },
    {
       "id":1613,
       "topic_id":1,
       "practice_test_id":4,
       "question":"An agent is three mutual fund sales away from a bonus.  It is unethical for the representative to:",
       "choice_a":"Tell clients about the bonus",
       "choice_b":"Solicit help from family and friends to meet the bonus",
       "choice_c":"Call clients and tell them that there is a great deal on a fund",
       "choice_d":"Establish a dollar cost averaging plan for a client at the client\u0027s request",
       "correct_answer":"C",
       "explanation":"The agent may not recommend the fund for which the sales are the basis for a bonus and use that potential bonus as the basis for the recommendation."
    },
    {
       "id":1614,
       "topic_id":1,
       "practice_test_id":5,
       "question":"An agent has discretionary account.  The person who is the account holder tells them to pick whatever they think will be in their best interest. Which of the following is acceptable?",
       "choice_a":"The agent should pick growth stocks",
       "choice_b":"The agent can only pick time and price, not securities",
       "choice_c":"The agent should pick the securities he believes will offer the best performance",
       "choice_d":"The agent should pick only securities he believes are best suited for the client",
       "correct_answer":"D",
       "explanation":"An agent who is managing a discretionary account must always select investments that meet the client's investment profile."
    },
    {
       "id":1615,
       "topic_id":1,
       "practice_test_id":6,
       "question":"A person needs $10,000 to cover an unexpected expense, they have $5,000 in cash in their account and $55,000 in mutual funds and stock. They tell the agent to send them $10,000. The agent should:",
       "choice_a":"Send the cash and pick which stocks he thinks will grow the least and sell them to cover the other $5,000",
       "choice_b":"Send the cash and get permission to sell $5,000 of the mutual fund",
       "choice_c":"Send the cash and take taxes into account and sell enough of the assets to cover the $5,000 and the tax",
       "choice_d":"Send the cash and sell the stock first to cover the $5,000 as this will not incur a penalty",
       "correct_answer":"B",
       "explanation":"The agent should do as the client asks and send the $5,000 to the client and get permission to sell $5,000 of the mutual fund to cover the rest of the cash need. The key is that the agent asked for permission."
    },
    {
       "id":1616,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following statements made by a representative is a violation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Covered stocks are less risky than non-covered stocks </li><li> Since a stock is covered, it does not need to be registered with the SEC or state </li><li>This covered stock has many shares outstanding </li><li>This covered stock should be bought by all my clients </li></ol>",
       "choice_a":"I and III",
       "choice_b":"II only",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"All of the statements if made by an agent regarding a covered security would be a violation except telling the client the amount of shares the company has outstanding."
    },
    {
       "id":1617,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following if engaged in by an agent is a violation of the USA?",
       "choice_a":"Charging different fees to different clients",
       "choice_b":"Refusing to allow a low-income client to buy risky securities",
       "choice_c":"Recommending a stock to all clients",
       "choice_d":"Charging different fees to execute different orders",
       "correct_answer":"C",
       "explanation":"Charging different fees for specific orders or for clients who purchase more shares is an acceptable practice. An agent may not recommend a security to all clients as it will not be suitable for all clients."
    },
    {
       "id":1618,
       "topic_id":1,
       "practice_test_id":1,
       "question":"Anyone who invests, including individual investors is subject to:",
       "choice_a":"Keeping documents",
       "choice_b":"Not committing fraud",
       "choice_c":"Registering securities",
       "choice_d":"Registering as a broker-dealer",
       "correct_answer":"B",
       "explanation":"No one may commit fraud including individual investors."
    },
    {
       "id":1619,
       "topic_id":1,
       "practice_test_id":2,
       "question":"An investment adviser has a new client sign a form before opening the account that says that the investment adviser does not follow any prudent investment guidelines. The investment adviser then engages in very risky trading (more than the client would like). The client:",
       "choice_a":"Has no rights because they signed the form",
       "choice_b":"Can take action against the investment adviser  because they did not inform them they were waiving their rights",
       "choice_c":"Can take action because the clause is unenforceable",
       "choice_d":"Cannot take action because they waived all rights",
       "correct_answer":"C",
       "explanation":"A client may never sign any form or agree to waive their rights to sue an adviser. Any form or clause under which a client waves their rights would be unenforceable."
    },
    {
       "id":1620,
       "topic_id":1,
       "practice_test_id":3,
       "question":"An investment adviser works with an 82 year old woman.  Her 50 year old son will be the Executor of her estate. The son calls the investment adviser saying he thinks that his mother's investments are out of line with what her objectives should be and wants information on the account. The investment adviser:",
       "choice_a":"Should provide the information because the son will be the Executor",
       "choice_b":"Cannot share the information without written permission from client",
       "choice_c":"Should share information if he is in agreement with son",
       "choice_d":"Advise the son that he should move the money to a more conservative portfolio",
       "correct_answer":"B",
       "explanation":"An investment adviser may not disclose any client information to a third party without the written permission of the client or without a court order or subpoena. The fact that the son will be the Executor of the estate is not relevant while his mother, the client is alive."
    },
    {
       "id":1621,
       "topic_id":1,
       "practice_test_id":4,
       "question":"Your advisory company charges fees to clients for both advice and transactions. This is:",
       "choice_a":"Never allowed",
       "choice_b":"Allowed if total fees are less than 1.25% of market value of assets",
       "choice_c":"Allowed if you disclose the fact to clients",
       "choice_d":"Allowed only if the company\u0027s advisory clients are limited to institutions",
       "correct_answer":"C",
       "explanation":"An advisory company many charge fees for advice and receive commissions for executing orders for the clients so long as it is disclosed to the clients."
    },
    {
       "id":1622,
       "topic_id":1,
       "practice_test_id":5,
       "question":"A hedge fund typically: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Has manager invested in it so they are a partner </li><li>Works against a benchmark </li><li>Are private investment companies  </li><li>Must offer a prospectus to investors </li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I, II and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct regarding hedge funds except they are not sold by prospectus as hedge funds are not offered to the general public."
    },
    {
       "id":1623,
       "topic_id":1,
       "practice_test_id":6,
       "question":"A client gives oral permission to their investment adviser to execute a trade.  The investment adviser executes the order for the client at the market in line with the client's instructions.  When must the adviser receive the authorization in writing?",
       "choice_a":"Before a fee is paid",
       "choice_b":"Before the next transaction",
       "choice_c":"Within 10 days",
       "choice_d":"Not at anytime if the adviser has a contract in place with the client",
       "correct_answer":"D",
       "explanation":"A client is not required to provide written authorization to document their approval to execute an order."
    },
    {
       "id":1624,
       "topic_id":1,
       "practice_test_id":"",
       "question":"When can an investment adviser reveal information about their client?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If the client gives permission </li><li>If legally forced </li><li>At their discretion </li><li>If asked by family </li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I and Iv",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"An investment adviser may only reveal information about their client if the client gives permission or if they are required to legally, such as under a subpoena."
    },
    {
       "id":1625,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A broker dealer is all of the following except:",
       "choice_a":"A firm acting for its own account or for the accounts of others",
       "choice_b":"A person acting for his own account or for the account of others",
       "choice_c":"An agent, a bank, a savings institution, a trust company, or an issuer of securities",
       "choice_d":"Registered under the Uniform Securities Act in every state in which he carries on business with the public.",
       "correct_answer":"C",
       "explanation":"Agents, banks, savings institutions, trust companies, and issuers are excluded from the definition of a broker dealer. A person is any legal entity, such as a corporation, that may enter into a legally binding contract."
    },
    {
       "id":1626,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A firm, acting for the accounts of others as an agency, is considered:",
       "choice_a":"An agent",
       "choice_b":"A dealer",
       "choice_c":"A broker",
       "choice_d":"An issuer",
       "correct_answer":"C",
       "explanation":"A firm, acting for the accounts of others as an agency, is known as a broker."
    },
    {
       "id":1638,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A person will be considered an investment adviser if he does all of the following except:",
       "choice_a":"Engages in the business of advising others, directly or indirectly, about the merits of securities, either for purchase or for sale",
       "choice_b":"Provides reports or analysis concerning securities in the regular course of his business",
       "choice_c":"Solely participates in the buying and selling of the securities for the accounts of clients",
       "choice_d":"Receives compensation for his securities advice",
       "correct_answer":"C",
       "explanation":"The person will  be considered only a broker dealer if they solely purchase and sell securities for clients."
    },
    {
       "id":1639,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A regional firm is acquiring a local firm in state. The regional firm is not registered as a broker dealer in the state of the firm that it is acquiring. All of the following are true except:",
       "choice_a":"The acquiring firm\u0027s registration will be effective upon completion of the transaction.",
       "choice_b":"The acquiring firm will have to pay new registration fees.",
       "choice_c":"The acquiring firm will not have to pay registration fees.",
       "choice_d":"The acquiring firm must file an application with the Administrator.",
       "correct_answer":"B",
       "explanation":"All of the answers listed are true except that the firm will have to pay new registration fees. The acquiring firm will pay the registration fees at year end for the next year."
    },
    {
       "id":1640,
       "topic_id":2,
       "practice_test_id":1,
       "question":"A small broker dealer is applying for registration in a nearby state. The State Securities Administrator is asking that the broker dealer post a surety bond. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Cash can be substituted for the bond </li><li>A deposit of qualified securities may be substituted for the bond </li><li>An agent of the firm subject to the surety bond requirements may not make substitutions for the bond </li><li>If the broker dealer meets the SEC's minimum net capital requirement they are exempt from the surety bond requirement. </li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I, II and IV",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"All of the choices listed are correct except number II. An agent may substitute a deposit of cash or securities for the bond."
    },
    {
       "id":1641,
       "topic_id":2,
       "practice_test_id":2,
       "question":"According to the Uniform Securities Act, an investment adviser is considered to have custody of client's funds under which of the following circumstances? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The adviser has full discretion </li><li>The adviser self-clears </li><li>The adviser has limited discretion </li><li>The adviser accepts client's securities for deposit </li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and II",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"An adviser is considered to have custody if they have full discretion to withdraw cash and securities as well as when they accept customer's securities for deposit. An adviser that self-clears holds all of the customer's cash and securities."
    },
    {
       "id":1642,
       "topic_id":2,
       "practice_test_id":3,
       "question":"According to the Uniform Securities Act an agent is: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The representative of a broker dealer in a neighboring state who sells securities to existing customers who are non residents </li><li>The representative of an issuer selling large denomination commercial paper  </li><li>A registered broker dealer transacting business with the general public </li><li>A representative of a broker dealer who sells nonexempt securities to residents </li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"IV only",
       "correct_answer":"D",
       "explanation":"Of the choices listed, only IV would have to register as an agent."
    },
    {
       "id":1660,
       "topic_id":2,
       "practice_test_id":4,
       "question":"Applicants cannot transact business until which of the following happens?",
       "choice_a":"A written or oral exam is taken and passed if required",
       "choice_b":"All the documents and the application are filed",
       "choice_c":"The administrator approves the registration",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the above must happen before an applicant can transact business."
    },
    {
       "id":1661,
       "topic_id":2,
       "practice_test_id":5,
       "question":"As it is covered under the Uniform Securities Act, which of the following is a broker dealer?",
       "choice_a":"A person trading large blocks of stock for their own private account",
       "choice_b":"A firm with no office in the state executing orders for banks",
       "choice_c":"A firm with no office in the state executing orders for investment companies and accredited investors only",
       "choice_d":"A firm with no office in the state who executed orders for existing customers in state for less than 30 days",
       "correct_answer":"C",
       "explanation":"A firm with no office in the state who executes orders for accredited investors in state would be considered a broker dealer in the state and would have to register."
    },
    {
       "id":1662,
       "topic_id":2,
       "practice_test_id":6,
       "question":"As it relates to a consent to service of process, which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is an agreement with administrator whereby the registrant agrees to allow actions to be commenced against them upon the receipt of notice by the office of the Administrator. </li><li>It is required only by broker dealers and investment advisors.  </li><li>Any action arising out of the business of the broker dealer in the state served to the office of the administrator will bind all agents as well as principals of the firm. </li><li>The registrant must file an ethical business affidavit with the consent to service of process. </li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"All broker dealers, investment advisors and agents must sign a consent to service of process, which is an agreement allowing the administrator to accept legal notices for the registrant. There is no requirement that the registrant file an ethical business affidavit."
    },
    {
       "id":1663,
       "topic_id":2,
       "practice_test_id":"",
       "question":"As it relates to the USA, a broker dealer is:",
       "choice_a":"Any person executing orders for their own account or the account of others",
       "choice_b":"A trust company entering orders for trust customers",
       "choice_c":"An investment advisor entering orders for clients",
       "choice_d":"A bank officer recommending a closed end mutual fund to a client",
       "correct_answer":"A",
       "explanation":"Under the USA, a broker dealer is any person that executes orders for their own account or for the account of others."
    },
    {
       "id":1682,
       "topic_id":2,
       "practice_test_id":"",
       "question":"You're an agent for an investment adviser and you maintain custody of customer cash and securities. Your firm also has full discretion for several long standing clients. The State Administrator has required your firm to post a surety bond in the amount of $35,000. Your firm may deposit which of the following, instead of posting the bond?",
       "choice_a":"Cash only",
       "choice_b":"Cash or marketable securities",
       "choice_c":"Cash marketable securities, or real estate",
       "choice_d":"Nothing may be substituted for a surety bond",
       "correct_answer":"B",
       "explanation":"Only a deposit of cash or marketable securities may be deposited to meet the surety bond requirement."
    },
    {
       "id":1683,
       "topic_id":2,
       "practice_test_id":"",
       "question":"As it relates to 3 (C)(7) funds which of the following is not true?",
       "choice_a":"They may charge asset based fees",
       "choice_b":"They may change performance based fees",
       "choice_c":"They may be offered to investors who invest a minimum of $1,000,000",
       "choice_d":"Participating corporations must have a net worth of at least $25,000,000",
       "correct_answer":"C",
       "explanation":"In order for an individual to participate in a 3 (C) (7) fund, the investor must either invest $750,000 or have a net worth of at least $1,500,000."
    },
    {
       "id":1684,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Which of the following would be required to register as an investment adviser? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Sports representative </li><li>Pension consultant </li><li>Entertainment representative </li><li>The publisher of a market letter who charges an annual subscription of $499, based on market conditions </li></ol>",
       "choice_a":"II only",
       "choice_b":"I and IV",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed would be required to register as an investment adviser. A publisher of a market letter must register if they base the letter on market conditions."
    },
    {
       "id":1685,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investment adviser from a neighboring state may direct advice to how many people within the state during a 12 month period and still qualify for the de minimis exemption?",
       "choice_a":3,
       "choice_b":4,
       "choice_c":5,
       "choice_d":9,
       "correct_answer":"C",
       "explanation":"An investment adviser may direct advice to five people in any 12- month period and still qualify for the de minimis exemption."
    },
    {
       "id":1686,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Which of the following are given a federal exclusion from the definition of an investment adviser?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An adviser who gives advice on government securities </li><li>An accountant  </li><li>A teacher </li><li>An engineer </li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the answers listed are excluded from the definition of an investment adviser."
    },
    {
       "id":1687,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Which of the following are required to register with the SEC as an investment adviser?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>National statistical ratings organizations </li><li>An adviser with $12,000,000 in assets under management in a state with no adviser requirements  </li><li>An affiliate of a federally registered adviser </li><li>Advisers to registered investment companies </li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are required to register with the SEC as an investment adviser."
    },
    {
       "id":1688,
       "topic_id":2,
       "practice_test_id":6,
       "question":"The federal private adviser exclusion covers advisers who:",
       "choice_a":"Have given advice to five or fewer people in 12 months",
       "choice_b":"Have given advice to fifteen or fewer people in 12 months",
       "choice_c":"Have given advice to ten or fewer people in 12 months",
       "choice_d":"Have given advice to six or fewer people in 12 months",
       "correct_answer":"B",
       "explanation":"The federal private adviser exemption is available to advisers who have given advice to fifteen or fewer people in twelve months."
    },
    {
       "id":1689,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investment adviser representative for a federally registered investment adviser needs to do which of the following?",
       "choice_a":"Register with the SEC only",
       "choice_b":"Register with the SEC and the state",
       "choice_c":"Register with the state only",
       "choice_d":"The IA representative is not required to register",
       "correct_answer":"C",
       "explanation":"The IA representative would most likely be required to register in the state where they are located."
    },
    {
       "id":1690,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A registered representative prepares financial plans for clients outside their employment with a duly registered broker dealer. The representative prepares several plans a month and receives a fee for developing the plan. Which of the following is true?",
       "choice_a":"The RR is not required to register as an investment adviser",
       "choice_b":"The RR would be required to register as an investment adviser",
       "choice_c":"The RR would not be required to register as an investment adviser if their employer was registered as an investment adviser",
       "choice_d":"The RR would  be required to register as an investment adviser if their employer was also registered as an investment adviser",
       "correct_answer":"B",
       "explanation":"Because the representative  is preparing several plans per month and receiving a fee for the plans outside of their employment with the broker dealer, they would be required to register as an investment adviser."
    },
    {
       "id":1691,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A long established broker dealer has decided to offer clients an account that charges a fee for execution and advice. Which of the following is true?",
       "choice_a":"Broker dealers offering wrap accounts must register as investment advisers",
       "choice_b":"Broker dealers offering wrap accounts are not required to register as investment advisers",
       "choice_c":"The broker dealer will only need to register if more than 15% of the firm\u0027s revenue comes from fee based business",
       "choice_d":"The broker dealer will only need to register if more than 10% of the firm\u0027s revenue comes from fee based business",
       "correct_answer":"A",
       "explanation":"Broker dealers who offer wrap accounts are required to register as investment advisers."
    },
    {
       "id":1692,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Affiliates of federally registered advisers:",
       "choice_a":"Must register with the state",
       "choice_b":"Must register with the SEC",
       "choice_c":"Are exempt from SEC registration",
       "choice_d":"Are exempt from both SEC and state registration",
       "correct_answer":"B",
       "explanation":"Affiliates of federally registered advisers must register with the SEC."
    },
    {
       "id":1693,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An agent whose registration is pending in a state may do business with a client who has relocated to the state for:",
       "choice_a":"30 days",
       "choice_b":"45 days",
       "choice_c":"60 days",
       "choice_d":"15 days",
       "correct_answer":"C",
       "explanation":"An agent may conduct business with a client for 60 days while their registration is pending"
    },
    {
       "id":1694,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A state may not prevent an agent who is not registered in the state from transacting business with a customer if which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Such transaction is effected on behalf of a customer that, for 30 days prior to the day of the transaction, maintains an account with the agent's firm </li><li>Such associated person is not ineligible to register with such state for any reason </li><li>Such associated person is registered with a registered securities association </li><li>Such associated person is registered in their state of employment and with at least one other state </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II Only",
       "choice_c":"I and II",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"A state may not prevent an agent who is not registered in the state from transacting business with a customer if all of the conditions are met except an agent is required to be registered in more than one state."
    },
    {
       "id":1695,
       "topic_id":2,
       "practice_test_id":"",
       "question":"The term investment adviser includes all of the following except:",
       "choice_a":"An accountant who recommends tax-free securities as part of his tax service",
       "choice_b":"A person who sells security analyses",
       "choice_c":"A financial planner who sells written financial plans covering insurance and securities purchases",
       "choice_d":"A broker who charges for investment advice",
       "correct_answer":"A",
       "explanation":"Professionals who give investment advice that is incidental to their normal course of business (such as accountants), would not be considered investment advisers. The other individuals listed would be considered investment advisers."
    },
    {
       "id":1696,
       "topic_id":2,
       "practice_test_id":1,
       "question":"The term agent does not include an individual who represents an issuer in:",
       "choice_a":"The sale of one-year commercial paper",
       "choice_b":"The sale of Canadian common stock",
       "choice_c":"Transactions with an underwriter",
       "choice_d":"Any transaction for the benefit of the issuer",
       "correct_answer":"C",
       "explanation":"In general, persons who represent issuers in exempt transactions are not agents. Transactions between issuers and underwriters are exempt."
    },
    {
       "id":1697,
       "topic_id":2,
       "practice_test_id":2,
       "question":"An individual who has passed the Uniform Securities Agent State Law Examination but has not been granted registration by the Administrator. He may participate in:",
       "choice_a":"Prospecting personally",
       "choice_b":"Prospecting by mail only",
       "choice_c":"Accepting unsolicited orders only",
       "choice_d":"None of the activities of an agent",
       "correct_answer":"D",
       "explanation":"Until the Administrator grants registration, an applicant who has passed the Uniform Securities Agent State Law Examination may not transact any business."
    },
    {
       "id":1698,
       "topic_id":2,
       "practice_test_id":3,
       "question":"An agent who is registered in State A contacts a client in State B. The broker-dealer is registered in State B but not the agent. The agent can:",
       "choice_a":"Not sell the security",
       "choice_b":"Sell the security if it is a federal covered security",
       "choice_c":"Sell the security upon notification to a superior",
       "choice_d":"Sell the security because this is an exempt transaction",
       "correct_answer":"A",
       "explanation":"In order to sell a security in a state, the broker-dealer and the agent must both be registered in the state. Therefore, the agent cannot sell the security."
    },
    {
       "id":1699,
       "topic_id":2,
       "practice_test_id":4,
       "question":"A firm that would like to act as an investment adviser in a specific state could do so under the Uniform Securities Act by: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Registering as an investment adviser </li><li>Registering as an investment adviser representative </li><li>Registering as a broker-dealer </li><li>Limiting clientele to insurance companies, broker-dealers, and investment companies </li></ol>",
       "choice_a":"I only",
       "choice_b":"I and IV only",
       "choice_c":"II and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"Investment advisers can transact business in a state only if they are registered or exempt from registration. An investment adviser is exempt from registration if the adviser does not maintain a place of business in that state and clients are limited to institutional investors (e.g., insurance companies, broker-dealers, and investment companies)."
    },
    {
       "id":1700,
       "topic_id":2,
       "practice_test_id":5,
       "question":"Under the Uniform Securities Act, an investment adviser who has no place of business in a state is exempt from registration in that state if the adviser provides advice in which of the following situations? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The adviser had no more than 5 clients in that state within the last 12 months. </li><li>The adviser had no more than 15 clients in that state within the last 12 months. </li><li>The adviser provided advice only to investment companies in that state. </li><li>The adviser provided advice only to insurance companies in that state </li></ol>",
       "choice_a":"I and IV only",
       "choice_b":"II and IV only",
       "choice_c":"III and IV only",
       "choice_d":"I, III, and IV only",
       "correct_answer":"D",
       "explanation":"An adviser whose clients are all institutions or who has no more than 5 clients in a state is exempt from registration, provided that the adviser has no place of business in that state."
    },
    {
       "id":1701,
       "topic_id":2,
       "practice_test_id":6,
       "question":"According to the Uniform Securities Act, which of the following statement(s) is (are) false concerning a broker-dealer or investment adviser filing an application for registration as a successor? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The successor's firm must be in existence prior to the filing of the application for registration. </li><li>The successor's firm registration will be effective for the unexpired portion of the year. </li><li>The successor's firm must submit a filing fee with the application for registration.</li></ol>",
       "choice_a":"II only",
       "choice_b":"III only",
       "choice_c":"I and II only",
       "choice_d":"I and III only",
       "correct_answer":"D",
       "explanation":"If a registered broker-dealer's or investment adviser's ownership structure is changed (from a partnership to a corporation, for example), or is bought or sold by another person, they are permitted to file an application for registration as a successor firm. According to the Act, this can be accomplished whether or not the successor's firm was in existence prior to the filing and is effective for the unexpired portion of the year. A filing fee is not required when the application is submitted."
    },
    {
       "id":1702,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Jane is in the process of registering as an agent for B/D SIA. The Administrator is examining her application. Which of the following facts could be used by the Administrator to deny her application? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> She was disciplined by the FINRA for failure to supervise employees </li><li>She is currently in the process of filing personal bankruptcy. </li><li>She has not included the full amount of the filing fee with her application </li><li>She inadvertently filed her application with the incorrect zip code for her home address. </li></ol>",
       "choice_a":"II only",
       "choice_b":"I, II, and III only",
       "choice_c":"I, III, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"The grounds that the Administrator can use to deny an application for agent registration include: insolvency, failure to reasonably supervise employees to insure compliance with the Act and failure to pay the proper filing fee. Materially false or misleading information on an application can be grounds for denial. However, an incorrect zip code is not likely to be considered a material fact on an application."
    },
    {
       "id":1703,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An unregistered agent who is an employee of a licensed broker-dealer is allowed to sell exempt securities to the public:",
       "choice_a":"Under no circumstances",
       "choice_b":"If it is an exempt transaction",
       "choice_c":"Because the security is exempt",
       "choice_d":"If the employee is not paid a salary or commission",
       "correct_answer":"A",
       "explanation":"An individual who sells securities (whether or not the securities are exempt) must be registered as an agent in order to sell such securities to the public for a licensed broker-dealer"
    },
    {
       "id":1704,
       "topic_id":2,
       "practice_test_id":2,
       "question":"In which of the following situations will the registration of a broker-dealer automatically result in the person being registered as an agent with the Administrator?",
       "choice_a":"The person is an attorney",
       "choice_b":"The person is a director of the broker-dealer",
       "choice_c":"The person is an agent of the broker-dealer and is registered in another state",
       "choice_d":"The person had been previously employed by the Administrator",
       "correct_answer":"B",
       "explanation":"The registration of a broker-dealer in a state will automatically constitute the registration of an agent if the person is a partner, director, officer or other persons occupying a similar status."
    },
    {
       "id":1705,
       "topic_id":2,
       "practice_test_id":3,
       "question":"An agent includes all of the following except:",
       "choice_a":"A person who represents a broker-dealer and sells listed securities",
       "choice_b":"A person who represents an issuer in selling securities through exempt transactions",
       "choice_c":"A person who sells registered securities to the public on behalf of an issuer",
       "choice_d":"A person representing a broker-dealer effecting transactions for the issuer",
       "correct_answer":"B",
       "explanation":"An individual who represents an issuer in selling securities through exempt transactions would not be considered an agent. An individual who sold securities for the issuer to the public through nonexempt transactions would be an agent. Anyone who represents a broker-dealer in a securities transaction is an agent."
    },
    {
       "id":1706,
       "topic_id":2,
       "practice_test_id":4,
       "question":"Under the Uniform Securities Act, an officer of an issuer selling securities to the public is considered an:",
       "choice_a":"Agent of the issuer and is subject to registration",
       "choice_b":"Agent of the issuer and is not subject to registration",
       "choice_c":"Agent of a broker-dealer",
       "choice_d":"Associated person",
       "correct_answer":"A",
       "explanation":"A person acting in this capacity is referred to as an \u0022agent of the issuer,\u0022 and is subject to registration. An officer who sells issuer securities to employees or engages in certain exempt transactions is not an agent. The term associated person is defined in the rules of some self-regulatory organizations, but it is not a term used in the Uniform Securities Act."
    },
    {
       "id":1707,
       "topic_id":2,
       "practice_test_id":5,
       "question":"Pete  is an official SIA Securities who only works with management relating to corporate matters.  Under the Uniform Securities Act:",
       "choice_a":"Pete is an agent since all officers of a securities firm are considered agents",
       "choice_b":"Pete is not considered an agent since he is not involved in sales or trading",
       "choice_c":"Pete is considered an agent but would not have to pass a qualifying exam",
       "choice_d":"Pete is not an agent but could accept unsolicited orders",
       "correct_answer":"B",
       "explanation":"Only personnel engaged in securities transactions are agents. Officers can be considered agents, but it depends on their particular job functions. If the officer is not involved in the training or supervising of agents the officer would not be considered to be an agent."
    },
    {
       "id":1708,
       "topic_id":2,
       "practice_test_id":6,
       "question":"According to the Uniform Securities Act, a person is not considered an investment adviser if the advice provided covers only:",
       "choice_a":"Whole life insurance",
       "choice_b":"Variable annuities",
       "choice_c":"Municipal bonds",
       "choice_d":"Money-market mutual funds",
       "correct_answer":"A",
       "explanation":"Since whole life insurance is not a security, someone who provides advice only about insurance would not be viewed as an investment adviser."
    },
    {
       "id":1709,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Which of the following is not true regarding licensing and registration standards for broker-dealers?",
       "choice_a":"The Administrator may require that a broker-dealer have a minimum net capital as a condition of registration",
       "choice_b":"A broker-dealer must notify the SEC that it intends doing business in a state before it can transact any business",
       "choice_c":"The Administrator may require registered broker-dealers to post bonds and may determine their conditions",
       "choice_d":"The Administrator may provide for a qualification examination which may be written, oral, or both",
       "correct_answer":"B",
       "explanation":"Licensing and registration standards for broker-dealer not include SEC notification of intent to transact business in a particular state. All other choices are correct."
    },
    {
       "id":1710,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An Administrator may deny an investment advisory registration for all of the following reasons except:",
       "choice_a":"Not meeting minimum financial standards",
       "choice_b":"Not posting a bond",
       "choice_c":"Not passing an oral and/or written examination",
       "choice_d":"Not having at least five years experience in the investment advisory field",
       "correct_answer":"D",
       "explanation":"An Administrator cannot deny an investment advisory registration solely due to the applicant's lack of experience. All of the other items listed would be valid reasons for denying a registration."
    },
    {
       "id":1711,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Widget has filed a registration statement with the state Administrator to register a new offering by qualification. Before the registration statement is declared effective, the Company discovers that some of the information in the registration statement has become inaccurate. Which of the following is true?",
       "choice_a":"The company must withdraw its registration statement and begin the process over again",
       "choice_b":"The company must file a correcting amendment with the Administrator",
       "choice_c":"The company is no longer eligible to use registration by qualification for this offering",
       "choice_d":"The company does not need to do anything as long as the information was accurate when it was filed and the Administrator does not deny the registration",
       "correct_answer":"B",
       "explanation":"When information on a registration statement is inaccurate or incomplete, a correcting amendment must be sent to the Administrator. The effective date of the registration will then be dependent upon the date of the amendment, not the date of the original filing."
    },
    {
       "id":1712,
       "topic_id":2,
       "practice_test_id":6,
       "question":"Which of the following is not true of federal covered advisers?",
       "choice_a":"They are not subject to registration as investment advisers under the Uniform Securities Act",
       "choice_b":"They are not subject to state record keeping requirements",
       "choice_c":"They are not subject to the antifraud provisions of the Uniform Securities Act",
       "choice_d":"Investment adviser representatives of federal covered advisers can be required to register in a state if they have a place of business there",
       "correct_answer":"C",
       "explanation":"The antifraud provisions of the Uniform Securities Act cover \u0022all persons,\u0022 including federal covered advisers."
    },
    {
       "id":1713,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investment adviser with no place of business within a state will not be required to register with the Administrator under which of the following conditions?",
       "choice_a":"The adviser has not been the subject of any disciplinary action",
       "choice_b":"If the adviser has been in business for ten years",
       "choice_c":"The adviser will only provide advice to mutual funds",
       "choice_d":"The adviser will only provide advice to 401(k) plans with assets of at least $500,000",
       "correct_answer":"C",
       "explanation":"An adviser with no place of business in a state who only provides advice to mutual funds (a type of investment company), other investment advisors, broker-dealers, banks, trust companies, insurance companies, saving and loan associations, employee benefit plans such as a 401(k), where the minimum amount of the assets is $1,000,000, are exempt from registration."
    },
    {
       "id":1714,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following is a broker-dealer in North Carolina?",
       "choice_a":"An agent in South Carolina who contacts a client in North Carolina",
       "choice_b":"A corporation that sells commercial paper every other week in North Carolina",
       "choice_c":"A broker-dealer registered in South Carolina, where its only office is located, which has only insurance companies as clients in North Carolina",
       "choice_d":"None of the choices listed",
       "correct_answer":"D",
       "explanation":"Agents, issuers, and persons conducting business exclusively with institutional buyers are all exempt from the definition of a broker-dealer."
    },
    {
       "id":1715,
       "topic_id":2,
       "practice_test_id":"",
       "question":"All of the following are true regarding an agent except:",
       "choice_a":"An agent may only sell securities that have been properly registered in a state or qualify for an exemption from registration",
       "choice_b":"An agent\u0027s registration to sell securities in a given state is in effect until December 31 and then must be renewed",
       "choice_c":"An agent may only solicit business in a state if both the agent and broker-dealer are registered in the state",
       "choice_d":"If an agent leaves a broker-dealer to go to another broker-dealer, it is the sole responsibility of the agent to notify the Administrator",
       "correct_answer":"D",
       "explanation":"When an agent leaves one broker-dealer to work for another broker-dealer, the Administrator must be notified by the agent and both broker-dealers. All of the other statements are correct."
    },
    {
       "id":1716,
       "topic_id":2,
       "practice_test_id":1,
       "question":"Which of the following persons would not be considered an agent under the act?",
       "choice_a":"A person representing a broker-dealer in non-exempt transactions",
       "choice_b":"A person representing a director of an issuer who does not receive commissions",
       "choice_c":"A person representing a director of an issuer who receives commissions",
       "choice_d":"A person employed by a broker-dealer as a sales assistant who occasionally accepts client orders",
       "correct_answer":"B",
       "explanation":"A person who represents a broker-dealer is defined as an agent even if they are selling exempt securities. A person representing an issuer executing transactions with an existing employee, partner, officer or director of an issuer who does not receive any commissions or other payment directly or indirectly for soliciting the order in that state will not be considered an agent. An employee of a broker-dealer who performs only clerical functions is not considered an agent. However, if that employee accepts client orders (even unsolicited) then that person is classified as an agent and must register."
    },
    {
       "id":1717,
       "topic_id":2,
       "practice_test_id":2,
       "question":"All of the following are agents except:",
       "choice_a":"A representative of a broker-dealer effecting transactions with employees of an issuer",
       "choice_b":"A clerk taking telephone quotes",
       "choice_c":"A secretary authorized to accept orders from clients",
       "choice_d":"A salesperson of a broker-dealer effecting transactions in exempt securities",
       "correct_answer":"B",
       "explanation":"A clerk taking quotes over the telephone would not be considered an agent, since such a person is acting in a clerical or ministerial capacity, not a sales capacity. Representatives of broker-dealers taking orders or effecting transactions are considered agents, even if the securities are exempt."
    },
    {
       "id":1718,
       "topic_id":2,
       "practice_test_id":3,
       "question":"Broker-Dealer X is currently registered in state A. If the Administrator believes that X has or is about to violate some provision of the Uniform Securities Act, the Administrator may, if in the public interest, do all of the following except:",
       "choice_a":"Petition a court to issue an injunction to prevent X from violating the Act",
       "choice_b":"Issue a cease and desist order directing X to stop violations of the Act",
       "choice_c":"Fine X for activities that violate the Act",
       "choice_d":"Suspend X\u0027s broker-dealer registration",
       "correct_answer":"C",
       "explanation":"The Uniform Securities Act does not empower the Administrator to levy fines. The Administrator would have to request that the district attorney initiate criminal legal action against the broker-dealer, which could result in a fine by the court."
    },
    {
       "id":1719,
       "topic_id":2,
       "practice_test_id":4,
       "question":"The president of a company is selling his corporation's convertible bonds to the public. In this capacity, he is considered to be:",
       "choice_a":"A broker-dealer",
       "choice_b":"An agent of the issuer",
       "choice_c":"An agent of a broker-dealer",
       "choice_d":"Excluded from the definition of an agent",
       "correct_answer":"B",
       "explanation":"Unless the transaction or the securities are exempt, a person who represents an issuer in the sale of securities is considered an agent of the issuer. There is no indication in this question that the transaction or the securities are exempt."
    },
    {
       "id":1720,
       "topic_id":2,
       "practice_test_id":5,
       "question":"Which of the following is not excluded from the definition of a broker-dealer under the Uniform Securities Act?",
       "choice_a":"A bank",
       "choice_b":"An agent",
       "choice_c":"An investment adviser",
       "choice_d":"An issuer",
       "correct_answer":"C",
       "explanation":"A bank, agent, and issuer are all specifically excluded from the definition of a broker-dealer. An investment adviser, has no specific exclusion. If it performs the activities that fit the definition of a broker-dealer, it must register as such."
    },
    {
       "id":1721,
       "topic_id":2,
       "practice_test_id":6,
       "question":"Under the Uniform Securities Act, which of the following statements is (are) false concerning the definition of a broker-dealer? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A person who has no place of business in a state and effects transactions only with institutional buyers is not considered a broker-dealer. </li><li>A person who has no place of business in a state and effects transactions only with other broker-dealers is not considered a broker-dealer. </li><li>A person who has no place of business in a state and effects transactions with fewer than five clients is not considered a broker-dealer.  </li><li>A person who has a place of business in State A and sells to existing customers that are residents of State B is considered a broker-dealer in State A. </li></ol>",
       "choice_a":"III only",
       "choice_b":"I and III only",
       "choice_c":"II and IV only",
       "choice_d":"I,II, and IV only",
       "correct_answer":"A",
       "explanation":"The term broker-dealer does not include a person who has no place of business in a state and deals exclusively with other broker-dealers, institutional customers, and clients who are residents of another state. There is no de minimus exemption from the definition of a broker-dealer."
    },
    {
       "id":1722,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An agent could sell to a resident of another state if:",
       "choice_a":"Both the agent and broker-dealer are registered in that state",
       "choice_b":"The agent was formerly employed by a broker-dealer registered in that state",
       "choice_c":"The security being sold is registered in that state",
       "choice_d":"The agent is registered in an adjoining state",
       "correct_answer":"A",
       "explanation":"In order for an agent to sell securities to a resident of another state, both the agent and broker-dealer must be registered in that state."
    },
    {
       "id":1723,
       "topic_id":2,
       "practice_test_id":"",
       "question":"The limited registration provision available to Canadian broker-dealers conducting business in a state permits which of the following?",
       "choice_a":"The broker-dealer to solicit all residents of a state",
       "choice_b":"The broker-dealer to transact business with existing clients who move to a state",
       "choice_c":"The broker-dealer to transact business with Canadian residents with whom the broker-dealer had an existing relationship",
       "choice_d":"The broker-dealer to transact business with institutional investors",
       "correct_answer":"C",
       "explanation":"The provisions allowing Canadian broker-dealers to transact business in a state are limited. A broker-dealer may effect transactions with a person from Canada who is temporarily in the state if there was an existing broker-dealer-client relationship before the person entered the United States."
    },
    {
       "id":1724,
       "topic_id":2,
       "practice_test_id":"",
       "question":"All of the following describe an investment adviser representative except:",
       "choice_a":"A person who makes recommendations or gives advice regarding securities",
       "choice_b":"A person who negotiates the sale of investment advisory services",
       "choice_c":"A person who performs clerical services for an advisory firm",
       "choice_d":"A person who creates and presents written financial plans",
       "correct_answer":"C",
       "explanation":"Clerical personnel do not meet the definition of an investment adviser representative. States require that investment adviser representatives be registered."
    },
    {
       "id":1725,
       "topic_id":2,
       "practice_test_id":2,
       "question":"An exemption from the definition of an investment adviser is not given to:",
       "choice_a":"A publisher",
       "choice_b":"Someone who gives advice on industrial revenue bonds",
       "choice_c":"Broker-dealers and their agents",
       "choice_d":"Banks and trust companies",
       "correct_answer":"B",
       "explanation":"Providing advice on industrial revenue bonds, which are a type of municipal bond, does not entitle one to an exemption."
    },
    {
       "id":1726,
       "topic_id":2,
       "practice_test_id":3,
       "question":"In order for an investment adviser to maintain custody of funds and securities:",
       "choice_a":"The firm must have a three-year track record of no violations",
       "choice_b":"The investment adviser must notify the Administrator and there must be no rule against custody",
       "choice_c":"The Administrator must give permission to the investment adviser",
       "choice_d":"At least $100,000 in Treasury bills must be posted as security",
       "correct_answer":"B",
       "explanation":"An adviser must notify the Administrator of its intention to maintain custody of client funds and securities. In some cases, an Administrator may adopt a rule prohibiting an investment adviser from taking possessions."
    },
    {
       "id":1727,
       "topic_id":2,
       "practice_test_id":4,
       "question":"The compensation of an investment adviser is usually based on:",
       "choice_a":"The percentage of successful trades",
       "choice_b":"A percentage of the average value of the account",
       "choice_c":"The level of interest rates",
       "choice_d":"Profits generated in the account",
       "correct_answer":"B",
       "explanation":"Investment adviser compensation is usually based on a percentage of the assets under management. This is usually calculated based upon the average value of the account."
    },
    {
       "id":1728,
       "topic_id":2,
       "practice_test_id":5,
       "question":"According to the Uniform Securities Act, if an advisory firm concentrates its advice on New York Stock Exchange securities, the firm:",
       "choice_a":"Can seek an exemption from registration as an adviser",
       "choice_b":"Will be subject to the rules of the New York Stock Exchange",
       "choice_c":"Is not engaging in a  practice that would be considered a violation",
       "choice_d":"Can only receive commissions as compensation",
       "correct_answer":"C",
       "explanation":"There is nothing wrong with giving advice that is limited to NYSE issues. Only members of the NYSE are subject to its rules."
    },
    {
       "id":1729,
       "topic_id":2,
       "practice_test_id":6,
       "question":"A sole proprietor who was registered as a broker-dealer is now charging a separate fee for securities advice. According to the Uniform Securities Act, the sole proprietor:",
       "choice_a":"Has an exemption from registration as an investment adviser",
       "choice_b":"Would have to register as an investment adviser",
       "choice_c":"Must change from sole proprietor to another business structure in order to become an investment adviser",
       "choice_d":"Must only register if the activities are called financial planning",
       "correct_answer":"B",
       "explanation":"Any business entity not specifically exempted from registration and charging a separate fee for administering advice, is subject to registration as an investment adviser. Broker-dealers are excluded from the definition of investment adviser if they provided only incidental advice with no separate, identifiable charge."
    },
    {
       "id":1730,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An agent's application includes which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A filing fee </li><li>Work history </li><li>A consent to service of process</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"An agent's application contains all of the items listed."
    },
    {
       "id":1731,
       "topic_id":2,
       "practice_test_id":"",
       "question":"SIA is a broker-dealer registered in the state of Florida. An existing client of the firm who is a resident of Florida is on a ski vacation in Alaska. Under the Uniform Securities Act, which of the following is TRUE if a securities transaction is effected with the client in Alaska?",
       "choice_a":"SIA would need to register as a broker-dealer in Alaska",
       "choice_b":"SIA would not need to register as a broker-dealer in Alaska if the agent selling the securities was registered in Alaska",
       "choice_c":"SIA would not need to register as a broker-dealer in Alaska if the client signed an agreement",
       "choice_d":"SIA would not need to register as a broker-dealer in Alaska if it has no office there",
       "correct_answer":"D",
       "explanation":"Since the client's residence is in Florida, the trade is valid. SIA does not need to register in Alaska because it does not have an office there."
    },
    {
       "id":1732,
       "topic_id":2,
       "practice_test_id":6,
       "question":"According to the Uniform Securities Act, if a prospective agent has an impaired financial condition, the Administrator may:",
       "choice_a":"Issue an indictment",
       "choice_b":"Deny registration",
       "choice_c":"Require a consent to service of process",
       "choice_d":"Require an amendment to Form ADV",
       "correct_answer":"B",
       "explanation":"The Administrator may deny registration because a prospective agent is insolvent. Indictments are criminal charges for alleged violations of law. The consent to service of process and amendments to Form ADV are not needed since registration would be denied."
    },
    {
       "id":1733,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investment adviser is registered in North Carolina and South Carolina. A broker-dealer is registered only in North Carolina. The client is a resident of South Carolina. The investment adviser asks the broker-dealer to purchase a nonexempt security, which is registered in South Carolina, for the advisory client. The broker-dealer:",
       "choice_a":"Should refuse the order because the broker-dealer is not registered in the state in which the client resides",
       "choice_b":"Can accept the order as long as this practice does not occur with any regularity",
       "choice_c":"Can accept the order only if the client places the order",
       "choice_d":"Can accept the order if the broker-dealer has no place of business in South Carolina",
       "correct_answer":"D",
       "explanation":"The term \u0022broker-dealer\u0022 excludes any person who has 1) no place of business in the North Carolina and 2) transacts business with or through a financial institution or institutional buyer, whether acting for itself or as a trustee."
    },
    {
       "id":1734,
       "topic_id":2,
       "practice_test_id":1,
       "question":"Under the Uniform Securities Act, a person effecting transactions in commodities",
       "choice_a":"Is subject to oversight by the Administrator",
       "choice_b":"Does not meet the definition of an agent",
       "choice_c":"Avoids the definition of an agent only if the person\u0027s duties are merely clerical",
       "choice_d":"Is automatically considered an agent if his or her employer is a broker-dealer",
       "correct_answer":"B",
       "explanation":"Since commodities are not securities, a person effecting transactions in commodities is not considered an agent."
    },
    {
       "id":1735,
       "topic_id":2,
       "practice_test_id":2,
       "question":"Under the Uniform Securities Act, which of the following would not have to be disclosed when filing a registration by qualification?",
       "choice_a":"A statement analyzing the issuer\u0027s profit margin over the last three years compared to the profit margins of its primary competitors",
       "choice_b":"The capitalization and long-term debt of the issuer and any significant subsidiary",
       "choice_c":"The general character and location of the issuer\u0027s business and a statement of the general competitive conditions within the industry or business in which it operates",
       "choice_d":"The estimated cash proceeds to be received by the issuer from the offering",
       "correct_answer":"A",
       "explanation":"An analysis of the issuer's profit margin as compared to competitors' would not be required. All other items listed would be required when filing a registration by qualification."
    },
    {
       "id":1736,
       "topic_id":2,
       "practice_test_id":3,
       "question":"According to the Uniform Securities Act, an employee who is not registered as an agent may do which of the following?",
       "choice_a":"Take phone messages and post records",
       "choice_b":"Accept unsolicited orders",
       "choice_c":"Participate in an exempt transaction",
       "choice_d":"Participate in the distribution of an exempt security",
       "correct_answer":"A",
       "explanation":"A person need not be registered as an agent to take messages and post records."
    },
    {
       "id":1737,
       "topic_id":2,
       "practice_test_id":4,
       "question":"According to the Uniform Securities Act, an entity can avoid meeting the definition of a broker-dealer if it: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Has no office in the state </li><li>Only deals with institutional clients </li><li>Does not hold customer funds or securities</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I and II only",
       "choice_d":"II and III only",
       "correct_answer":"C",
       "explanation":"If a broker-dealer has no office in a state and effects transactions only with institutional clients, it would be exempt from the definition of a broker-dealer. An institutional broker-dealer cannot qualify for this exemption if it has an office in the state, even if it avoids holding customer funds and securities."
    },
    {
       "id":1738,
       "topic_id":2,
       "practice_test_id":5,
       "question":"Registration by qualification becomes effective:",
       "choice_a":"30 days after the filing date",
       "choice_b":"60 days after the filing date",
       "choice_c":"When determined by the Administrator",
       "choice_d":"In conjunction with federal registration",
       "correct_answer":"C",
       "explanation":"Registration by qualification becomes effective when determined by the Administrator."
    },
    {
       "id":1739,
       "topic_id":2,
       "practice_test_id":6,
       "question":"Under the Uniform Securities Act, if information regarding an agent changes, it is the agent's responsibility to file an amendment:",
       "choice_a":"Within 10 days",
       "choice_b":"Within 30 days",
       "choice_c":"Within a reasonable amount of time",
       "choice_d":"Promptly",
       "correct_answer":"D",
       "explanation":"If information regarding an agent changes, the agent must file an amendment with the Administrator promptly."
    },
    {
       "id":1740,
       "topic_id":2,
       "practice_test_id":"",
       "question":"If a bank owned a broker-dealer subsidiary, what would its registration requirements be under the USA?",
       "choice_a":"Since banks are exempt from state securities registration, the subsidiary would also be exempt",
       "choice_b":"If the subsidiary is registered with the SEC, it would be exempt from registering with any particular state",
       "choice_c":"The subsidiary would need to register in any state in which it planned to do business",
       "choice_d":"The subsidiary would register in all states under the provisions of qualification",
       "correct_answer":"C",
       "explanation":"Commercial banks, thrifts, and savings and loans are specifically exempted from the definition of a broker-dealer. However, a broker-dealer subsidiary of a bank would still be required to be registered as a broker-dealer."
    },
    {
       "id":1741,
       "topic_id":2,
       "practice_test_id":"",
       "question":"With reference to the Uniform Securities Act, once agents are registered, their registration remains in effect:",
       "choice_a":"Until December 31",
       "choice_b":"For one year",
       "choice_c":"For five years",
       "choice_d":"As long as the agent is associated with a broker-dealer",
       "correct_answer":"A",
       "explanation":"Under the Uniform Securities Act, every registration expires on December 31st."
    },
    {
       "id":1742,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A broker-dealer's original application filed with the state includes all of the following except:",
       "choice_a":"Place of business",
       "choice_b":"Form of business organization",
       "choice_c":"Type of services rendered",
       "choice_d":"Fingerprints",
       "correct_answer":"D",
       "explanation":"Fingerprints are not required for a broker-dealer's registration. The other items listed are disclosures found in the broker-dealer application."
    },
    {
       "id":1743,
       "topic_id":2,
       "practice_test_id":2,
       "question":"A security adviser registers May 1st  with company XYZ, but then quits and goes to work with company ABC in the same state on November 1st.  What must he do to register?",
       "choice_a":"Register on November 1st  and again on January 1st",
       "choice_b":"Pay prorated registration on November 1st",
       "choice_c":"Reregister May 1st of the following year",
       "choice_d":"Need not do anything new",
       "correct_answer":"A",
       "explanation":"If an adviser moves from one firm to another they must register with the state as being an adviser with the new firm when the employment starts, in this case on November 1st. All advisers must renew their registration for the new year by January 1st."
    },
    {
       "id":1744,
       "topic_id":2,
       "practice_test_id":3,
       "question":"When does an agent's registration expire?",
       "choice_a":"On their birthday",
       "choice_b":"December 31st",
       "choice_c":"Year to date of registration",
       "choice_d":"Never",
       "correct_answer":"B",
       "explanation":"All registrations of firms and agents expire on December 31st and must be properly renewed each year."
    },
    {
       "id":1745,
       "topic_id":2,
       "practice_test_id":4,
       "question":"A broker dealer requests to withdraw their registration.  Barring action by the administrator, when will the request become effective?",
       "choice_a":"45 days",
       "choice_b":"60 days",
       "choice_c":"15 days",
       "choice_d":"30 days",
       "correct_answer":"D",
       "explanation":"If a broker dealer requests that their registration within a state be withdrawn the request will become effective 30 days after the request is received so long as the administrator is not in the process of taking action against the firm."
    },
    {
       "id":1746,
       "topic_id":2,
       "practice_test_id":5,
       "question":"An IAR works for a firm registered in New York that has clients in Florida.  The IAR has a single client investing $10,000,000 in Colorado.  Where does the IAR have to register? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Florida </li><li>New York </li><li>Colorado</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I and II",
       "choice_d":"I, II and III",
       "correct_answer":"C",
       "explanation":"The IAR must register where the firm is registered (NY) and where they have clients (FL). The IAR would not be required to register in Colorado because the only have 1 client in that state and because the firm is not registered in Colorado. Under the rule an adviser may have or give advice to up to five clients in a 12 month period without being required to register."
    },
    {
       "id":1747,
       "topic_id":2,
       "practice_test_id":6,
       "question":"When a broker-dealer registers, who is automatically registered as well?",
       "choice_a":"Agent",
       "choice_b":"Principal",
       "choice_c":"Office Manager",
       "choice_d":"Sales Clerk",
       "correct_answer":"B",
       "explanation":"When a broker dealer registers in a state a principal of the firm is automatically required to register in that state."
    },
    {
       "id":1748,
       "topic_id":2,
       "practice_test_id":"",
       "question":"With whom can you split a commission?",
       "choice_a":"Clerical staff who helped with the client",
       "choice_b":"Someone who has taken but not passed the registration test",
       "choice_c":"The manager of the office who is also a registered agent",
       "choice_d":"An IAR who is not registered in that state",
       "correct_answer":"C",
       "explanation":"An agent may split commissions with someone who is also registered as an agent, in this case the office manger who is also registered as an agent."
    },
    {
       "id":1749,
       "topic_id":2,
       "practice_test_id":"",
       "question":"The net capital requirement for an agent cannot exceed:",
       "choice_a":"The SEC required level",
       "choice_b":"FINRA\u0027S required level",
       "choice_c":"The fee for each state in which they are registered",
       "choice_d":"The lowest fee for a state in which they are registered",
       "correct_answer":"C",
       "explanation":"The state can not require an agent to meet any net capital requirement other than the ability to pay the registration fees in each state in which they wish to conduct business."
    },
    {
       "id":1750,
       "topic_id":2,
       "practice_test_id":1,
       "question":"A broker dealer does not need to register in a state when the firm has no office in a state, and: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Works only with banks </li><li> Works only with wealthy investors </li><li>Works with institutional investors </li><li> Works with savings and loans </li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"The broker dealer would not have to register if there was no office in the state and did business only with banks, institutional investors or savings and loans. If the firm conducted business with individual investors the firm would have to register."
    },
    {
       "id":1751,
       "topic_id":2,
       "practice_test_id":2,
       "question":"A Canadian agent registered in the Alberta Province wants to do business with a client while they are on vacation in New Mexico.  This is:",
       "choice_a":"Not allowed as Canadians cannot perform business in the US",
       "choice_b":"Acceptable as long as they register within New Mexico",
       "choice_c":"Acceptable even without registration",
       "choice_d":"Only allowed if given special dispensation from the SEC",
       "correct_answer":"C",
       "explanation":"Canadian broker dealers and agents duly registered in Canada can transact business with a client traveling in New Mexico ( or any state)  temporarily without having to register with the state of New Mexico ( or any state)."
    },
    {
       "id":1752,
       "topic_id":2,
       "practice_test_id":3,
       "question":"Which of the following are not required at the time of initial registration of a broker dealer?",
       "choice_a":"Fees",
       "choice_b":"Application",
       "choice_c":"Fingerprints of president",
       "choice_d":"Consent to service of process",
       "correct_answer":"C",
       "explanation":"All of the choices listed are required at the time a broker dealer registers with the state except the finger prints of the president."
    },
    {
       "id":1753,
       "topic_id":2,
       "practice_test_id":4,
       "question":"If an investment adviser  works in state A and has a client who is a bank in state B, the investment adviser must register if: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investment adviser opens a place of business in B </li><li>The investment adviser has more than 5 banking clients in state B in the last 12 months </li><li>The investment adviser gets an individual client in state B </li><li>The investment adviser opens accounts for 11 individual clients in state B </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I only",
       "correct_answer":"A",
       "explanation":"If an investment adviser opens accounts for 11 individuals or opens an office in state B the investment adviser would be required to register in state B."
    },
    {
       "id":1754,
       "topic_id":2,
       "practice_test_id":5,
       "question":"If an investment adviser works in state A and advises institutional clients in state B the investment adviser must register if:",
       "choice_a":"The investment adviser  wants to do any work in state B",
       "choice_b":"The investment adviser  has up to 12 institutional clients in state B",
       "choice_c":"The investment adviser  has more than 5 institutional clients in state B",
       "choice_d":"Only if the investment adviser opens a business in state B",
       "correct_answer":"D",
       "explanation":"If an investment adviser works in state A and advises only institutional clients in state B the investment adviser would only have to register in state B if the investment adviser opened up a place of business in state B."
    },
    {
       "id":1755,
       "topic_id":2,
       "practice_test_id":6,
       "question":"An investment adviser is registered with their home state on June 15th, when do they have to re register?",
       "choice_a":"30-Jun",
       "choice_b":"31-Dec",
       "choice_c":"December 31 of the next year",
       "choice_d":"12 months from issuance of registration",
       "correct_answer":"B",
       "explanation":"All registrations at the state level must be renewed or re registered on December 31st of every year."
    },
    {
       "id":1756,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investment adviser who is also an agent of a broker dealer, guarantees a client that the securities they are investing in will outperform US Bonds. This is:",
       "choice_a":"Acceptable because they are an agent as well",
       "choice_b":"Not acceptable because they are guaranteeing performance",
       "choice_c":"Acceptable because they do not cite a specific rate",
       "choice_d":"Not acceptable as an investment adviser may not represent a broker dealer",
       "correct_answer":"B",
       "explanation":"An investment adviser may never guarantee the performance of any investment, promise a return or promise no loss for any reason."
    },
    {
       "id":1757,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investment adviser borrows money from a client, this is:",
       "choice_a":"Never allowed",
       "choice_b":"Allowed if given permission",
       "choice_c":"Allowed if the client is a broker-dealer",
       "choice_d":"Allowed if the client is a long time friend prior to becoming a client",
       "correct_answer":"C",
       "explanation":"An investment adviser may borrow money from a broker dealer who is in the business of making loans for such things as a margin account. An investment adviser may also borrow money from a bank so long as the bank is in the business of making such loans."
    },
    {
       "id":1758,
       "topic_id":2,
       "practice_test_id":"",
       "question":"When an agent switches firms what notifications are required? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The agent is required to notify the administrator  </li><li>The former firm is required to notify the administrator </li><li>The new firm is required to notify the administrator </li><li>The agent must contact all old clients at the old firm to inform them he has left the firm and will no longer be servicing their account </li></ol>",
       "choice_a":"I Only",
       "choice_b":"II and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"When an agent leaves a firm the agent, the old firm and the new firm are all required to notify the administrator. The agent is not required to contact the clients to tell them that he is leaving."
    },
    {
       "id":1759,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A blue chip exemption is offered to which of the following?",
       "choice_a":"Preorganization certificates",
       "choice_b":"Subordinated debentures of XYZ Corp. XYZ\u0027s Common stock is listed on the Pacific Stock Exchange",
       "choice_c":"Commercial paper",
       "choice_d":"US Treasury bonds",
       "correct_answer":"B",
       "explanation":"A blue chip exemption is given to the securities of any issuer whose common stock is listed on a US stock exchange."
    },
    {
       "id":1760,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A company would be required to register under qualification if: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is a 10 year old company with a net worth of $15,000,000 and it is planning to raise money for the first time through the sale of securities in its home state. </li><li>It is a 2 year old company selling securities in 11 states simultaneously </li><li> It is a 2 year old company that has previously sold securities in 4 other states and now wants to raise additional cash by selling securities in another state. </li><li>It is a 2 year old company selling securities to investors for the first time through a private placement. </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"Only the company selling securities in its home state for the first time and the two year old company who had sold securities in four other states would be required to register through qualification. Even though the ten year old company meets some of the requirements to register through notification, they are selling securities for the first time in their home state only."
    },
    {
       "id":1761,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A federally covered exemption is given to all of the following except:",
       "choice_a":"Option contracts",
       "choice_b":"Employee benefit plans",
       "choice_c":"XYZ debentures XYZ\u0027s common stock is listed on the Boston Stock exchange",
       "choice_d":"ABC preferred stock listed on the OTC BB",
       "correct_answer":"D",
       "explanation":"A federally covered exemption is only given to NASDAQ securities. A security trading on the OTCBB is not a covered security"
    },
    {
       "id":1762,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A firm participating in the offering of a private placement may offer the private placement to:",
       "choice_a":"No more than twelve non-accredited investors in any twelve month period.",
       "choice_b":"No more than six non-accredited investors in any twelve month period.",
       "choice_c":"No more than ten non-accredited investors in any twelve month period.",
       "choice_d":"No more than fifteen non accredited investors in any twelve month period.",
       "correct_answer":"C",
       "explanation":"The number of non-accredited investors is limited to ten in any twelve month period."
    },
    {
       "id":1763,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A newly formed company wanting to raise money by selling securities in its home state would most likely use what type of registration for the securities being offered ?",
       "choice_a":"Coordination",
       "choice_b":"Application",
       "choice_c":"Qualification",
       "choice_d":"Whichever method is required by the State Securities Administrator",
       "correct_answer":"C",
       "explanation":"A company selling securities only in its home state would register the securities with the State Securities Administrator through qualification."
    },
    {
       "id":1764,
       "topic_id":3,
       "practice_test_id":1,
       "question":"A registration fee for a registration application:",
       "choice_a":"Is paid for all initial and renewal applications",
       "choice_b":"Is required by every state",
       "choice_c":"May be partially retained by the administrator if the registration is denied or withdrawn",
       "choice_d":"All of the choices listed are correct",
       "correct_answer":"D",
       "explanation":"Each of the above is true about a filing fee for a registration application."
    },
    {
       "id":1765,
       "topic_id":3,
       "practice_test_id":2,
       "question":"A security sold directly to a bank in a neighboring state for its investment account would represent which of the following, if the firm has no place of business in the state?",
       "choice_a":"An exempt security",
       "choice_b":"A private placement",
       "choice_c":"An exempt security",
       "choice_d":"An exempt transaction",
       "correct_answer":"D",
       "explanation":"Any transaction with a bank would represent an exempt transaction."
    },
    {
       "id":1766,
       "topic_id":3,
       "practice_test_id":3,
       "question":"A security would be entitled to a manual exemption if information relating to the company could be found in all of the following except",
       "choice_a":"Moody\u0027s",
       "choice_b":"Fitch\u0027s",
       "choice_c":"Standard and Poor\u0027s",
       "choice_d":"NASDAQ Composite",
       "correct_answer":"D",
       "explanation":"A security would be entitled to a manual exemption if information relating to the issuer could be found in a nationally recognized manual such as Moody's or Standard and Poor's. The NASDAQ Composite is an index, not a published manual."
    },
    {
       "id":1767,
       "topic_id":3,
       "practice_test_id":4,
       "question":"ABC wants to issue $15,000,000 worth of subordinated debentures maturing in 20 years. Which of the following governs the issuance of these securities?",
       "choice_a":"The Securities Lending Act of 1941",
       "choice_b":"The Securities Act of 1934",
       "choice_c":"The Trust Indenture Act of 1939",
       "choice_d":"The Corporate Finance Act of 1935",
       "correct_answer":"C",
       "explanation":"The Trust Debenture Act of 1939 regulates the issuance of corporate debt in excess of $10,000,000 and longer than 1 year."
    },
    {
       "id":1768,
       "topic_id":3,
       "practice_test_id":5,
       "question":"All but which of the following is true about the National Securities Market Act of 1996?",
       "choice_a":"It was passed to minimize the dual registration of investment advisers at both the state and federal levels",
       "choice_b":"It requires that advisers with assets under management of $100,000,000 or more must register with the state government only; they must notify the federal government and pay a federal filing fee only",
       "choice_c":"It requires that investment advisers with assets under management of $100,000,000 or more register with the SEC; they are then known as federally registered advisers",
       "choice_d":"It requires that federally registered advisers notify the state in which they do business and pay a state filing fee",
       "correct_answer":"B",
       "explanation":"The National Securities Market Act of 1996 requires that investment advisers with assets under management of $100,000,000 or more must register with the federal government, the SEC, and notify the state and pay a state filing fee in the states where they do business."
    },
    {
       "id":1769,
       "topic_id":3,
       "practice_test_id":6,
       "question":"All of the following are true of exempt commercial paper except for which of the following statements?",
       "choice_a":"It has a maturity of up to one year",
       "choice_b":"It is a discounted security",
       "choice_c":"It trades in the money markets",
       "choice_d":"Its is backed by a line of credit at a bank",
       "correct_answer":"A",
       "explanation":"Commercial Paper has a maximum maturity of 270 days.  It is considered a discounted short term debt instrument issued by a company and backed by a bank line of credit.  Commercial paper is also considered a money market instrument."
    },
    {
       "id":1770,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following securities are considered exempt from SEC and state registration requirements except for which?",
       "choice_a":"Private Placements",
       "choice_b":"Foreign Federal Securities",
       "choice_c":"Direct Participation Programs",
       "choice_d":"Credit Union Issues",
       "correct_answer":"C",
       "explanation":"Direct Participation Programs are required to be registered as a security with both the Securities & Exchange Commission and each state that the Direct Participation Program intends to be sold in.  Private Placements, Foreign Federal Securities and Credit Union Issues are all considered to be exempt securities for registration filing."
    },
    {
       "id":1771,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All securities sold or offered for sale must be properly registered prior to the offering in each state in which it is to be offered unless:",
       "choice_a":"It is an exempt security",
       "choice_b":"It is sold in an exempt transaction",
       "choice_c":"It is a federally covered security",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All securities sold or offered for sale must be properly registered prior to the offering in each state in which it is to be offered unless it is an exempt security, is sold in an exempt transaction, or is a federally covered security."
    },
    {
       "id":1772,
       "topic_id":3,
       "practice_test_id":2,
       "question":"An agent represents an issuer in the sale of short term commercial paper in sales with the public and receives a fee when it is sold. The commercial paper has a maximum duration of one year or less and is sold in denominations of $100,000 or more. Which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The agent need not register </li><li>The commercial paper is exempt  </li><li>The commercial paper is given a federally covered exemption </li><li>The agent register</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I, and II",
       "choice_c":"II and III",
       "choice_d":"IV only",
       "correct_answer":"D",
       "explanation":"The commercial paper is only given a federally covered exemption if it is less than 270 and sold in denominations of $50,000 or more. The agent in this case is selling the commercial paper to the public and receives a fee when it is sold and therefore must register."
    },
    {
       "id":1773,
       "topic_id":3,
       "practice_test_id":3,
       "question":"An issuer has registered securities within a state under coordination. Which of the following is not true?",
       "choice_a":"The state registration will become effective within ten days or at the time the federal registration becomes effective",
       "choice_b":"The issuer must be engaged in an intrastate offering of its securities",
       "choice_c":"The issuer\u0027s registration must not yet be effective at the federal level",
       "choice_d":"The State Administrator sets specific fees for the issuer",
       "correct_answer":"B",
       "explanation":"In order for an issuer to register through coordination, they must be engaging in a interstate offering of securities, not an intrastate offering. All of the other choices are true."
    },
    {
       "id":1774,
       "topic_id":3,
       "practice_test_id":4,
       "question":"An issuer selling securities to the public for the first time has registered their securities with the states through coordination. The state registration will become effective:",
       "choice_a":"In 10 days",
       "choice_b":"In 20 days",
       "choice_c":"At the time the federal registration becomes effective",
       "choice_d":"At the time the administrator approves the registration",
       "correct_answer":"C",
       "explanation":"Registration through coordination becomes effective at the same time the federal registration becomes effective."
    },
    {
       "id":1775,
       "topic_id":3,
       "practice_test_id":5,
       "question":"An officer of a national hardware franchise gets paid a commission when they sell a new franchise. Which of the following is true?",
       "choice_a":"The individual is not required to register and has nothing to do with the securities industry",
       "choice_b":"The individual would only have to register if they get paid for the sale of 10 or more per year",
       "choice_c":"The individual is required to register",
       "choice_d":"The USA does not concern itself with licensing agreements",
       "correct_answer":"C",
       "explanation":"The individual works for the issuer and gets paid based on the sale of the  franchise. The individual is required to register."
    },
    {
       "id":1776,
       "topic_id":3,
       "practice_test_id":6,
       "question":"As per the Securities Act of 1933, which of the following securities are considered to be non-exempt? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Treasury Bonds  </li><li> Municipal Bonds  </li><li>Corporate Bonds  </li><li> Open End Investment Companies </li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I, II, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"A non-exempt security is a security that must register a new offering with the Securities & Exchange Commission.  Only corporate bonds and Open End Investment Companies would fit this description."
    },
    {
       "id":1777,
       "topic_id":3,
       "practice_test_id":"",
       "question":"At the conclusion of the 20-day cooling off period of a new issue registration, the SEC will award which of the following if all information is deemed acceptable?",
       "choice_a":"A settlement date",
       "choice_b":"A trade date",
       "choice_c":"An effective date",
       "choice_d":"A payable date",
       "correct_answer":"C",
       "explanation":"An effective date will be awarded by the Securities & Exchange Commission at the conclusion of the 20-day cooling off period, if the applying issuer registration information is deemed acceptable."
    },
    {
       "id":1792,
       "topic_id":3,
       "practice_test_id":"",
       "question":"The most difficult method of registration due to the extensive details of disclosure required is called:",
       "choice_a":"Registration by filing or notification",
       "choice_b":"Registration by coordination",
       "choice_c":"Registration by administration",
       "choice_d":"Registration by qualification",
       "correct_answer":"D",
       "explanation":"The most difficult method of registration, due to the extensive details of disclosure required, is called registration by qualification."
    },
    {
       "id":1793,
       "topic_id":3,
       "practice_test_id":1,
       "question":"The Uniform Securities Act provides for the registration of all non-exempt securities by each of the following methods except:",
       "choice_a":"Registration by filing or notification",
       "choice_b":"Registration by coordination",
       "choice_c":"Registration by administration",
       "choice_d":"Registration by qualification",
       "correct_answer":"C",
       "explanation":"There is no such method as registration by administration."
    },
    {
       "id":1794,
       "topic_id":3,
       "practice_test_id":2,
       "question":"The USA regulates which of the following as it relates to the sales of private placements to non-accredited investors? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The number of offers that can be made </li><li>The number of sales that can be made </li><li>Agent compensation </li><li>The information that must be made available to investors </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II, III, IV",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"All of the choices listed are correct except IV. There are no rules that offerees must be given certain information relating to the private placement."
    },
    {
       "id":1795,
       "topic_id":3,
       "practice_test_id":3,
       "question":"What is the difference between an issuer transaction and a non-issuer transaction?",
       "choice_a":"In an issuer transaction, the issuer first proposes the transaction, whereas in a non-issuer transaction, a board of directors first proposes the transaction",
       "choice_b":"An issuer transaction involves securities, and a non-issuer transaction involves debentures",
       "choice_c":"In an issuer transaction, the proceeds go directly to the issuer, but in a non-issuer transaction, the issuer does not receive the proceeds from the sale of the securities",
       "choice_d":"An issuer transaction includes voting trust certificates and equipment trust certificates, whereas a non-issuer transaction involves mining leases and oil and gas drilling programs",
       "correct_answer":"C",
       "explanation":"The main difference between issuer transactions and non-issuer transactions is in where the proceeds from the sale go; in an issuer transaction the proceeds go directly to the issuer, whereas in a non-issuer transaction the proceeds do not directly benefit the issuer."
    },
    {
       "id":1796,
       "topic_id":3,
       "practice_test_id":4,
       "question":"What is the first step Dr. Dogwood must follow when he registers The Dogwood Corporation prior to offering its stock for sale?",
       "choice_a":"Filing of the registration statement",
       "choice_b":"Filing of the appropriate filing fee",
       "choice_c":"Filing of the registration statement accompanied by the filing fee",
       "choice_d":"Establishing the escrow account to hold proceeds from the sale",
       "correct_answer":"C",
       "explanation":"The initial step in registering is filing the registration statement (which includes the information on the offering) accompanied by the appropriate filing fee, usually based on a percentage of the total offering price of the security."
    },
    {
       "id":1797,
       "topic_id":3,
       "practice_test_id":5,
       "question":"When an issuer of a new security in the market  registers the same security in each state that it is to be sold, as well as with the SEC, this is known as what type of registration?",
       "choice_a":"A non-exempt registration",
       "choice_b":"A Registration by coordination",
       "choice_c":"A Registration by notification",
       "choice_d":"A Registration by qualification",
       "correct_answer":"B",
       "explanation":"Registration by Coordination will enable an issuer to register their new issue in each state that they intend to sell the security."
    },
    {
       "id":1798,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Which of the following are always exempt? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Common carriers </li><li>Foreign provincial governments </li><li>Regulated utilities </li><li>Insurance companies </li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are always exempt except foreign provincial governments."
    },
    {
       "id":1799,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is a prohibited practice?",
       "choice_a":"A broker dealer purchases a common stock for its own account and immediately flips it to a customer\u0027s account for a profit",
       "choice_b":"A broker dealer makes a market in multiple stocks at the same time",
       "choice_c":"An investment adviser who charges a fee also receives a commission for executing a client\u0027s orders",
       "choice_d":"A broker dealer purchases shares for its own account just prior to entering a customer\u0027s market buy order",
       "correct_answer":"D",
       "explanation":"The broker dealer has committed a violation known as front running. They entered their order to purchase the shares before they entered the customer's order to purchase the shares."
    },
    {
       "id":1800,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is an exempt transaction?",
       "choice_a":"A transaction in an exchange listed security",
       "choice_b":"A transaction in a US government security",
       "choice_c":"A transaction in large denomination commercial paper",
       "choice_d":"A transaction executed at the customer\u0027s request",
       "correct_answer":"D",
       "explanation":"An unsolicited transaction is an example of an unsolicited transaction."
    },
    {
       "id":1801,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is an exempt transaction?",
       "choice_a":"A transaction with a high net worth client in state",
       "choice_b":"A sale of a 30-year Treasury bond to the account of a conservative investor",
       "choice_c":"A transaction executed with a trustee for 500 shares of a biotech stock",
       "choice_d":"A sale of an investment company security to the account of a long term investor",
       "correct_answer":"C",
       "explanation":"Transactions with fiduciaries are all exempt, regardless of what type of security is involved."
    },
    {
       "id":1802,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following securities are exempt under the USA? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A nationally chartered bank </li><li>An insurance holding company </li><li>Consolidated Trucking Company's common stock </li><li>Unsecured corporate promissory notes with 180 days to maturity </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"I and II",
       "choice_c":"I, III, and IV",
       "choice_d":"I, II, III and IV",
       "correct_answer":"C",
       "explanation":"All of the securities issued are exempt from registration except an insurance holding company. Insurance company securities are exempt, but not insurance holding companies. Common carrier securities are exempt such as airlines, railroads, and trucking companies."
    },
    {
       "id":1803,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following securities are exempt under the USA: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Treasury Note </li><li>Municipal GO </li><li>UIT </li><li>The common stock of an airline </li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II,  III,  IV",
       "correct_answer":"D",
       "explanation":"All of the securities listed are exempt under the USA. All federal and municipal securities are exempt. All securities that are registered under The Investment Company Act of 1940 are exempt, such as a UIT, and all common carrier securities are also exempt"
    },
    {
       "id":1804,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Which of the following would be required to be registered in each state in which a new issue that is coming to market is being sold? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The issuer's securities which are the subject of the offering  </li><li>The broker dealer of the offering  </li><li>The underwriter of the offering  </li><li>The syndicate members of the offering </li></ol>",
       "choice_a":"I only",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"Under the Uniform Securities Act, all of the listed entities would be required to be registered in each respective state in which a new issue is being offered.  This includes the issuer's securities, the underwriter, the broker dealers selling the issue, and all syndicate members.  There would be no exceptions to this requirement for the entities listed in the question."
    },
    {
       "id":1805,
       "topic_id":3,
       "practice_test_id":1,
       "question":"You work for a large broker dealer and have been working closely with a small company whose stock is traded over the counter. You want to recommend the stock to a client in a distant state. The stock of the issuer is not registered in the state and does not qualify for an exemption from registration. You feel that the stock is an excellent recommendation for your customer. Which of the following is true?",
       "choice_a":"The agent may execute the order if the client agrees that the trade was unsolicited",
       "choice_b":"The agent may not execute the order",
       "choice_c":"The agent may execute the order, so long as the issuer has been reporting results as require under The Securities Exchange Act of 1934",
       "choice_d":"Executing the order would subject both the agent and the firm to action by the administrator",
       "correct_answer":"C",
       "explanation":"The agent may execute the order as an isolated non-issuer transaction, so long as the company has been reporting its results as required by the Securities Exchange Act of 1934."
    },
    {
       "id":1806,
       "topic_id":3,
       "practice_test_id":2,
       "question":"A guaranteed security is one in which:",
       "choice_a":"The payment of principal by the backer is guaranteed",
       "choice_b":"The payment of interest by the backer is guaranteed",
       "choice_c":"The payment of dividends by the backer is guaranteed",
       "choice_d":"All of the choices listed are true",
       "correct_answer":"D",
       "explanation":"A guaranteed security is one in which the payment of principal, interest, and/or dividends by the backer is guaranteed."
    },
    {
       "id":1807,
       "topic_id":3,
       "practice_test_id":3,
       "question":"All of the following are considered to be an issuer except:",
       "choice_a":"A corporation that proposes to go public, but who has not yet done so.",
       "choice_b":"The US government",
       "choice_c":"State and local governments",
       "choice_d":"A bank",
       "correct_answer":"D",
       "explanation":"A bank is not considered to be an issuer. All of the other choices listed are issuers. A corporation is considered to be an issuer even if it just proposes to issue securities."
    },
    {
       "id":1808,
       "topic_id":3,
       "practice_test_id":4,
       "question":"All of the following are not considered to be securities according to NASAA except:",
       "choice_a":"Trade confirmations",
       "choice_b":"Retirement plans",
       "choice_c":"Individual stock futures",
       "choice_d":"Fixed annuity",
       "correct_answer":"C",
       "explanation":"An individual stock future is considered to be a security."
    },
    {
       "id":1809,
       "topic_id":3,
       "practice_test_id":5,
       "question":"An agent is recommending a convertible preferred stock to their clients. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>This is an offer of the preferred stock </li><li>This is a sale of the preferred stock </li><li>This is an offer of the common stock </li><li>This is subject to the jurisdiction of the Administrator </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"I, III, and IV",
       "choice_c":"II, III and IV",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"An offer of a convertible security is considered to include an offer of the security into which it is convertible."
    },
    {
       "id":1810,
       "topic_id":3,
       "practice_test_id":6,
       "question":"An institutional investor is all of the following except:",
       "choice_a":"An accredited investor with $2,500,000 in their account",
       "choice_b":"A bank",
       "choice_c":"An insurance company",
       "choice_d":"An employee benefit plan with $1,300,000 in assets",
       "correct_answer":"A",
       "explanation":"An accredited investor is not an institutional investor."
    },
    {
       "id":1811,
       "topic_id":3,
       "practice_test_id":"",
       "question":"As a type of security, corporate issues include which of the following?",
       "choice_a":"Common stock, preferred stock, warrants, and rights",
       "choice_b":"Notes, bonds, and debentures",
       "choice_c":"Equipment, collateral, and voting trust certificates",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Corporate issues include all of the choices listed as types of securities."
    },
    {
       "id":1812,
       "topic_id":3,
       "practice_test_id":"",
       "question":"As a type of security, government issues may include which of the following?",
       "choice_a":"Common stock, preferred stock, warrants, and rights",
       "choice_b":"Notes and bonds",
       "choice_c":"Equipment, collateral, and voting trust certificates",
       "choice_d":"None of the choices listed",
       "correct_answer":"B",
       "explanation":"Common stock, preferred stock, warrants, and rights, and most trust certificates are types of corporate issues, not government issues."
    },
    {
       "id":1813,
       "topic_id":3,
       "practice_test_id":"",
       "question":"As it relates to the Uniform Securities Act, which of the following are securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A futures contract on a blue chip stock </li><li>A futures contract on light sweet crude oil </li><li>A put contract on the S & P 500  </li><li>A variable annuity's separate account</li></ol>",
       "choice_a":"III and IV",
       "choice_b":"I and IV",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Options, separate accounts, and individual stock futures are all considered securities. A commodity future is not a security."
    },
    {
       "id":1814,
       "topic_id":3,
       "practice_test_id":"",
       "question":"The following are all types of government issues except:",
       "choice_a":"Treasury bonds, obligations of the US government",
       "choice_b":"Obligations of foreign governments, such as Canadian bonds",
       "choice_c":"Government agency obligations, such as options clearing issues",
       "choice_d":"Obligations of state and local governments",
       "correct_answer":"C",
       "explanation":"Options clearing issues are corporate issues, option contracts on stocks, debt investments, market indices, and foreign currencies; government agency obligations are ones like Freddie Mac, Ginnie Mae, and Fannie Mae."
    },
    {
       "id":1815,
       "topic_id":3,
       "practice_test_id":2,
       "question":"The name of the test used by the Supreme Court to determine a security is:",
       "choice_a":"The Hartly Test",
       "choice_b":"The Third Party Test",
       "choice_c":"The Howey Test",
       "choice_d":"The Hamilton Test",
       "correct_answer":"C",
       "explanation":"The name of the test used by the Supreme Court was the Howey Test."
    },
    {
       "id":1816,
       "topic_id":3,
       "practice_test_id":3,
       "question":"Under USA, which of the following constitute a sale? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A gift of assessable stock </li><li>A pledge of securities for a margin loan </li><li>The contract for the exchange of a security for value </li><li>The hypothecation of a security </li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I and II",
       "choice_d":"I, II, and III",
       "correct_answer":"A",
       "explanation":"Only the gift of assessable stock and the contract to exchange a security are sales under the USA."
    },
    {
       "id":1817,
       "topic_id":3,
       "practice_test_id":4,
       "question":"Which of the following are considered securities?",
       "choice_a":"Insurance policies",
       "choice_b":"Fixed annuities",
       "choice_c":"Retirement plans, such as IRAs and Keogh",
       "choice_d":"None of the choices listed",
       "correct_answer":"D",
       "explanation":"Insurance policies, fixed annuities, retirement plans, and also commodities futures contracts are not considered securities, and are excluded from the definition of a security."
    },
    {
       "id":1818,
       "topic_id":3,
       "practice_test_id":5,
       "question":"Which of the following are not considered securities under the USA?",
       "choice_a":"Interest in real estate, variable contract separate accounts, whiskey warehouse receipts",
       "choice_b":"Retirement plans, fixed contract general accounts, whole life insurance",
       "choice_c":"Pre-organization certificates, assessable stock, rights",
       "choice_d":"Option contracts, individual stock futures, interest in farm animals",
       "correct_answer":"B",
       "explanation":"Retirement plans, fixed contracts and life insurance are not securities."
    },
    {
       "id":1819,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Which of the following does not constitute an offer to sell a security?",
       "choice_a":"Any attempt to purchase or to dispose of a security for value",
       "choice_b":"Stock dividends paid to shareholders",
       "choice_c":"A security given as a bonus in conjunction with the purchase of a security",
       "choice_d":"A gift of an assessable security",
       "correct_answer":"B",
       "explanation":"Stock dividends paid to shareholders are excluded from the definition of a sale or an offer to sell a security."
    },
    {
       "id":1820,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is false?",
       "choice_a":"When no board of directors exists, such as in unit investment trusts, the issuer is the person who assumes the managerial and depository duties",
       "choice_b":"For collateralized securities, such as equipment trust certificates, the issuer is the person to whom the equipment is sold or leased",
       "choice_c":"For interests in mining leases and oil and gas drilling, the issuer is the majority shareholder in the stock",
       "choice_d":"The issuer is the individual, group or organization which issues, or proposes to issue, a security",
       "correct_answer":"C",
       "explanation":"For interests in mining leases and oil and gas drilling, there is not considered to be an issuer at all."
    },
    {
       "id":1821,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is not excluded from the definition of a sale or an offer to sell a security?",
       "choice_a":"Stock dividends paid to shareholders",
       "choice_b":"A gift of non-assessable securities",
       "choice_c":"Security interests of borrowers pledged as collateral for loans",
       "choice_d":"A gift of assessable securities",
       "correct_answer":"D",
       "explanation":"A gift of assessable securities, when the issuer can assess the owner for additional money, is considered a sale of securities."
    },
    {
       "id":1822,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is true relating to the XYZ Company during the issuing of securities?",
       "choice_a":"The company is not a person issuing securities  because a company cannot  be considered one person",
       "choice_b":"The company must hire an underwriter to sell the securities",
       "choice_c":"The company will be considered both an issuer and a person",
       "choice_d":"The company will only be considered an issuer",
       "correct_answer":"C",
       "explanation":"A person is considered to be an individual, a group, or an organization that can enter into a legally binding contract; as such, a person may either trade or issue securities."
    },
    {
       "id":1823,
       "topic_id":3,
       "practice_test_id":1,
       "question":"Which of the following meet the definition of a security?",
       "choice_a":"A Keogh plan",
       "choice_b":"A fixed contract\u0027s general account",
       "choice_c":"A single stock future",
       "choice_d":"A commodity contract",
       "correct_answer":"C",
       "explanation":"Of the choices listed, only a single stock future meets the definition for a security. A single stock future is also the only time that a future is a security when it appears without the word option."
    },
    {
       "id":1824,
       "topic_id":3,
       "practice_test_id":2,
       "question":"Which of the following would best describe the profile of an accredited investor? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  An individual with a minimum net worth of $1,000,000  </li><li> An individual with yearly income in excess of $100,000 for the past three years </li><li>An individual with a minimum net worth of $5,000,000  </li><li> An individual with a yearly income of $200,000 for the past two years </li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"III and IV",
       "correct_answer":"B",
       "explanation":"An accredited investor is defined as an individual with a minimum net worth of $1,000,000 without the house, and a yearly income of $200,000 for the previous two years, with the reasonable expectation of maintaining this yearly income."
    },
    {
       "id":1825,
       "topic_id":3,
       "practice_test_id":3,
       "question":"A new issuer registering through coordination must send the State Securities Administrator:",
       "choice_a":"5 copies of the prospectus",
       "choice_b":"1 copy of the prospectus",
       "choice_c":"2 copies of the prospectus",
       "choice_d":"3 copies of the prospectus",
       "correct_answer":"D",
       "explanation":"An issuer registering their securities under coordination must send 3 copies of the prospectus to the Administrator."
    },
    {
       "id":1826,
       "topic_id":3,
       "practice_test_id":4,
       "question":"The act that requires non exempt issuers of securities to file a registration statement with the SEC is:",
       "choice_a":"The Securities Act of 1933",
       "choice_b":"The Securities Exchange Act of 1934",
       "choice_c":"The Corporate Registration Act of 1936",
       "choice_d":"The Trust Indenture Act of 1939",
       "correct_answer":"A",
       "explanation":"The Securities Act of 1933 requires non exempt issuers to file a registration statement with the SEC."
    },
    {
       "id":1827,
       "topic_id":3,
       "practice_test_id":5,
       "question":"The filing date for a new issue is considered to be:",
       "choice_a":"The date the SEC stamps on the registration statement",
       "choice_b":"The date of post mark",
       "choice_c":"The date on the registration statement",
       "choice_d":"Three days after post mark",
       "correct_answer":"B",
       "explanation":"The filing date is considered to be the date of post mark."
    },
    {
       "id":1828,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Under the Investment Company Act of 1940 which of the following would qualify as a financial contract?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A negotiated agreement to buy a security </li><li>A negotiated agreement to lend a security </li><li>A negotiated agreement to swap a security </li><li>An arrangement to repurchase a security </li></ol>",
       "choice_a":"I only",
       "choice_b":"II and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed would be considered a financial contract under The Investment Company Act of 1940."
    },
    {
       "id":1829,
       "topic_id":3,
       "practice_test_id":"",
       "question":"The federal government has exclusive jurisdiction over the registration of all of the following except:",
       "choice_a":"Investment company securities",
       "choice_b":"Intrastate offerings",
       "choice_c":"Nationally traded securities",
       "choice_d":"Securities listed on a tier of a regional stock exchange",
       "correct_answer":"B",
       "explanation":"The federal government has exclusive jurisdiction over the registration of all of the following except an intrastate offering. An intrastate offering is an offering of securities in only one state."
    },
    {
       "id":1830,
       "topic_id":3,
       "practice_test_id":"",
       "question":"The term \u0022principal shareholder\u0022 means any person who is directly or indirectly the beneficial owner of more than what percent of any class of equity security of an issuer?",
       "choice_a":"5%",
       "choice_b":"10%",
       "choice_c":"25%",
       "choice_d":"20%",
       "correct_answer":"D",
       "explanation":"The term \u0022principal shareholder\u0022 means any person who is directly or indirectly the beneficial owner of more than 20 percent of any class of equity security of an issuer"
    },
    {
       "id":1831,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Upon the effectiveness of its registration statement under the Securities Act of 1933, which of the following are considered to have registered an indefinite amount of securities?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>UIT </li><li>Face amount company </li><li>A shelf registration of debt securities </li><li>Open end investment company </li></ol>",
       "choice_a":"IV only",
       "choice_b":"II and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Upon the effectiveness of its registration statement under the Securities Act of 1933, all of the answers are considered to have registered an indefinite amount of securities except a shelf offering of debt securities."
    },
    {
       "id":1832,
       "topic_id":3,
       "practice_test_id":"",
       "question":"The Uniform Securities Act defines non-issuer transactions as:",
       "choice_a":"Primary transactions",
       "choice_b":"Secondary transactions",
       "choice_c":"Private placements",
       "choice_d":"Isolated transactions",
       "correct_answer":"B",
       "explanation":"The Uniform Securities Act defines non-issuer transactions as secondary or secondary market transactions."
    },
    {
       "id":1833,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following would be considered an issuer transaction? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A secondary distribution by officers of a corporation </li><li>A primary offering by a corporation </li><li>A market maker purchasing an OTC security for its own account </li><li>Buying and selling of listed securities in the secondary market </li></ol>",
       "choice_a":"II only",
       "choice_b":"I and II only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and IV only",
       "correct_answer":"A",
       "explanation":"An issuer transaction is for the benefit of the issuer, whether directly or indirectly. The buying or selling of securities by a market maker in the OTC market, or buying and selling listed securities in the secondary market, would not be an issuer transaction. A primary offering by a corporation (whereby the corporation receives the proceeds of the sale) is an example of an issuer transaction."
    },
    {
       "id":1834,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, to say that a security is exempt means that:",
       "choice_a":"Transactions involving the security are not subject to the antifraud provisions of the Act",
       "choice_b":"An agent who sells the security does not have to be registered with the state",
       "choice_c":"A broker-dealer that underwrites a new issue of the securities does not need to be registered with the state",
       "choice_d":"The security does not need to be registered with the state to be sold there",
       "correct_answer":"D",
       "explanation":"An exempt security is not subject to the registration provisions of the Uniform Securities Act, but is subject to the antifraud provisions of the Act."
    },
    {
       "id":1835,
       "topic_id":3,
       "practice_test_id":2,
       "question":"Which method of registration is not used in all states?",
       "choice_a":"Notification",
       "choice_b":"Coordination",
       "choice_c":"Qualification",
       "choice_d":"Consent",
       "correct_answer":"A",
       "explanation":"Registration by coordination and qualification is recognized by all states. However, not all states allow registration by notification (filing)."
    },
    {
       "id":1836,
       "topic_id":3,
       "practice_test_id":3,
       "question":"When does registration by coordination become effective? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If no stop order is in effect </li><li>At the same time that the SEC registration becomes effective </li><li>If the registration statement has been on file with the Administrator for ten days </li><li>If a statement of the minimum and maximum underwriting discount has been on file for two full business days </li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I, II, and III only",
       "choice_c":"I, II, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"When a security is in registration with the SEC under the Securities Act of 1933, that registration can be \u0022coordinated\u0022 with the Administrator for state registration. A registration under coordination is automatically effective when the federal registration becomes effective, provided that no stop order is in effect, the registration statement has been on file with the Administrator for at least ten days, and a statement of the minimum and maximum proposed offering prices and the maximum underwriting discounts has been on file for two full business days."
    },
    {
       "id":1846,
       "topic_id":3,
       "practice_test_id":4,
       "question":"Which of the following are true of exempt securities under the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Any security exempt under the Uniform Securities Act is also exempt under federal regulations </li><li>Any security exempt under federal regulations is also exempt under the Uniform Securities Act </li><li>If Intrastate rules regarding an exemption are more restrictive than federal rules, then state rules would govern </li><li>Federal regulations always supersede state rules </li></ol>",
       "choice_a":"IV only",
       "choice_b":"I and III only",
       "choice_c":"II and IV only",
       "choice_d":"I, II, and IV only",
       "correct_answer":"A",
       "explanation":"A security can be exempt under federal law but not state law, and vice versa. for example a Rule 147 offering is exempt at the federal but may very well have to register in the state where it is offered. The only answer that is correct is IV"
    },
    {
       "id":1847,
       "topic_id":3,
       "practice_test_id":5,
       "question":"Under the Uniform Securities Act, which of the following is a characteristic needed for commercial paper to be exempt from registration requirements?",
       "choice_a":"Issued in denominations of at least $100,000",
       "choice_b":"Issued by a company whose annual revenues exceed $100,000,000",
       "choice_c":"Issued by a religious, educational, or charitable organization",
       "choice_d":"Rated in one of the three highest rating categories from a recognized rating organization",
       "correct_answer":"D",
       "explanation":"Under the Uniform Securities Act, commercial paper that matures in nine months or less is exempt from registration if the minimum denomination is at least $50,000 and it is rated in one of the three highest rating categories by a recognized rating organization. The type of issuer and the annual revenues of the issuer are not relevant factors."
    },
    {
       "id":1848,
       "topic_id":3,
       "practice_test_id":6,
       "question":"All of the following conditions must be met for a private placement to be exempt under the Uniform Securities Act except:",
       "choice_a":"The securities cannot be offered to more than ten small investors in 12 consecutive months",
       "choice_b":"No payment is made by any subscriber",
       "choice_c":"Subscribers receive unregistered securities",
       "choice_d":"The seller must reasonably believe that all buyers are purchasing for investment purposes only",
       "correct_answer":"B",
       "explanation":"All of the items listed regarding private placements are true except no payment is made by any subscriber. The capital raised by a private placement comes from its subscribers."
    },
    {
       "id":1849,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following securities is not exempt from registration?",
       "choice_a":"Airport authority bonds",
       "choice_b":"Railroad equipment trust certificates",
       "choice_c":"Convertible bonds",
       "choice_d":"Securities issued by religious organizations",
       "correct_answer":"C",
       "explanation":"Convertible bonds are not exempt from registration. All of the other securities listed are exempt from registration under the Uniform Securities Act."
    },
    {
       "id":1850,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is not an exempt security?",
       "choice_a":"A security issued by a Canadian commercial bank",
       "choice_b":"A security issued by a foreign insurance company organized under the laws of the state",
       "choice_c":"A security issued by a foreign bank organized under the laws of the United States",
       "choice_d":"Common stock listed on the American Stock Exchange",
       "correct_answer":"A",
       "explanation":"There is no exemption under the Uniform Securities Act for securities issued by Canadian banks. The exemption is for securities issued or guaranteed by Canada or any of its provinces. Securities issued by banks and insurance companies (whether foreign or domestic) that are organized under the laws of either the state or federal government are considered exempt securities. Any security listed on the New York, American, and regional exchanges approved by the Administrator are also exempt."
    },
    {
       "id":1851,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is not a security?",
       "choice_a":"XYZ common shares",
       "choice_b":"SIA debentures",
       "choice_c":"A variable annuity separate account providing an investor with an option to receive fixed payments for a specified period",
       "choice_d":"A Treasury futures contract",
       "correct_answer":"D",
       "explanation":"Futures contracts are not considered to be securities. A variable annuity separate account is always a security, regardless of the payment options available."
    },
    {
       "id":1852,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An exempt transaction would include <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An unsolicited order in unregistered nonexempt securities </li><li>A trade where the customer acknowledges the risk of the trade </li><li>A transaction between SIA Corp. and its underwriter </li><li>The purchase of an equipment trust certificate </li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"Exempt transactions are defined by the nature or character of the transaction, not the security involved. Unsolicited trades, and trades between issuers and underwriters, are examples of exempt transactions. An equipment trust certificate is a security exempt from registration."
    },
    {
       "id":1853,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following are not considered to be a security?",
       "choice_a":"Whiskey warehouse receipts",
       "choice_b":"Fixed annuity contracts",
       "choice_c":"Preorganization certificates",
       "choice_d":"Option contracts",
       "correct_answer":"B",
       "explanation":"A fixed annuity is a contract between an insurance company and an investor promising to pay a fixed amount at a future date. It is not considered a security. Individuals selling fixed annuities need not be registered as securities agent; however, they would have to be registered as insurance agents with the State Insurance Commission."
    },
    {
       "id":1854,
       "topic_id":3,
       "practice_test_id":2,
       "question":"When a security is sold under an exemption from registration under the Uniform Securities Act, the burden of proof for the exemption is imposed on:",
       "choice_a":"The Administrator",
       "choice_b":"The person claiming the exemption",
       "choice_c":"Any person bringing a lawsuit against the seller",
       "choice_d":"The purchaser",
       "correct_answer":"B",
       "explanation":"The person claiming the exemption must be able to demonstrate that they are entitled to the exemption."
    },
    {
       "id":1855,
       "topic_id":3,
       "practice_test_id":3,
       "question":"The State Securities Administrator has jurisdiction over which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The purchase of options via the Internet by a state resident </li><li>The sale of long-term certificates of deposit by a bank </li><li>The delivery of securities to a customer who is a resident of a particular state </li><li>The offer of securities by an out-of-state broker-dealer to a resident of the state </li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"III and IV",
       "correct_answer":"C",
       "explanation":"State securities administrators have jurisdiction over securities transactions that are directed to their state, originate in their state, or are paid for in their state. The simple delivery of securities to a particular state does not fall under an administrator's jurisdiction, nor do general commercial banking transactions."
    },
    {
       "id":1856,
       "topic_id":3,
       "practice_test_id":4,
       "question":"In a coordinated registration, how long is the statutory cooling-off period?",
       "choice_a":"10 days for federal and state",
       "choice_b":"20 days for federal and state",
       "choice_c":"10 days for federal and 20 days for state",
       "choice_d":"10 days for state and 20 days for federal",
       "correct_answer":"D",
       "explanation":"The statutory cooling-off period is 10 days for state registration and 20 days for federal registration. The cooling-off period may be halted, extended, or shortened by either the SEC or a state securities administrator."
    },
    {
       "id":1857,
       "topic_id":3,
       "practice_test_id":5,
       "question":"Under the Uniform Securities Act, which of the following is a nonexempt transaction?",
       "choice_a":"Selling U.S. federal agency securities to a bank",
       "choice_b":"Selling U.S. Treasury bills to a mutual fund",
       "choice_c":"Selling unregistered nonexempt securities",
       "choice_d":"Selling unregistered exempt securities on an unsolicited basis",
       "correct_answer":"C",
       "explanation":"The only nonexempt transaction would be selling unregistered nonexempt securities. This would actually be a violation of the Uniform Securities Act."
    },
    {
       "id":1858,
       "topic_id":3,
       "practice_test_id":6,
       "question":"According to the Uniform Securities Act, which of the following are considered securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An investment contract </li><li>A unit investment trust </li><li>An IRA account </li><li>A warehouse receipt </li></ol>",
       "choice_a":"II only",
       "choice_b":"I and III only",
       "choice_c":"I, II, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"All of the items listed would be considered a security except an IRA account. An IRA account may contain securities but the account itself is not a security."
    },
    {
       "id":1859,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is an exempt transaction?",
       "choice_a":"Selling a security to an investor in the same state as you",
       "choice_b":"Selling a security to an investor in a neighboring state",
       "choice_c":"A broker dealer buying a security from a client",
       "choice_d":"Selling a security to the trustee of a family trust",
       "correct_answer":"D",
       "explanation":"All transactions with fiduciaries such as a trustee are exempt transactions."
    },
    {
       "id":1860,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A federally covered security is:",
       "choice_a":"Safer than other investments",
       "choice_b":"Exempt from registering with states",
       "choice_c":"Limited to open end investment companies whose shares are sold through a prospectus",
       "choice_d":"Subject to review by the state securities administrator",
       "correct_answer":"B",
       "explanation":"A federally covered security is exempt from state registration."
    },
    {
       "id":1861,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following issuers is required to register their securities with the administrator?",
       "choice_a":"A Canadian Province",
       "choice_b":"An issuer whose securities are sold only to people previously invested in the issuer\u0027s securities",
       "choice_c":"An issuer of open end mutual fund shares",
       "choice_d":"An issuer of common stock listed on the Toronto Stock Exchange",
       "correct_answer":"D",
       "explanation":"The issuer of common stock listed on the Toronto Stock Exchange would have to register the securities with the state administrator"
    },
    {
       "id":1862,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A broker dealer is under investigation by a State Administrator for fraudulent business practices.  The State Administrator has requested that the broker dealer turn over their records and other applicable evidence in the investigation.  What is the scope of the Administrator\u0027s powers?",
       "choice_a":"They have the right to indict the broker dealer",
       "choice_b":"They have the right to subpoena any and all evidence",
       "choice_c":"They have no powers over evidence in the investigation",
       "choice_d":"They must get an insider of the firm being investigated to turn over the evidence, or it would be considered inadmissible.",
       "correct_answer":"B",
       "explanation":"A state administrator conducting an investigation of a broker dealer for suspected fraudulent business practices has the power to subpoena any and all records of the broker dealer to assist in their investigation.  Any broker dealer that ignores a subpoena for this requested information can have their license revoked and face contempt of court charges for failure to comply."
    },
    {
       "id":1863,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A broker dealer is under investigation by a state administrator for fraudulent business practices.  Which of the following statements is considered true of the investigation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investigation must be conducted by the Administrator of the state where the broker dealer has their office  </li><li>Any State Administrator can conduct an investigation into the fraudulent acts, if they have suspected the firm of wrong doing </li><li>The State Administrator can issue a Cease & Desist order over the broker dealer to discontinue the suspected action </li><li>The broker dealer would be immune to any investigation that does not originate in their home state </li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"III only",
       "choice_d":"II only",
       "correct_answer":"A",
       "explanation":"A broker dealer that is under investigation for suspected fraudulent business practices can be investigated by any State Administrator that suspects wrongdoing.  If a Cease and Desist order has been issued against a broker dealer, it will enjoin the broker dealer from continuing with the suspected business practice until the final disposition of the investigation is determined."
    },
    {
       "id":1864,
       "topic_id":4,
       "practice_test_id":1,
       "question":"A broker follows a practice of requiring his clients to purchase a minimum of $10,000 worth of stock with his firm before any customer can receive shares in an Initial Public Offering.  Which of the following statements are considered true of this policy?",
       "choice_a":"The broker is within his scope of authority by having customers invest a minimum amount in their account before receiving IPO shares",
       "choice_b":"The broker can only force a customer to purchase one round lot transaction in their account, before having to offer IPO shares to a client",
       "choice_c":"The broker is guilty of forcing a customer to purchase securities for favored treatment in receiving IPO shares",
       "choice_d":"The broker is guilty of churning a customers\u0027 account",
       "correct_answer":"C",
       "explanation":"Under the Uniform Securities Act, it is a violation for a broker to require that a customer purchase additional securities in order to receive favored treatment in Initial Public Offerings.  This action is tantamount to requiring a customer to pay for favored treatment, which is clearly a violation."
    },
    {
       "id":1884,
       "topic_id":4,
       "practice_test_id":2,
       "question":"An Administrator may cancel a registration if a registered person is:",
       "choice_a":"Discovered to be no longer alive",
       "choice_b":"Found to be alive but mentally incompetent",
       "choice_c":"Cannot be located after a reasonable search",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The Administrator may cancel a registration if a registered person is found to be in any of these circumstances."
    },
    {
       "id":1885,
       "topic_id":4,
       "practice_test_id":3,
       "question":"An Administrator may revoke the exemption from registration from which of the following?",
       "choice_a":"A municipal issuer",
       "choice_b":"A bank",
       "choice_c":"A church",
       "choice_d":"A railroad",
       "correct_answer":"C",
       "explanation":"Of the choices listed, an Administrator may only revoke the exemption of a non-profit organization. An Administrator would do this when the exemption was based on a false claim for the exemption, such as a church claiming to be a non-profit organization but it truly is an organization designed to earn a profit."
    },
    {
       "id":1886,
       "topic_id":4,
       "practice_test_id":4,
       "question":"An Administrator may take action against the registration of an investment adviser in which of the following cases? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The adviser's balance sheet shows assets less than its liabilities </li><li>A shareholder of an advisory corporation with no management responsibilities declares personal bankruptcy </li><li>The adviser is delinquent in meeting it current obligations </li><li>Another state has taken action against the adviser </li></ol>",
       "choice_a":"II and III",
       "choice_b":"I, II and III",
       "choice_c":"III and IV",
       "choice_d":"I, III, and IV",
       "correct_answer":"D",
       "explanation":"An adviser who is insolvent as described in answers I and III may have their registration canceled or revoked. If an adviser has violated the securities laws of another state and is subject to an action in that state, the Administrator may take action against the adviser as well."
    },
    {
       "id":1887,
       "topic_id":4,
       "practice_test_id":5,
       "question":"An advisory client is entitled to all of the following except:",
       "choice_a":"To cancel the contract within five days and receive a return of all fees",
       "choice_b":"To renew or cancel the contract annually",
       "choice_c":"To be advised of any change in the management of the advisory",
       "choice_d":"To recover all losses suffered as a result of the advice received, if such advice was deemed unsuitable",
       "correct_answer":"D",
       "explanation":"While the client is entitled to recover losses from advice that is deemed unsuitable, the client must subtract the amount of income received from the advice from the amount they may recover."
    },
    {
       "id":1888,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An agent has filed for registration within a neighboring state. At the time the agent's registration becomes effective, the State Securities Administrator was aware of the agent's previous disciplinary history. The administrator may do which of the following based on the agent's history?",
       "choice_a":"Take no action, as they were aware of the history at the time the registration was granted",
       "choice_b":"Take action only if the agent commits a violation within the first year",
       "choice_c":"Take action within 30 days",
       "choice_d":"Take action within the first year",
       "correct_answer":"C",
       "explanation":"An administrator may take action against an agent within 30 days after the registration becomes effective  based on the history of an agent, which was known at the time the registration was granted."
    },
    {
       "id":1889,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent has had an order entered against them by the Administrator. The agent wants to appeal the decision. Which of the following is true?",
       "choice_a":"The agent must appeal the order within 30 days to the SEC",
       "choice_b":"The agent must appeal the order within 60 days to the SEC",
       "choice_c":"The agent must appeal the order within 60 days to the court",
       "choice_d":"The agent must appeal the order within 60 days to the FINRA",
       "correct_answer":"C",
       "explanation":"The agent must appeal the order to the court within 60 days of the order."
    },
    {
       "id":1890,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent of a firm has been engaging in fraudulent sales practices. Which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The Administrator may take action against the agent  </li><li>The Administrator may take action against the firm </li><li>The Administrator may revoke the license of the firm  </li><li>The Administrator may only revoke the license of the agent who committed the violation. </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II , and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"An Administrator may take action against both the firm and the agent and may revoke the license of both the firm and the agent for the agent's fraudulent activities."
    },
    {
       "id":1891,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent who fails to respond to the Administrator's request for information may ultimately:",
       "choice_a":"Be found in contempt of court",
       "choice_b":"Be sentenced to up to 3 years in jail",
       "choice_c":"Be sentenced up to 5 years in jail",
       "choice_d":"Be fined up to $100,000",
       "correct_answer":"A",
       "explanation":"An agent who fails to respond to the Administrator's request for information may be found in contempt of court if the Administrator goes to court to compel the agent to produce the information and the agent fails to do so."
    },
    {
       "id":1892,
       "topic_id":4,
       "practice_test_id":2,
       "question":"An individual has applied for a registration with a broker dealer.  The individual had previously traded options on the Chicago Board of Options Exchange and had four outstanding arbitration cases pending against him on disputes with clients.  Which statement is true of his application for registration at a broker dealer?",
       "choice_a":"Under no circumstances can he be registered on another exchange",
       "choice_b":"The Administrator may require the pending arbitration cases to be resolved prior to his registration being approved",
       "choice_c":"The applicant cannot  be registered with FINRA",
       "choice_d":"The applicant must post a fidelity bond to become registered",
       "correct_answer":"B",
       "explanation":"An individual that has previously been employed in the securities industry and has outstanding arbitration cases pending against them may be required by the State Administrator to resolve the outstanding arbitration cases before the application for another registration  would be approved.  If the State Administrator deems the applicant's application as unacceptable, then they could also deny the registration based on the grounds of the arbitration cases."
    },
    {
       "id":1893,
       "topic_id":4,
       "practice_test_id":3,
       "question":"An investment adviser may be denied a registration for which of the following reasons?",
       "choice_a":"The investment adviser is also a broker dealer",
       "choice_b":"The investment adviser\u0027s parent company is also an issuer",
       "choice_c":"The investment adviser\u0027s managing partner has been convicted of felony 11 years ago",
       "choice_d":"The investment adviser had their license denied by another state",
       "correct_answer":"D",
       "explanation":"An investment adviser may have their license denied because it was revoked by another state."
    },
    {
       "id":1894,
       "topic_id":4,
       "practice_test_id":4,
       "question":"An investor is offered to be made whole after suffering a large loss on a sale that was in violation of the Uniform Securities Act. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The offer may be written or verbal </li><li>The offer must include interest equal to the prime rate </li><li>The investor may recover over and above the losses, court costs, and interest </li><li>The investor is required to accept the offer within 30 days </li></ol>",
       "choice_a":"II only",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"IV only",
       "correct_answer":"D",
       "explanation":"Of the choices listed regarding an investor's right of recovery, only IV is correct. An investor must accept an offer of rescission within 30 days. That offer must be in writing and it must contain an offer of interest. There is no requirement that the interest rate equal the prime rate."
    },
    {
       "id":1895,
       "topic_id":4,
       "practice_test_id":5,
       "question":"An investor's recourse will be lost if they do not accept a firm's bona fide offer of rescission in:",
       "choice_a":"15 days",
       "choice_b":"30 days",
       "choice_c":"45 days",
       "choice_d":"60 days",
       "correct_answer":"B",
       "explanation":"An investor has 30 days to accept an offer of rescission."
    },
    {
       "id":1896,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Frank is a broker for a firm that is currently under investigation by the state for fraudulent practices.  The State Administrator wants Frank to testify against the principals of the firm being investigated. Which statements would apply to his testimony? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The State Administrator can subpoena Frank to testify  </li><li>Frank must have a lawyer to represent him before testifying </li><li>The Administrator can offer immunity to Frank to testify  </li><li>Frank is under no obligation to answer the subpoena </li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I,II,III",
       "choice_d":"I and IV",
       "correct_answer":"B",
       "explanation":"Any individual that is employed by a broker dealer that is under investigation by a state administrator can be subpoenaed by the administrator.  The employee would not be required to have legal representation if they have been informed of their legal rights under the fifth amendment.  Failure to answer a subpoena can have serious ramifications for the individual, which could lead to suspension of their license or contempt of court charges filed against them.  The State Administrator can offer immunity to a witness if they deem it is in the best interest of their investigation."
    },
    {
       "id":1897,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If an agent decides to file an appeal of the Administrator's order, it must be done:",
       "choice_a":"Within 10 days",
       "choice_b":"Within 30 days",
       "choice_c":"Within 45 days",
       "choice_d":"Within 60 days",
       "correct_answer":"D",
       "explanation":"An agent must file an appeal with the court within 60 days."
    },
    {
       "id":1898,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Joe Lane has been employed by the Midwest Commodity Exchange for five years.  He was barred from the commodity exchange for illegal and deceptive practices against clients.  He has been out of the securities industry for one year and has now applied for registration as a broker with Titan Securities.  Which of the following statements is considered true of his application?",
       "choice_a":"He does not have to list his previous employment on the commodity exchange",
       "choice_b":"He has been out of the securities industry for one year, and can now work once again in the industry",
       "choice_c":"He was barred only from commodity trading, but would still be permitted to sell equity securities",
       "choice_d":"His application for registration will be denied by the State Administrator",
       "correct_answer":"D",
       "explanation":"Any applicant that has been previously employed in the securities industry and has been subsequently barred from such exchange for illegal and deceptive practices will also be denied a registration with any other exchange.  The State Administrator will deny the applicant's registration for just cause."
    },
    {
       "id":1899,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Karen Thomas has a discretionary account with Titan Securities.  Her broker at Titan Securities enters numerous trades in the account each day without any actual regard to Karen\u0027s investment profile.  The broker is guilty of what if any, prohibited action?",
       "choice_a":"The broker is completely within his authority due to the account being discretionary",
       "choice_b":"The broker is guilty of churning the customer account",
       "choice_c":"The broker is guilty of baseless price predictions",
       "choice_d":"The broker is guilty of omission of material facts",
       "correct_answer":"B",
       "explanation":"In a discretionary account, a broker has trading authority over the account.  The discretionary trades should, however, follow the investment profile of the client.  The broker has clearly not followed any discernable investment strategy, and would be guilty of churning the customer's account for the purpose of generating commission income."
    },
    {
       "id":1900,
       "topic_id":4,
       "practice_test_id":1,
       "question":"Several clients living in Ohio have complained to their State Administrator of a broker dealer\u0027s  business practices in the state of Florida.  The practices of the firm in Florida are clearly fraudulent in action.  Which of the following statements are true of the complaints? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The State Administrator of Ohio must notify the Administrator of Florida to initiate an investigation  </li><li>The State Administrator of Ohio has no investigative powers over a firm in another state </li><li>The State Administrator of Florida must conduct the investigation  </li><li>The State Administrator of Ohio can initiate their own investigation </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II only",
       "choice_c":"I and III",
       "choice_d":"IV only",
       "correct_answer":"D",
       "explanation":"A State Administrator that suspects fraudulent business practices being conducted by a broker dealer either in their own state or interstate, are within their scope of power to initiate an investigation into the suspected prohibited actions.  The investigative powers of each State Administrator can carry across state lines if fraud is suspected."
    },
    {
       "id":1901,
       "topic_id":4,
       "practice_test_id":2,
       "question":"Several clients of a broker dealer have contacted the State Administrator with complaints over established business practices at the firm.  The State Administrator is permitted to conduct which of the following actions regarding the complaints?",
       "choice_a":"The State Administrator can only investigate the firm if they have absolute proof",
       "choice_b":"The State Administrator would forward the complaints against the broker dealer to the Securities & Exchange Commission",
       "choice_c":"The State Administrator can commence an investigation into the suspected business practices of the firm",
       "choice_d":"The State Administrator would require that the clients first try to resolve the complaints with the broker dealer, before moving forward with an investigation.",
       "correct_answer":"C",
       "explanation":"A State Administrator that has received customer complaints against a broker dealer and suspects fraud at the broker dealer can initiate an investigation based on their suspicion.  There is no requirement to have absolute proof of wrong doing by the Administrator to initiate an investigation, either in their state or interstate."
    },
    {
       "id":1902,
       "topic_id":4,
       "practice_test_id":3,
       "question":"Which of the following would be the maximum penalty in a criminal court for a violation of the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The individual would be subject to unlimited jail time  </li><li>An unlimited fine  </li><li>A fine of up to $5,000  </li><li> A prison sentence of up to three years </li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I and III",
       "choice_d":"III and IV",
       "correct_answer":"D",
       "explanation":"The maximum penalty is a $5,000 fine and a three year jail term for criminal violations of the USA."
    },
    {
       "id":1903,
       "topic_id":4,
       "practice_test_id":4,
       "question":"The only true statement regarding a stop order that has been issued by a State Administrator is which of the following choices?",
       "choice_a":"A Stop Order is strictly used in the case of fraud",
       "choice_b":"A Stop Order can only be issued during the cooling off period for the security",
       "choice_c":"A Stop Order can be issued within 30 days of the SEC effective date",
       "choice_d":"A Stop Order cannot be appealed by the issuing company",
       "correct_answer":"C",
       "explanation":"The only true statement is that a Stop Order that has been entered by a State Administrator must be entered within 30 days of the Securities & Exchange Commission awarding of the Effective Date for the new issue."
    },
    {
       "id":1904,
       "topic_id":4,
       "practice_test_id":5,
       "question":"The party responsible for enforcing the Uniform Securities Act within a state may be all of the following except:",
       "choice_a":"The Administrator",
       "choice_b":"Attorney General",
       "choice_c":"Any party appointed by the Governor",
       "choice_d":"SEC Commissioner",
       "correct_answer":"D",
       "explanation":"All of the parties listed could enforce the USA within a state except an SEC Commissioner. An SEC commissioner is a federal regulator."
    },
    {
       "id":1905,
       "topic_id":4,
       "practice_test_id":6,
       "question":"The purpose of the USA is all of the following except:",
       "choice_a":"To require minimum standards for State Administrators",
       "choice_b":"To set model legislation for all states to follow",
       "choice_c":"To ensure that all states have the exact same securities laws so that issuers can register their securities easily",
       "choice_d":"To ensure that Administrators can effectively enforce the provisions of the USA in their own state",
       "correct_answer":"C",
       "explanation":"The USA is designed to provide model legislation for the states, which allows the states to adopt their own rules as needed."
    },
    {
       "id":1906,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The State Securities Administrator is required to enforce all of the following except:",
       "choice_a":"Anti-fraud provisions of the USA",
       "choice_b":"State securities regulations",
       "choice_c":"Fraud provisions of the USA",
       "choice_d":"State registration requirements",
       "correct_answer":"C",
       "explanation":"The State Securities Administrator enforces the anti-fraud provisions of the USA, not the fraud provisions."
    },
    {
       "id":1907,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The State Securities Administrator may: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Rule that investment advisers within their jurisdiction may not have custody of funds </li><li>Require that investment advisers file sales literature </li><li>Require that securities sold within their borders are sold on a state approved subscription form </li><li>Inspect broker dealers outside of their state without notice. </li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"The State Securities Administrator has a broad range of power and may do everything listed."
    },
    {
       "id":1908,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The statute of limitations for taking action against a firm at the state level is:",
       "choice_a":"6 years",
       "choice_b":"2 years",
       "choice_c":"2 years from discovery or 3 years from the triggering event, which ever occurs first",
       "choice_d":"3 years from discovery or 6 years from the triggering event, which ever occurs first",
       "correct_answer":"C",
       "explanation":"The statute of limitation at the state level is two years from discovery or three years from the triggering event which ever occurs first."
    },
    {
       "id":1909,
       "topic_id":4,
       "practice_test_id":2,
       "question":"To maintain registration, the Administrator may require:",
       "choice_a":"All sales literature and advertising distributed to the public be filed prior to use",
       "choice_b":"All accounting records and financial records, as well as customer account files, order tickets, and correspondence be kept on file for at least three years",
       "choice_c":"An Investment Advisory Brochure be provided to prospective clients 48 hours before entering into an advisory contract",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The Administrator, in order for a professional to maintain registration, may require all of the above."
    },
    {
       "id":1910,
       "topic_id":4,
       "practice_test_id":3,
       "question":"Under The Act who can issue an injunction? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The Administrator </li><li>The court </li><li>FINRA </li><li>The District Attorney </li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I, II, III, IV",
       "choice_d":"II only",
       "correct_answer":"D",
       "explanation":"Only a court can enter an injunction."
    },
    {
       "id":1911,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Under the Uniform Securities Act, it is illegal to willfully omit material facts about a security to a customer when soliciting client business.  Which of the following actions would constitute omission of material facts? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Failure to notify a customer of negative news about a company  </li><li>Failure to notify a customer of an impending lawsuit about a company  </li><li>Failure to notify a customer about an officer of the firm that has been indicted for fraud  </li><li>Failure to notify a customer about the Chief Executive officer announcing his resignation from the firm </li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I, II, III",
       "choice_d":"I, II ,III, IV",
       "correct_answer":"D",
       "explanation":"All of the listed actions would constitute the omission of material facts to a customer when soliciting client business.  Negative news about a company, a pending lawsuit, criminal action against an officer of a firm, and a resignation of a key senior officer, would all be considered acts that a client should be informed of prior to the solicitation of business."
    },
    {
       "id":1912,
       "topic_id":4,
       "practice_test_id":5,
       "question":"Which of the following actions by a broker dealer is prohibited under the Uniform Securities Act regarding customer accounts?",
       "choice_a":"Allowing a client to trade in a margin account without signing the margin agreement within 15 days",
       "choice_b":"Allowing a client to trade in an option account without signing the option agreement within 15 days",
       "choice_c":"Signing a customer\u0027s signature with their verbal approval for a trading authorization in a discretionary account",
       "choice_d":"Allowing a customer to open an account with no name, and only a number designating the account.",
       "correct_answer":"C",
       "explanation":"Under the Uniform Securities Act, it is strictly prohibited for a broker to sign a customer signature to any account documentation, regardless if the customer has given their verbal approval to the broker to do so.  Under no circumstances can a broker sign a customer signature to any document pertaining to the account."
    },
    {
       "id":1913,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Which of the following actions would constitute a criminal action as opposed to a civil action against a broker under the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The broker has willfully intended to defraud his customers  </li><li>The broker has violated a prohibited action under the Uniform Securities Act </li><li>The broker has unintentionally defrauded a customer  </li><li>The broker has not violated a prohibited action under the Uniform Securities Act </li></ol>",
       "choice_a":"I Only",
       "choice_b":"I and II",
       "choice_c":"II and III",
       "choice_d":"III and IV",
       "correct_answer":"A",
       "explanation":"The only action listed that would initiate a criminal investigation by a State Administrator would be the intentional act of fraud by the broker.  The line between criminal and civil in scope is determined under the Uniform Act as the willful and intentional act of fraud being perpetuated by the broker dealer or agent."
    },
    {
       "id":1914,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are true regarding an Administrator's hearing? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is usually a public hearing  </li><li>It can be held in private </li><li>The Administrator can have witnesses testify under oath </li><li>The Administrator may compel testimony </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"The hearings are usually public but may be held in private and the Administrator can have witnesses testify under oath and can compel testimony."
    },
    {
       "id":1915,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is not subject to the USA?",
       "choice_a":"Any of the 50 states",
       "choice_b":"Any territory or possession of the United States",
       "choice_c":"The District of Columbia",
       "choice_d":"All of the choices are subject to the USA",
       "correct_answer":"D",
       "explanation":"All of the 50 states, territories, possessions and the Commonwealth of Puerto Rico, and the District of Columbia are subject to the USA."
    },
    {
       "id":1916,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Who is responsible for administering the Uniform Securities Act within a state?",
       "choice_a":"Anyone designated by the Governor",
       "choice_b":"The SEC",
       "choice_c":"The State Supreme Court",
       "choice_d":"The District Attorney",
       "correct_answer":"A",
       "explanation":"Anyone designated by the Governor is responsible for the administration of The USA within the state. It will usually be someone appointed to the position of State Securities Administrator."
    },
    {
       "id":1917,
       "topic_id":4,
       "practice_test_id":1,
       "question":"The State Securities Administrator may do which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Arrest violators of state securities laws </li><li>Issue a Cease and Desist order </li><li>Force compliance with an order </li><li>Revoke an exemption from registration </li></ol>",
       "choice_a":"II and III",
       "choice_b":"I, II and IV",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"A  State Securities Administrator may not arrest violators or enforce compliance with an order."
    },
    {
       "id":1918,
       "topic_id":4,
       "practice_test_id":2,
       "question":"The State Securities Administrator may require a federally covered adviser with an office in its state to: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>File all forms that are filed with the SEC  </li><li>File a consent to service of process </li><li>Register with the administrator's office </li><li>Pay a fee </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"IV only",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"The state Securities Administrator may require a federally covered adviser within its home state to do all of the choices listed except register."
    },
    {
       "id":1919,
       "topic_id":4,
       "practice_test_id":3,
       "question":"A state may not establish requirements for broker dealers that are in addition to the federal regulations in which of the following areas? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Custody </li><li>Margin </li><li>Books and records </li><li>Bonding </li></ol>",
       "choice_a":"I only",
       "choice_b":"II and IV",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"A state may not establish requirements for broker dealers that are in addition to the federal regulations in any of the areas listed."
    },
    {
       "id":1920,
       "topic_id":4,
       "practice_test_id":4,
       "question":"As it relates to the State Securities Administrator's authority over federally covered securities, which of the following are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>No filing may be required with respect to any federally covered security </li><li>The filing of any documents filed with the commission maybe filed for notice purposes  </li><li>The State Securities Administrator may require the issuer to submit certain fees </li><li>The administrator may suspend the offer or sale of securities within a state as a result of the failure to submit any filing or fee required under law </li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the answers listed are correct. A state may not \u0022require\u0022 a federally covered security to make additional filings but may have any filing made with the SEC sent to them for notification only."
    },
    {
       "id":1921,
       "topic_id":4,
       "practice_test_id":5,
       "question":"Which of the following would be a violation of the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Buying and selling the same stock on the same day on different exchanges </li><li> Offering shares of an unregistered nonexempt security to exactly 14 clients </li><li> Offering a Canadian Government bond to a resident of a state in which the agent is not registered</li></ol>",
       "choice_a":"II only",
       "choice_b":"I and II only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"C",
       "explanation":"It is a violation of the Act to offer unregistered nonexempt securities to one client, let alone fourteen. Also, the sale of exempt securities in a state does not exempt the agent from being registered in that state."
    },
    {
       "id":1922,
       "topic_id":4,
       "practice_test_id":6,
       "question":"A Broker-Dealer is currently registered in the state of Florida. If the Administrator believes that the Broker Dealer has or is about to violate some provision of the Uniform Securities Act, the Administrator may, if in the public interest, do all of the following except:",
       "choice_a":"Petition a court to issue an injunction to prevent the Broker Dealer from violating the Act",
       "choice_b":"Issue a cease and desist order directing the Broker Dealer to stop violations of the Act",
       "choice_c":"Fine the Broker Dealer for activities that violate the Act",
       "choice_d":"Suspend the Broker Dealer\u0027s broker-dealer registration",
       "correct_answer":"C",
       "explanation":"The Uniform Securities Act does not empower the Administrator to levy fines. The Administrator would have to request that the district attorney initiate criminal legal action against the broker-dealer, which could result in a fine by the court."
    },
    {
       "id":1923,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, the Administrator may not do which of the following?",
       "choice_a":"Conduct investigations involving broker-dealers domiciled in other states",
       "choice_b":"Conduct an investigation without proof of wrongdoing",
       "choice_c":"Suspend an agent\u0027s registration without an opportunity for a hearing",
       "choice_d":"Issue subpoenas to individuals outside the state",
       "correct_answer":"C",
       "explanation":"An Administrator must give a reason for revoking or suspending an agent's license. Although an Administrator may suspend a license prior to a hearing, the opportunity for a hearing must then be provided. The Administrator is allowed to serve subpoenas and conduct investigations, both in and out of state."
    },
    {
       "id":1924,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If an agent sells a security in violation of a state registration provision, his or her client must take action for recovery within three years of occurrence of the violation, or within two years of discovery of the violation, whichever comes first. Which of the following persons would not be considered an agent under the act?",
       "choice_a":"A person representing a broker-dealer in non-exempt transactions",
       "choice_b":"A person representing a director of an issuer who does not receive commissions",
       "choice_c":"A person representing a director of an issuer who receives commissions",
       "choice_d":"A person employed by a broker-dealer as a sales assistant who occasionally accepts client orders",
       "correct_answer":"B",
       "explanation":"A person who represents a broker-dealer is defined as an agent even if they are selling exempt securities. A person representing an issuer executing transactions with an existing employee, partner, officer or director of an issuer who does not receive any commissions or other payment directly or indirectly for soliciting the order in that state will not be considered an agent. An employee of a broker-dealer who performs only clerical functions is not considered an agent. However, if that employee accepts client orders (even unsolicited) then that person is classified as an agent and must register."
    },
    {
       "id":1925,
       "topic_id":4,
       "practice_test_id":"",
       "question":"After examining the offices of a broker-dealer, the Administrator sanctioned the firm for keeping stock owned by customers and stock owned by the broker-dealer together in a way that did not clearly indicate who owned which shares. This prohibited practice is called:",
       "choice_a":"Re-Hypothecation",
       "choice_b":"Mixing",
       "choice_c":"Commingling",
       "choice_d":"Conversion",
       "correct_answer":"C",
       "explanation":"Commingling refers to the practice of intermixing securities belonging to customers with securities belonging to the broker-dealer. This is prohibited in order to assure that customer securities are not misused."
    },
    {
       "id":1926,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following could not be used by the Administrator as grounds for denying the registration of a security?",
       "choice_a":"It is in the public interest of the state",
       "choice_b":"The offering is being made based upon terms that are unfair",
       "choice_c":"The weak financial condition of the issuer",
       "choice_d":"Prior willful violation of the act by the corporate officers",
       "correct_answer":"C",
       "explanation":"The Administrator cannot use the weak financial condition of an issuer as the only reason to deny a registration application. All of the other items listed above may be used by the Administrator as legitimate grounds for denial of registration of securities."
    },
    {
       "id":1927,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following statements is true concerning the posting of bonds by a broker-dealer?",
       "choice_a":"The bond may be waived if the broker-dealer has been in business for at least ten years",
       "choice_b":"There is no bond requirement if the broker-dealer does not have custody or discretionary authority",
       "choice_c":"The Administrator may not waive the bond requirement for any broker-dealer",
       "choice_d":"There is no bond requirement if the broker-dealer is registered in another state",
       "correct_answer":"B",
       "explanation":"The Administrator may require broker-dealers to post bonds if they have custody of or discretionary authority over client funds or securities. The bond may be waived if the broker-dealer's net capital exceeds a specified amount. The Administrator may determine this amount."
    },
    {
       "id":1928,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The amount of the bond that a broker-dealer is required to post is:",
       "choice_a":"Determined by the Administrator",
       "choice_b":"Based on the number of employees the firm has",
       "choice_c":"Related to prior disciplinary action",
       "choice_d":"Waived if the filing fee is prepaid",
       "correct_answer":"A",
       "explanation":"The Administrator determines the amount of the bond that a broker-dealer must post. The Administrator is allowed to waive the bond requirement if the broker-dealer has a minimum amount of net capital, which is also determined by the Administrator."
    },
    {
       "id":1929,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Under the Uniform Securities Act, which of the following is correct regarding a State Administrator's investigative powers?",
       "choice_a":"The Administrator may initiate an investigation only when he or she feels a violation has occurred",
       "choice_b":"The Administrator may initiate an investigation only if the person investigated is registered in the Administrator\u0027s state",
       "choice_c":"The Administrator may initiate an investigation anytime it appears a violation is about to occur",
       "choice_d":"The Administrator may initiate an investigation only if a complaint has been filed by a client",
       "correct_answer":"C",
       "explanation":"The Administrator may initiate an investigation if it appears that a violation of the Uniform Securities Act is about to occur. The Administrator need not wait for a violation to occur before starting an investigation."
    },
    {
       "id":1930,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following does not constitute grounds for denial, suspension, or revocation of a registration statement under the Uniform Securities Act?",
       "choice_a":"The issuer is engaged in an illegal enterprise",
       "choice_b":"The security is not registered with the SEC",
       "choice_c":"The applicant has failed to pay the proper filing fee",
       "choice_d":"The offering has been or would be made with unreasonable amounts of compensation",
       "correct_answer":"B",
       "explanation":"An Administrator may deny the registration of a security if the issuer is engaged in an enterprise that is illegal where performed (gambling and prostitution are illegal in the majority of states), if the registrant has failed to pay the proper filing fee, or if there is unreasonable underwriting compensation. The order to deny registration for failure to pay the proper filing fee can be reversed when the fee is paid. Securities that are not registered at the federal level could be either registered or exempt at the state level."
    },
    {
       "id":1931,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, in the absence of fraud, when must action be taken for recovery on a transaction made in violation of a state registration provision?",
       "choice_a":"Within two years of occurrence",
       "choice_b":"Within two years of discovery",
       "choice_c":"Within three years of occurrence and two years of discovery, whichever comes first",
       "choice_d":"Within two years of occurrence or discovery, whichever occurs last",
       "correct_answer":"C",
       "explanation":"If an agent sells a security in violation of a state registration provision, his or her client must take action for recovery within three years of occurrence of the violation, or within two years of discovery of the violation, whichever comes first."
    },
    {
       "id":1932,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The Administrator has the authority to make an on-site inspection of a broker-dealer or an investment adviser:",
       "choice_a":"At a time convenient for the broker-dealer or investment adviser",
       "choice_b":"At a time determined by the Administrator",
       "choice_c":"On a quarterly basis",
       "choice_d":"On a semiannual basis",
       "correct_answer":"B",
       "explanation":"The Administrator determines when to review the records and practices of an investment adviser or a broker-dealer; there is no set schedule."
    },
    {
       "id":1933,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Under the Uniform Securities Act, which of the following documents are customarily forwarded to the Administrator?",
       "choice_a":"Customer complaints",
       "choice_b":"Securities registration statements",
       "choice_c":"Municipal securities advertising",
       "choice_d":"Investment advisory contracts",
       "correct_answer":"B",
       "explanation":"Of the items listed, only securities registration statements are regularly forwarded to the Administrator. Registration by Coordination and Qualification require that a registration statement and prospectus be filed with the Administrator."
    },
    {
       "id":1934,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The Administrator has the right to deny, revoke or suspend the registration statement of an issuer of securities. Under the Uniform Securities Act, which of the following issuers is subject to this action? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Stock listed on a Canadian Exchange </li><li>Federal Savings and Loan Associations </li><li>Federal credit unions </li><li>For-profit corporations </li></ol>",
       "choice_a":"I and IV only",
       "choice_b":"II and III only",
       "choice_c":"II, III, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"Choice II and III are exempt securities and would not be required to file a registration statement. Nonexempt securities would be subject to this rule."
    },
    {
       "id":1935,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is considered a fraudulent act?",
       "choice_a":"Making a delinquent filing to the Administrator",
       "choice_b":"Purposely omitting a fact that a reasonable person would need to make an informed investment decision",
       "choice_c":"Renewing an investment advisory contract when performance has been poor",
       "choice_d":"Telling a client that money market mutual funds sold by a bank are not FD1C insured",
       "correct_answer":"B",
       "explanation":"Withholding material facts is considered fraudulent. Material facts are those that a reasonable person would want to know in order to make an informed investment decision."
    },
    {
       "id":1936,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Pete has a large position in VBNM Corporation common stock. The stock is low-priced and lightly traded. Pete has given money to several other investors and directed them to purchase the stock at specific times. As the investors make their purchases, the stock begins to rise and Pete sells his position at a profit. Which of the following is true?",
       "choice_a":"This is a form of churning but is improper only if Peter is an employee of a broker-dealer",
       "choice_b":"This is an acceptable practice since the increase in the price of the security was due to demand for the stock",
       "choice_c":"The coordinated purchases are a form of market manipulation and violate the Uniform Securities Act",
       "choice_d":"This activity is called arbitrage and is proper if conducted during normal market hours",
       "correct_answer":"C",
       "explanation":"The coordinated purchases were designed solely to manipulate the price of the stock and are a violation of the antifraud section of the USA."
    },
    {
       "id":1937,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are true regarding the preparation and maintenance of records by investment advisers and broker-dealers except:",
       "choice_a":"The Administrator may determine that the records prepared by investment advisers and broker-dealers may be different",
       "choice_b":"All records must be preserved for a period determined by the Administrator",
       "choice_c":"Correcting amendments must be filed promptly if information in a document previously filed becomes inaccurate",
       "choice_d":"Only an Administrator within the same state may examine the records of an investment adviser or broker-dealer",
       "correct_answer":"D",
       "explanation":"An Administrator may inspect the records of a broker-dealer or investment adviser located within or outside the state. All of the other statements regarding recordkeeping are correct."
    },
    {
       "id":1938,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Pursuant to the Uniform Securities Act, when do the licenses of broker-dealers, agents, and investment advisers expire?",
       "choice_a":"On the fiscal year-end of the state government",
       "choice_b":"On the fiscal year-end of the broker-dealer, agent, or investment adviser",
       "choice_c":"On December 31 each year",
       "choice_d":"Three years from the original registration",
       "correct_answer":"C",
       "explanation":"Under the Uniform Securities Act, licenses expire at the end of each calendar year."
    },
    {
       "id":1939,
       "topic_id":4,
       "practice_test_id":6,
       "question":"A state securities administrator has decided that a broker-dealer is in danger of becoming insolvent. The administrator orders the broker-dealer to maintain a minimum net capital of twice that of the federal minimum. How would this be viewed under NSMIA?",
       "choice_a":"Administrators are not allowed to set net capital requirements for broker-dealers",
       "choice_b":"Administrators are not allowed to impose requirements that are more stringent than SEC regulations",
       "choice_c":"Administrators are free to set whatever requirements they feel are necessary to maintain fair and equitable markets within their own state",
       "choice_d":"The broker-dealer must first be offered a hearing on the matter",
       "correct_answer":"B",
       "explanation":"Under NSMIA, state securities administrators are not allowed to impose requirements that are more stringent than SEC regulations."
    },
    {
       "id":1940,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An Administrator from North Carolina has jurisdiction over an offer made: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>On a radio or television program that originated in North Carolina </li><li>On a radio or television program broadcast in a North Carolina where the communication originated outside the state </li><li>In a newspaper circulated in North Carolina, but published in South Carolina </li><li>In a newspaper published in North Carolina, but with more than two thirds of its circulation outside the state in the last year </li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II only",
       "choice_c":"I and III only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"Generally, an Administrator will have jurisdiction over any offer if it originated in that state, was directed in that state, or was accepted in the Administrator's state. However, if the communication originated outside the North Carolina and was in the form of a radio or television broadcast, the Administrator would not have jurisdiction. The Administrator has jurisdiction if the newspaper is published in that North Carolina and more than one-third of the circulation is inside that state."
    },
    {
       "id":1941,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent unknowingly violates a provision of the Uniform Securities Act. Which of the following statements is correct?",
       "choice_a":"The minimum sanction called for is a suspension of the agent\u0027s registration",
       "choice_b":"Criminal penalties are called for if client losses exceed $5,000",
       "choice_c":"No prison sentence can be imposed if the agent had no prior knowledge of the rule or order",
       "choice_d":"After passing the Series 63, agents cannot claim they unknowingly violated a provision of the Act",
       "correct_answer":"C",
       "explanation":"Criminal liabilities exist for violations of the Uniform Securities Act. If the agent had no prior knowledge of the rule or order then a prison sentence cannot be imposed. Clients do not have to demonstrate that they were harmed and suffered damages. The state brings the criminal charges."
    },
    {
       "id":1942,
       "topic_id":4,
       "practice_test_id":1,
       "question":"Which of the following securities are not exempt from the antifraud provisions of the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>U.S. government securities </li><li>Securities issued by a for-profit corporation listed on a U.S. Exchange </li><li>Debt issued by a manufacturing company</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"Although U.S. government and listed securities are not required to be registered under the Uniform Securities Act, they are not exempt from the antifraud provisions of the Uniform Securities Act. All securities are subject to the antifraud provisions."
    },
    {
       "id":1943,
       "topic_id":4,
       "practice_test_id":2,
       "question":"The administrator can investigate an agent applying for registration for which two of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A misdemeanor DUI </li><li>A misdemeanor involving securities </li><li>Citizenship </li><li>Late payments to a credit card or automobile installment account </li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and III",
       "choice_c":"II and IV",
       "choice_d":"I and IV",
       "correct_answer":"A",
       "explanation":"A state securities administrator may investigate an agent applying for registration if they have been involved in a securities related misdemeanor and to determine the agent's citizenship."
    },
    {
       "id":1944,
       "topic_id":4,
       "practice_test_id":3,
       "question":"An administrator believes an agent will be selling an unregistered non exempt security.  They can:",
       "choice_a":"Ask for an injunction in court",
       "choice_b":"Suspend the agent immediately",
       "choice_c":"Do nothing until they act",
       "choice_d":"Censure the agent",
       "correct_answer":"A",
       "explanation":"An administrator may issue a cease and desist order or may seek an injunction in court prior to a violation occurring in an effort to prevent the violation from occurring."
    },
    {
       "id":1945,
       "topic_id":4,
       "practice_test_id":4,
       "question":"If the net capital of an adviser dips below the level that is required:",
       "choice_a":"An administrator can act only if they are registered in their state",
       "choice_b":"An administrator can act only if they are registered in their state and the SEC acts first",
       "choice_c":"An administrator can act only if they are registered in their state and FINRA acts first",
       "choice_d":"An administrator can act only if they are registered in their state and the adviser has custody of clients\u0027 cash and securities",
       "correct_answer":"A",
       "explanation":"If an adviser becomes insolvent the administrator can act and cancel the adviser's registration if the firm (adviser) is registered in their state."
    },
    {
       "id":1946,
       "topic_id":4,
       "practice_test_id":5,
       "question":"Which of the following are rights of a state Administrator? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Collect evidence </li><li>Administer oaths </li><li>Subpoena </li><li>Execute a search warrant </li></ol>",
       "choice_a":"I and II",
       "choice_b":"III only",
       "choice_c":"I, II and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"An administrator may do all of the items listed except execute a search warrant."
    },
    {
       "id":1947,
       "topic_id":4,
       "practice_test_id":6,
       "question":"What document sent to the general public can the administrator require to be filed?",
       "choice_a":"Advertisements",
       "choice_b":"Company Logo",
       "choice_c":"Emails",
       "choice_d":"Memos",
       "correct_answer":"A",
       "explanation":"The state securities administrator may require advertisements to be filed with their office."
    },
    {
       "id":1948,
       "topic_id":4,
       "practice_test_id":"",
       "question":"What is true about criminal liability for someone who sells unregistered non exempt securities to state residents?",
       "choice_a":"They are only liable if they knew they were unregistered",
       "choice_b":"They are only liable if they are registered as an agent",
       "choice_c":"They are always liable as long as they intentionally and knowingly sold the unregistered securities",
       "choice_d":"They are only liable if the customers suffered losses",
       "correct_answer":"C",
       "explanation":"Any person (even if not registered as an agent) who intentionally and knowingly sells unregistered non exempt securities may be held criminally liable regardless of any losses."
    }
  ]